export default {
  agents: {
    addAgent: 'Dodaj agenta',
    addAgentErrorText: 'Wystąpił błąd podczas dodawania agenta',
    addAgentSuccessText: 'Pomyślnie dodano nowego agenta',
    addAgentSuccessTitle: 'Dodano agenta',
    addNewAgent: 'Dodaj nowego agenta',
    agentsLabel: 'Agenci',
    agentsList: 'Lista agentów',
    agentsSearchPlaceholder: 'Wyszukaj agenta po nazwie',
    assignedCustomers: 'Lista przypisanych klientów',
    commission: 'Prowizja',
    commissions: {
      comissionStatus: {
        PAID: 'Wypłacona',
        TO_PAY: 'Do wypłacenia'
      },
      commission: 'Prowizja',
      commissionStatusOption: 'Status prowizji?',
      errorWhenPayOut: 'Wystapił błąd podczas tworzenia wypłaty',
      invoiceExists: 'Czy jest FV?',
      noCommissionsToDisplay: 'Brak prowizji do wyświetlenia',
      orderDate: 'Data zamówienia',
      orderName: 'Nazwa zamówienia',
      orderStatus: 'Status zamówienia',
      paymentStatus: 'Status płatności',
      payOut: 'Wypłać zaznaczone',
      settlementNumber: 'Numer rozliczenia',
      settlementStatus: {
        PAID: 'Opłacona',
        UNPAID: 'Nieopłacona'
      },
      settlementStatusOption: 'Status rozliczenia?'
    },
    commissionsList: 'Lista prowizji',
    deleteConfirmTitle: 'Czy na pewno chcesz usunąć wybranego agenta?',
    deleteErrorText: 'Operacja usuwania agenta nie powiodła się',
    deleteSuccessText: 'Pomyślnie usunięto wybranego agenta',
    deleteSuccessTitle: 'Usunięto agenta',
    editAgent: 'Edytuj agenta',
    editAgentErrorText: 'Modyfikacja agenta nie powiodła się',
    editAgentSuccessText: 'Pomyślnie zmodyfikowano agenta',
    editAgentSuccessTitle: 'Zmodyfikowano agenta',
    noAgentsMatchingPhraseFound: 'Brak agentów pasujących do podanej frazy',
    noAgentsToDisplay: 'Brak agentów do wyświetlenia',
    reportEmail: 'Email do wysyłki raportów',
    selectAgent: 'Wybierz agenta',
    sendReport: 'Wysyłaj raporty',
    settlements: {
      currency: 'Waluta',
      date: 'Data zlecenia wypłaty',
      deleteConfirmTitle: 'Czy na pewno chcesz cofnąć tę wypłatę?',
      deleteErrorText: 'Nie udało się cofnąć wypłaty',
      deleteSuccessText: 'Wybrana wypłata została cofnięta',
      deleteSuccessTitle: 'Cofnięto wypłatę',
      export: 'Eksportuj',
      invoicesList: 'Lista uwzględnionych faktur',
      noSettlementsToDisplay: 'Brak wypłat do wyświetlenia',
      ordersList: 'Lista opłaconych zamówień',
      quote: 'Kwota '
    },
    settlementsHistory: 'Historia wypłat',
    thisTabWillBeAvailableAfterSavingAgent: 'Ta zakładka będzie dostępna po zapisaniu agenta...'
  },
  attachment: {
    addAttachemnt: 'Dodaj załącznik',
    attachemnts: 'Załączniki',
    chooseFileToAttachOptional: 'Wybierz plik do dołączenia (opcjonalne)',
    downloadAttachment: 'Pobierz załącznik',
    filesToAttach: 'Pliki do dołączenia',
    fileToAttach: 'Plik do dołączenia',
    noAttachment: 'Brak załącznika',
    removeAttachement: 'Usuń załącznik',
    selectFileWithAttachmentOptional: 'Wybierz plik z załącznikiem (opcjonalne)'
  },
  calendar: {
    chooseDayToShowOrders: 'Wybierz dzień aby pokazać zlecenia',
    chooseSecondDay: 'Wybierz drugi dzień',
    howManyItemsMove: 'Ile sztuk przenieść?',
    moveOrder: 'Przenieś zamówienie',
    moveOrderErrorText: 'Aktualizacja zlecenia nie powiodła się. Spróbuj ponownie.',
    moveOrderPartSuccessTitle: 'Przeniesiono część zlecenia',
    moveOrderSuccessText: 'Wybrane zlecenie zostało zaktualizowane',
    moveOrderSuccessTitle: 'Przeniesiono zlecenie',
    needToSelectDifferentDates: 'Należy wybrać różne daty dla obu dni!',
    noOrders: 'Brak zleceń',
    noPlannedOrders: 'Brak zaplanowanych zleceń',
    orderChangeUnsuccessful: 'Zmiana kolejności nie powiodła się. Spróbuj ponownie.',
    orderUpdateUnsuccessful: 'Aktualizacja zlecenia nie powiodła się. Spróbuj ponownie.',
    planned: 'Zaplanowano',
    showCurrentWeek: 'Pokaż obecny tydzień',
    showToday: 'Pokaż dzisiaj',
    today: 'Dzisiaj',
    toWhatDay: 'Na jaki dzień?'
  },
  complaints: {
    addNewComplaint: 'Dodaj nową reklamację',
    complainedElements: 'Reklamowane elementy',
    complainedProductsCount: 'Reklamowanych produktów',
    complainedServicesCount: 'Reklamowanych zdobień',
    complainedShipmentsCount: 'Reklamowanych transportów',
    complaint: 'Reklamacja',
    complaints: 'Reklamacje',
    complaintsInfoAvailableAfterSave: 'Lista reklamacji będzie widoczna po zapisaniu zamówienia',
    complaintsList: 'Lista reklamacji',
    createdAt: 'Utworzono',
    createdBy: 'Utworzona przez',
    deleteComplaintText: 'Tej operacji nie można cofnąć',
    ended: 'Zakończona',
    enterOrderName: 'Podaj nazwę zamówienia',
    handledBy: 'Obsługiwana przez',
    inRealization: 'W realizacji',
    itemsStatusAccepted: 'zaakceptowanych',
    itemsStatusNegotiated: 'negocjowanych',
    itemsStatusReceived: 'przyjętych',
    itemsStatusRejected: 'odrzuconych',
    noComplaintsToDisplay: 'Brak reklamacji do wyświetlenia',
    popup: {
      addComplaint: 'Dodaj reklamację',
      addErrorText: 'Nie udało się dodać reklamacji - spróbuj ponownie',
      addSuccessText: 'Pomyślnie dodano reklamację do zamówienia',
      addSuccessTitle: 'Dodano reklamację',
      complainedItems: 'Reklamowane pozycje',
      complainedProducts: 'Reklamowane produkty',
      complainedServices: 'Reklamowane zdobienia',
      complainTransport: 'Reklamuj transport',
      description: 'Opis reklamacji',
      editComplaint: 'Zapisz zmiany',
      editErrorText: 'Nie udało się zmienić reklamacji - spróbuj ponownie',
      editSuccessText: 'Pomyślnie zmodyfikowano reklamację',
      editSuccessTitle: 'Zmodyfikowano reklamację',
      enterComplaintDescription: 'Wprowadź opis reklamacji',
      handler: 'Osoba obsługująca reklamację',
      notInOrder: 'Nie istnieje w zamówieniu',
      product: 'Produkt',
      service: 'Zdobienie',
      trackingNumber: 'Numer trackingowy'
    },
    removeComplaintConfirmTitle: 'Czy chcesz usunąć reklamację?',
    removeComplaintErrorText: 'Wystąpił błąd podczas usuwania reklamacji. Spróbuj ponownie.',
    removeComplaintSuccessText: 'Usunięto wybraną reklamację',
    removeComplaintSuccessTitle: 'Usunięto reklamację',
    status: 'Status reklamacji',
    statuses: 'Statusy elementów',
    statusNames: {
      accepted: 'Zaakceptowana',
      negotiated: 'Negocjowana',
      received: 'Przyjęta',
      rejected: 'Odrzucona'
    }
  },
  container: {
    addContainer: 'Dodaj kontener',
    addContainerErrorText: 'Dodawanie kontenera nie powiodło się. Spróbuj ponownie.',
    addContainerSuccessText: 'Podany kontener został zapisany',
    addContainerSuccessTitle: 'Dodano kontener',
    addingNewContainer: 'Dodawanie nowego kontenera',
    addNewContainer: 'Dodaj nowy kontener',
    canClose: 'Czy można zamknąć?',
    close: 'Zamknięty',
    closeContainer: 'Zamknij kontener',
    container: 'Kontener',
    containerCloseErrorText: 'Zamknięcie kontenera nie powiodło się. Spróbuj ponownie.',
    containerEdit: 'Edycja kontenera',
    containerNumber: 'Numer kontenera',
    containers: 'Kontenery',
    containerSearchInProgress: 'Trwa wyszukiwanie kontenerów',
    containersList: 'Lista kontenerów',
    containersOrders: 'Kontenery - zamówienia',
    dliveryDateChanged: 'Data dostawy została zmieniona',
    editContainer: 'Edytuj kontener',
    enterContainerNumber: 'Podaj numer kontenera lub nazwę, kod produktu',
    importResults: 'Rezultaty importu',
    importSuccessfull: 'Zaimportowano pomyślnie',
    noContainersMatchingPhraseFound: 'Brak kontenerów pasujących do podanej frazy',
    noContainersToDisplay: 'Brak kontenerów do wyświetlenia',
    noContainersWithSufficientProductQuantityFound: 'Nie znaleziono kontenerów z wystarczającą ilością wybranego produktu.',
    noProductsInOrders: 'Brak produktów w zamówieniach...',
    noProductsInThisContainer: 'Brak produktów w tym kontenerze...',
    notificationSendErrorText: 'Wysłanie powiadomień nie powiodło się. Spróbuj ponownie.',
    notificationSendSuccessText: 'Powiadomienia mailowe zostały wysłane do klientów',
    notificationSendSuccessTitle: 'Wysłano powiadomienia',
    open: 'Otwarty',
    ordersSum: 'Suma zamówień',
    productManagementAvailableAfterContainerSave: 'Zarządzanie produktami będzie dostępne po zapisaniu kontenera.',
    productsInOrders: 'Produkty w zamówieniach',
    removeContainerConfirmTitle: 'Czy na pewno chcesz usunąć ten kontener?',
    removeContainerErrorText: 'Usuwanie kontenera nie powiodło się. Spróbuj ponownie.',
    removeContainerSuccessText: 'Wybrany kontener został usunięty',
    removeContainerSuccessTitle: 'Usunięto kontener',
    removeProductText: 'Najpierw usuń powiązane produkty aby móc usunąć ten produkt z kontenera',
    reservation: {
      containersReservationsList: 'Lista rezerwacji z kontenerów',
      noContainersReservationsToDisplay: 'Brak rezerwacji z kontenerów do wyświetlenia',
      reserevedInContainer: 'Zarezerwowano w kontenerze',
      reservationsClose: 'Rezerwacje zrealizowane',
      reservationsOpen: 'Rezerwacje oczekujące'
    },
    result: 'Rezultat',
    saveOrderToBeAbleToBook: 'Zapisz zamówienie aby móc rezerwować',
    searchForProductInContainers: 'Szukaj produktu w kontenerach',
    selectContainer: 'Wybierz kontener',
    sendMessageToCustomers: 'Wyślij wiadomość do klientów',
    updateContainerErrorText: 'Aktualizacja kontenera nie powiodła się. Spróbuj ponownie.',
    updateContainerSuccessText: 'Podany kontener został zaktualizowany',
    updateContainerSuccessTitle: 'Zaktualizowano kontener'
  },
  contractor: {
    acceptanceDate: 'Data akceptacji',
    addContractor: 'Dodaj wykonawcę',
    addContractorErrorText: 'Dodawanie wykonawcy nie powiodło się. Spróbuj ponownie.',
    addContractorSuccessText: 'Podany wykonawca został zapisany',
    addContractorSuccessTitle: 'Dodano wykonawcę',
    addingNewContractor: 'Dodawanie nowego wykonawcy',
    addingPricesWillBeAvailableAfterContractorSave: 'Dodawanie cen będzie możliwe po zapisaniu wykonawcy.',
    addNewContractor: 'Dodaj nowego wykonawcę',
    all: 'Wszystkie',
    chooseContractor: 'Wybierz wykonawcę',
    chooseEndedStatus: 'Pokazywać tylko zakończone?',
    chooseSettlementStatus: 'Wybierz status rozliczenia',
    contractor: 'Wykonawca',
    contractorName: 'Nazwa wykonawcy',
    contractors: 'Wykonawcy',
    contractorsList: 'Lista wykonawców',
    dateOfSampleAndAcceptance: 'Data próby i akceptacji',
    doEditContractor: 'Edytuj wykonawcę',
    editContractor: 'Edycja wykonawcy',
    editContractorErrorText: 'Aktualizacja wykonawcy nie powiodła się. Spróbuj ponownie.',
    editContractorSuccessText: 'Podany wykonawca został zaktualizowany',
    editContractorSuccessTitle: 'Zaktualizowano wykonawcę',
    enterContractorName: 'Podaj nazwę wykonawcy',
    listOfContractorsWorksToBeSettled: 'Lista prac wykonawców do rozliczenia',
    makeSettlementErrorText: 'Rozliczenie nie powiodło się. Spróbuj ponownie.',
    noContractorsToDisplay: 'Brak wykonawców do wyświetlenia',
    noItemsToBeSettled: 'Brak elementów do rozliczenia',
    onlyEnded: 'Tylko zakończone',
    removeContractorConfirmTitle: 'Czy na pewno chcesz usunąć tego wykonawcę?',
    removeContractorErrorText: 'Usuwanie wykonawcy nie powiodło się. Spróbuj ponownie.',
    removeContractorSuccessText: 'Wybrany wykonawca został usunięty',
    removeContractorSuccessTitle: 'Usunięto wykonawcę',
    service: 'Usługa',
    serviceCost: 'Koszt zdobienia',
    toBeSettled: 'Do rozliczenia',
    unitPrice: 'Cena jednostkowa'
  },
  contractorsSettlementsImportPopup: {
    importSuccessDesc: 'Zaimportowano dane z pliku XLSX',
    importSuccessTitle: 'Dane zaimportowane',
    importTitle: 'Importuj listę prac wykonawców do rozliczenia',
    importXlsx: 'Importuj XLSX',
    xlsxFile: 'Plik XLSX'
  },
  customer: {
    addAddress: 'Dodaj adres',
    addAddressByTaxInfoSuccessText: 'Na podstawie pobranych danych dodano adres wysyłki z uwagi na brak innych adresów wysyłki',
    addAddressByTaxInfoSuccessTitle: 'Dodano adres wysyłki',
    addAddressErrorText: 'Dodawanie adresu nie powiodło się. Spróbuj ponownie.',
    addAddressSuccessText: 'Podany adres został zapisany',
    addAddressSuccessTitle: 'Dodano adres',
    addContactPerson: 'Dodaj osobę kontaktową',
    addContactPersonErrorText: 'Dodawanie osoby kontaktowej nie powiodło się. Spróbuj ponownie.',
    addContactPersonSuccessText: 'Podana osoba kontaktowa została zapisana',
    addContactPersonSuccessTitle: 'Dodano osobę kontaktową',
    addCustomer: 'Dodaj klienta',
    addCustomerErrorText: 'Dodawanie klienta nie powiodło się. Spróbuj ponownie.',
    addCustomerSuccessText: 'Podany klient został zapisany',
    addCustomerSuccessTitle: 'Dodano klienta',
    addingContactPersonAvailableAfterCustomerSave: 'Dodawanie osób kontaktowych będzie możliwe po zapisaniu klienta.',
    addingNewCustomer: 'Dodawanie nowego klienta',
    addingPricesWillBeAvailableAfterContractorSave: 'Dodawanie cen będzie możliwe po zapisaniu klienta.',
    addingShippingAddressAvailableAfterCustomerSave: 'Dodawanie adresów do wysyłki będzie możliwe po zapisaniu klienta.',
    addingTransaltionsAvailableAfterCustomerSave: 'Dodawanie tłumaczeń będzie możliwe po zapisaniu klienta.',
    addNewCustomer: 'Dodaj nowego klienta',
    addressCreateFrom: 'Utwórz adres na bazie',
    addressLine2: 'Dodatkowy adres 2',
    addressLine3: 'Dodatkowy adres 3',
    autoSpecialRequirements: 'Włącz specjalne wymagania automatycznie',
    building: 'Budynek',
    buildingNumber: 'Numer budynku',
    changePassword: 'Zmień hasło',
    changeYourPassword: 'Zmień swoje hasło',
    city: 'Miasto',
    company: 'Firma',
    companyName: 'Nazwa firmy',
    contact: {
      addComment: 'Dodaj komentarz',
      addContactErrorText: 'Dodawanie kontaktu z klientem nie powiodło się. Spróbuj ponownie.',
      addContactSuccessText: 'Podany kontakt z klientem został zapisany',
      addContactSuccessTitle: 'Dodano kontakt z klientem',
      addNewCustomerContact: 'Dodaj nowy kontakt z klientem',
      addNewLabel: 'Dodaj kontakt z klientem',
      addNewTitle: 'Dodawanie nowego kontaktu z klientem',
      author: 'Autor',
      commentContent: 'Treść komentarza',
      comments: 'Komentarze',
      contact: 'Kontakt',
      contactDate: 'Data kontaktu',
      contactRelatedToContact: 'Osoba kontaktowa klienta (opcjonalnie)',
      contactRelatedToOrder: 'Kontakt dotyczył zamówienia (opcjonalnie)',
      contactType: 'Rodzaj kontaktu',
      contactTypeQuestionMark: 'Typ kontaktu?',
      content: 'Treść',
      customerContactsList: 'Lista kontaktów z klientem',
      customerResponse: 'Odpowiedź klienta',
      customersContacts: 'Kontakty z klientami',
      customersContactsList: 'Lista kontaktów z klientami',
      descriptionOptional: 'Opis (opcjonalny)',
      editComment: 'Edytuj komentarz',
      editContactErrorText: 'Zapisanie kontaktu z klientem nie powiodło się. Spróbuj ponownie.',
      editContactSuccessText: 'Wybrany kontakt z klientem został zapisany',
      editContactSuccessTitle: 'Zapisano kontakt z klientem',
      editTitle: 'Edytuj kontakt z klientem',
      mailContact: 'Kontakt mailowy',
      noCommentsToDisplay: 'Brak komentarzy do wyświetlenia',
      noContactsToDisplay: 'Brak kontaktów do wyświetlenia',
      noResponse: 'brak odpowiedzi',
      notifications: 'Powiązane powiadomienia',
      notificationsWillBeAvailableAfterSaving: 'Powiązane powiadomienia będą dostępne po zapisaniu kontaktu z klientem',
      phoneContact: 'Kontakt telefoniczny',
      removeCommentConfirmTitle: 'Czy na pewno chcesz usunąć ten komentarz?',
      removeCommentErrorText: 'Usuwanie komentarza nie powiodło się. Spróbuj ponownie.',
      removeCommentSuccessText: 'Wybrany komentarz został usunięty',
      removeCommentSuccessTitle: 'Usunięto komentarz',
      removeContactConfirmTitle: 'Czy na pewno chcesz usunąć ten kontakt?',
      removeContactErrorText: 'Usuwanie kontaktu nie powiodło się. Spróbuj ponownie.',
      removeContactSuccessText: 'Wybrany kontakt został usunięty',
      removeContactSuccessTitle: 'Usunięto kontakt',
      repliedOn: 'Odpowiedź z dnia',
      saveCommentErrorText: 'Zapis komentarza nie powiódł się. Spróbuj ponownie.',
      saveCommentSuccessText: 'Komentarz został pomyślnie zapisany',
      saveCommentSuccessTitle: 'Zapisano komentarz',
      saveContactErrorText: 'Zapisanie kontaktu z klientem nie powiodło się. Spróbuj ponownie.',
      saveContactSuccessText: 'Podany kontakt z klientem został zapisany',
      saveContactSuccessTitle: 'Zapisano kontakt z klientem',
      type: 'Typ',
      typeMail: 'Mailowy',
      typeMeeting: 'Spotkanie',
      typePatternSending: 'Wysyłka wzorów',
      typePhone: 'Telefoniczny',
      typeSpecCatSending: 'Wysyłka \"spec cap\"'
    },
    contactAddress: 'Adres kontaktowy',
    contactGroupQuestionMark: 'Rodzaj kontaktu?',
    contactInsideOrder: 'Kontakt w zamówieniu',
    contactPeople: 'Osoby kontaktowe',
    contactsWithCustomer: 'Kontakty z klientem',
    correspondenceAddressSet: 'Ustawiono adres korespondencyjny',
    correspondenceAddressSetDesc: 'Na bazie pobranych danych ustawiono  dadres korespondencyjny klienta',
    correspondenceAddressWillBeUsed: 'Adres korespondencyjny klienta posłuży do utworzenia nowego adresu dostawy',
    correspondenceInfo: 'Dane korespondencyjne',
    createAddressCorrespondence: 'Adresu korespondencyjnego',
    createAddressInvoice: 'Adresu używanego na fakturze',
    createNewAddress: 'Nowego adresu',
    customerCode: 'Kod klienta',
    customerContactsInfoAvailableAfterSave: 'Dane o kontaktach z klientem będą dostępne po zapisaniu zamówienia',
    customerContactsInforAvailableAfterCustomerSave: 'Dane o kontaktach z klientem będą dostępne po zapisaniu klienta',
    customerCountryQuestionMark: 'Kraj klienta?',
    customerLogo: 'Logo klienta',
    customerLowCase: 'klienci',
    customers: 'Klienci',
    customersList: 'Lista klientów',
    customerTags: 'Tagi klienta',
    dayForPayment: 'Dni na płatność',
    deleteAddressConfirmTitle: 'Czy na pewno chcesz usunąć ten adres?',
    deleteAddressErrorText: 'Usuwanie adresu nie powiodło się. Spróbuj ponownie.',
    deleteAddressSuccessText: 'Wybrany adres został usunięty',
    deleteAddressSuccessTitle: 'Usunięto adres',
    deleteContactPersonConfirmTitle: 'Czy na pewno chcesz usunąć tę osobę kontaktową?',
    deleteContactPersonErrorText: 'Usuwanie osoby kontaktowej nie powiodło się. Spróbuj ponownie.',
    deleteContactPersonSuccessText: 'Wybrana osoba kontaktowa została usunięta',
    deleteContactPersonSuccessTitle: 'Usunięto osobę kontaktową',
    discount: {
      currentCustomerDiscounts: 'Obecne rabaty klienta',
      currentCustomerDiscountsDifferentFromThoseInOrder: '<strong>Uwaga!</strong> Obecne rabaty klienta różnią się od tych zastosowanych w zamówieniu.',
      deliveryDiscount: 'Rabat na dostawę',
      discounts: 'Rabaty',
      discountsUpdateErrorText: 'Zmiana rabatów nie powiodła się. Spróbuj ponownie.',
      editCustomerDiscounts: 'Edytuj rabaty klienta',
      includeCustomerDiscounts: 'Uwzględniaj rabaty klienta',
      modifyCustomerDiscounts: 'Modyfikuj rabaty klienta',
      productDiscount: 'Rabat na produkty',
      resetDiscounts: 'Zmień rabaty',
      resetDiscoutns: 'Resetuj rabaty',
      resetOrderDiscountsText: 'Wartości rabatów w zamówieniu zostaną ustawione zgodnie z aktualnymi rabatami klienta. Czy chcesz kontynuować?',
      resetOrderDiscountsTitle: 'Zmiana rabatów',
      serviceDiscount: 'Rabat na usługi',
      servicesDiscount: 'Rabat na zdobienia',
      shippingDiscount: 'Rabat na spedycje'
    },
    discountRange: 'Zakres rabatu',
    donNotSend: 'Nie wysyłaj',
    downloadTaxNumberConfirmation: 'Pobierz potwierdzenie',
    downloadTaxNumberConfirmationAfterSave: 'Potwierdzenie można pobrać po zapisaniu klienta',
    downloadTaxNumberConfirmationDownloading: 'Pobieranie potwierdzenia...',
    edit: 'Edycja klienta',
    editAddress: 'Edytuj adres',
    editAddressErrorText: 'Edycja adresu nie powiodła się. Spróbuj ponownie.',
    editAddressSuccessText: 'Podany adres został zmieniony',
    editAddressSuccessTitle: 'Zmieniono adres',
    editClientErrorText: 'Edycja klienta nie powiodła się. Spróbuj ponownie.',
    editClientSuccessText: 'Dane klienta zostały zmodyfikowane',
    editClientSuccessTitle: 'Zmodyfikowano klienta',
    editContactPerson: 'Edytuj osobę kontaktową',
    editContactPersonErrorText: 'Edycja osoby kontaktowej nie powiodła się. Spróbuj ponownie.',
    editContactPersonSuccessText: 'Podana osoba kontaktowa została zmieniona',
    editContactPersonSuccessTitle: 'Zmieniono osobę kontaktową',
    editPasswordErrorText: 'Zmiana hasła nie powiodła się. Spróbuj ponownie.',
    editPasswordSuccessText: 'Hasło zostało zmienione',
    editPasswordSuccessTitle: 'Zmieniono hasło',
    enterCustomerAddress: 'Podaj miasto klienta',
    enterCustomerData: 'Podaj dane klienta',
    excludeFromInvoiceReminder: 'Wyklucz z wysyłki przypomnień o fakturach',
    excludeFromStockReports: 'Wyklucz z powiadomień o stockach',
    exportCustomers: 'Eksportuj klientów',
    exportPricesInfo: 'Zostaną wyeksportowane wszystkie ceny produktów powiązane z tym klientem.',
    fountAddresses: 'Znalezionych adresów:',
    getDataFromGUS: 'Pobierz dane z GUS',
    getDataFromVIES: 'Pobierz dane z VIES',
    hidecustomerInQR: 'Ukryj dane klienta na kodzie QR',
    history: 'Historia edycji',
    historyAction: 'Rodzaj zmiany',
    historyActions: 'Akcje',
    historyActionsList: {
      ADD: 'Dodanie',
      DELETE: 'Usunięcie',
      UPDATE: 'Modyfikacja'
    },
    historyDate: 'Data',
    historyDiffPopup: {
      currentValue: 'Obecna wartość',
      fieldName: 'Nazwa pola',
      previousValue: 'Poprzednia wartość',
      title: 'Wprowadzone zmiany'
    },
    historyInfoAvailableAfterSave: 'Dane o historii będą dostępne po zapisaniu oferty',
    historyModifiedElement: 'Zmieniany element',
    historyModifiedElementsList: {
      ADDRESS: 'Dane adresowe',
      CONTACT: 'Dane kontaktowe',
      CUSTOMER: 'Dane klienta',
      PRODUCT_PRICE: 'Ceny produktów',
      TAX_NUMBER_VERIFICATION: 'Weryfikacja identyfikatora podatkowego',
      TRANSLATION: 'Tłumaczenia'
    },
    historyNoRecords: 'Brak historii edycji danych dotyczących tego klienta',
    historySeeChanges: 'Zobacz zmiany',
    historyUser: 'Zmiana dokonana przez',
    historyWillBeAvailableAfterCustomerSave: 'Dane o historii edycji będą dostępne po zapisaniu klienta',
    houseNumber: 'Numer lokalu',
    inactiveTaxNumberLong: 'Nieaktywny numer NIP/VAT ID u wybranego klienta. Nie można dodać zamówienia.',
    indentDiscountEnabled: 'Rabaty domyślnie aktywne w ofertach/zamówieniach Indent',
    invalidTaxNumber: 'Nieprawidłowy',
    invalidTaxNumberLong: 'Nieprawidłowy numer NIP/VAT ID',
    invalidTaxNumberLong2: 'Nieprawidłowy numer NIP/VAT ID u wybranego klienta. Nie można dodać zamówienia.',
    invoiceAddressSet: 'Ustawiono dane do faktury',
    invoiceAddressSetDesc: 'Na bazie pobranych danych ustawiono dane do faktury',
    invoiceAddressWillBeUsed: 'Adres używany na fakturach klienta posłuży do utworzenia nowego adresu dostawy',
    invoiceAndCorrespondenceAddressSet: 'Ustawiono dane do faktury i adres korespondencyjny',
    invoiceAndCorrespondenceAddressSetDesc: 'Na bazie pobranych danych ustawiono dane do faktury i adres korespondencyjny klienta',
    invoiceInfo: 'Dane do faktury',
    invoiceName: 'Nazwa na fakturze',
    invoiceReceiver: 'Odbiorca faktur',
    invoiceReceiverEmailAddress: 'Adres e-mail odbiorcy faktury',
    isInvoicesNotSettled: 'Nierozliczone faktury?',
    isOrdersInRpogress: 'Zamówienia w toku?',
    lastTaxVerification: 'Data ostatniej weryfikacji NIP/VAT ID:',
    maxAddressSearchResults: 'Maksymalnie wyświetlanych jest 50 pasujących adresów, jeśli nie możesz znaleźć potrzebnego adresu - zawęź kryteria wyszukiwania.',
    nameNotice: 'Ustaw w: Dane do faktury → Nazwa na fakturze',
    newsletterAgreement: 'Zgoda na newsletter',
    newsletterStatus: {
      null: 'Brak informacji',
      subscribed: 'Udzielono zgody',
      unsubscribed: 'Brak zgody'
    },
    newsletterStatusAt: 'Ostatnia zmiana zgody na newsletter',
    noAddressesToDisplay: 'Brak adresów do wyświetlenia',
    noContactPeopleToDisplay: 'Brak osób kontaktowych do wyświetlenia',
    noCustomerMarchingPhraseFound: 'Brak klientów pasujących do podanej frazy',
    noCustomersToDisplay: 'Brak klientów do wyświetlenia',
    noTagsMatchingGivenPhrase: 'Brak tagów pasujących do podanej frazy',
    noTranslationsForThisClient: 'Brak tłumaczeń dla tego klienta',
    offersInProgress: 'Ofert w toku',
    orders: 'Zamówień',
    ordersAndOffers: 'Zamówień i ofert',
    ordersInProgress: 'Zamówień w toku',
    passowrdChange: 'Zmiana hasła',
    person: 'Osoba',
    phoneShortCap: 'Tel',
    product: 'Produkt',
    profile: 'Profil',
    removeCustomerConfirmTitle: 'Czy na pewno chcesz usunąć tego klienta?',
    removeCustomerErrorText: 'Usuwanie klienta nie powiodło się. Spróbuj ponownie.',
    removeCustomerSuccessText: 'Wybrany klient został usunięty',
    removeCustomerSuccessTitle: 'Usunięto klienta',
    removeLogo: 'Usuń logo',
    retrievedStatus: 'Uzyskany status:',
    retrievedStatusFor: 'dla: ',
    searchAddressesByCompanyNameAddressOrContactInfo: 'Wyszukaj adresy po nazwie firmy, adresie lub danych kontaktowych',
    selectCustomer: 'Wybierz klienta',
    selectDiscountType: 'Wybierz rodzaj rabatu',
    selectDiscountTypes: {
      discountProducts: 'Rabat na produkty',
      discountServices: 'Rabat na zdobienia',
      discountShipping: 'Rabat na dostawę'
    },
    selectMarketCustomer: 'Wybierz klienta z targów',
    selectPotentialCustomer: 'Wybierz potencjalnego klienta',
    sendCommunication: 'Wysyłać komunikację?',
    sendReportFromStock: 'Wysyłaj raport ze stocków',
    setInvoiceDataAsCorrespondenceData: 'Użyj dostępnych danych do faktury jako danych korespondencyjnych',
    shippingInfo: 'Dane do wysyłki',
    showCustomerOffers: 'Pokaż oferty',
    showCustomerOrders: 'Pokaż zamówienia',
    sourceOfGain: 'Źródło pozyskania',
    statistics: 'Statystyki',
    stockReportsNotifications: 'Powiadomienia o stockach',
    street: 'Ulica',
    taxNumberConfirmationFileNamePrefix: 'vat-id-klient-',
    taxNumberDifference: 'Podany numer różni się od ostatnio weryfikowanego numeru NIP/VAT ID',
    telephone: 'Telefon',
    termsOfSale: 'Warunki sprzedaży',
    termsOfSaleIndent: 'Warunki sprzedaży Indent',
    unsettledInvoices: 'Nierozliczonych faktur',
    validTaxNumber: 'Prawidłowy',
    vatIDActiveDuringCheck: 'Aktywny w momencie weryfikacji',
    vatIDNumber: 'NIP / VAT ID',
    verificationGusErrorDesc: 'GUS zwrócił nieprawidłowy status dla NIP klienta. Zweryfikuj ręcznie dane klienta.',
    verificationGusErrorTitle: 'Weryfikacja w GUS nie powiodła się',
    verificationIntegrationDisabledDesc: 'Wkrótce zostanie automatycznie włączona, a NIP/VAT ID klienta zostanie zweryfikowany.',
    verificationIntegrationDisabledTitle: 'Integracja z VIES/GUS została wyłączona',
    verificationOtherErrorDesc: 'System zwrócił nieprawidłowy status dla NIP/VAT ID klienta. Zweryfikuj ręcznie dane klienta.',
    verificationOtherErrorTitle: 'Weryfikacja danych nie powiodła się',
    verificationSkippedDesc: 'Dla tego klienta weryfikacja jest pomijana z uwagi na kraj, konfigurację systemu lub wyłączoną integrację z usługą weryfikacji numerów podatkowych.',
    verificationSkippedTitle: 'Weryfikacja pominięta',
    verificationViesErrorDesc: 'VIES zwrócił nieprawidłowy status dla VAT ID klienta. Zweryfikuj ręcznie dane klienta.',
    verificationViesErrorTitle: 'Weryfikacja w VIES nie powiodła się',
    verifyManually: 'Zweryfikuj ręcznie',
    verifyTaxID: 'Zweryfikuj',
    viesCommunicationIssue: 'Wystąpił błąd komunikacji z VIES i nie udało się zweryfikować numeru VAT',
    viesVerifiedManuallyDesc: 'Numer VAT został ręcznie zweryfikowany',
    viesVerifiedManuallyTitle: 'Zweryfikowano ręcznie',
    weakCustomer: 'Słaby klient',
    withOrdersInProgress: 'Z zamówieniami w toku',
    withoutOrdersInProgress: 'Bez zamówień w toku',
    withoutUnsettledInvoices: 'Bez nieopłaconych faktur',
    withUnsettledInvoices: 'Z nieopłaconymi fakturami',
    youMustCheckCurrentTaxIDDesc: 'Aktualnie wprowadzony NIP/VAT ID nie został sprawdzony w VIES/GUS - zweryfikuj numer i spróbuj ponownie.',
    youMustCheckTaxID: 'Niezweryfikowany NIP/VAT ID',
    youMustCheckTaxIDDesc: 'Przed dodaniem klienta, należy zweryfikować jego NIP/VAT ID. Jeśli NIP/VAT ID był zmieniany - pobierz dane z VIES/GUS ponownie przed zapisem.',
    youMustProvideTaxNumberDesc: 'Przed dodaniem klienta należy podać jego NIP/VAT ID',
    youMustProvideTaxNumberTitle: 'Należy podać NIP/VAT ID',
    youMustProvideValidTaxNumberDesc: 'Podany numer NIP/VAT ID jest niepoprawny lub nieaktywny. Nie można dodać klienta bez podania poprawnego i aktywnego numeru NIP/VAT ID.',
    youMustProvideValidTaxNumberTitle: 'Niepoprawny NIP/VAT ID',
    youMustSelectCountryPrefix: 'Brak kodu kraju',
    youMustSelectCountryPrefixDesc: 'Przed weryfikacją NIP/VAT ID należy wybrać kod kraju',
    youMustSelectCountryPrefixDesc2: 'Do weryfikacji NIP/VAT ID przed dodaniem zamówienia, potrzebny jest kod kraju, który jest nieokreślony u wybranego klienta',
    yourAccount: 'Twoje konto',
    zipCode: 'Kod pocztowy'
  },
  customerOrdersPopup: {
    offers: 'Oferty klienta',
    orders: 'Zamówienia klienta'
  },
  dashboard: {
    admin_new_contacts_count: 'Kontaktów do pozyskania',
    admin_new_customers_count: 'Klientów do pozyskania',
    approachingDeadline: 'Zbliża się deadline',
    awaitingDraft: 'Czeka na draft',
    awaitingProductionFinish: 'Czeka na zakończenie produkcji',
    awaitingSample: 'Czeka na próbę',
    awaitingSampleAccept: 'Czeka na akceptację próby',
    blockedOrders: 'Zablokowane zamówienia',
    checkOffers: 'Sprawdź oferty',
    customersPopup: {
      averageOrderTime: 'Składa zamówienie średnio po {days} dniach',
      customerEmail: 'E-mail',
      customerName: 'Nazwa klienta',
      customerPhone: 'Telefon',
      title: 'Wyślij zapytania do klientów'
    },
    finishingProduction: 'Zbliża się koniec produkcji',
    from: ' z ',
    inPreprationForShipping: 'Przygotowanie do wysyłki',
    inquiriesToSendToCustomers: 'Zapytań do wysłania',
    inquiruesPendingCustomerResponse: 'Oferty czekające na odpowiedź klientów',
    longRealizedOrders: 'Zamówienia z długim czasem produkcji',
    mainPage: 'Strona główna',
    myTasksTitle: 'Moje zadania',
    new_contacts_count: 'Pozyskaj kontakty',
    new_customers_count: 'Pozyskaj klientów',
    offersToCheck: 'Ofert do sprawdzenia',
    ordersInProduction: 'Zamówienia w produkcji',
    ordersInWarehouse: 'Zamówienia zebrane w magazynie',
    ordersPendingInvoice: 'Zamówienia oczekujące na fakturę',
    ordersPendingShipment: 'Zamówienia oczekujące wysyłki',
    orderStatsTitle: 'Statystyki zamówień',
    sendInquiriesToCustomers: 'Wyślij zapytania',
    showCustomers: 'Pokaż klientów',
    showOffers: 'Pokaż oferty',
    toSettleWithContractors: 'Do rozliczenia z wykonawcami',
    welcomeToHeadwear: 'Witaj w HeadWear CRM',
    workersTasksTitle: 'Zadania dla pracowników'
  },
  errorPage: {
    errorCode: '404',
    pageDoesNotExist: 'Wybrana podstrona nie istnieje',
    tryAgainLaterOrContactAdministrator: 'Spróbuj ponownie później lub skontaktuj się z administratorem systemu.'
  },
  image: {
    dropPhotosHere: 'Upuść zdjęcia tutaj...',
    photo: 'Zdjęcie',
    photoGallery: 'Galeria zdjęć',
    photosLoading: 'Trwa wczytywanie zdjęć',
    photosOrderChangeErrorText: 'Zmiana kolejności zdjęć nie powiodła się. Spróbuj ponownie.',
    removePhoto: 'Usuń zdjęcie',
    removePhotoConfirmTitle: 'Czy na pewno chcesz usunąć to zdjęcie?',
    removePhotoErrorText: 'Usuwanie zdjęcia nie powiodło się. Spróbuj ponownie.',
    removePhotoSuccessText: 'Wybrane zdjęcie zostało usunięte',
    removePhotoSuccessTitle: 'Usunięto zdjęcie',
    webGallery: 'Zdjęcia na WWW'
  },
  indentRegistry: {
    additionalInfo: 'Dodatkowe informacje',
    addProductPopup: {
      addProduct: 'Dodaj produkt Indent',
      loadingDataError: 'Wystąpił błąd podczas pobierania danych',
      title: 'Dodawanie nowego produktu Indent'
    },
    cnCode: 'Kod CN',
    code: 'Styl',
    customerDesignName: 'Nazwa zamówienia klienta',
    customerOrderDate: 'Data złożenia zamówienia przez klienta',
    customerOrderName: 'Numer zamówienia klienta',
    enterOrderName: 'Wprowadź nazwę zamówienia',
    exportRegistry: 'Eksportuj rejestr',
    freightType: 'Rodzaj transportu',
    hideDetails: 'Ukryj informacje',
    indent: 'Indent',
    indentRegistry: 'Rejestr Indent',
    indentRegistryLowerCase: 'rejestr-produktow-indent',
    noItemsToDisplay: 'Brak pozycji do wyświetlenia',
    order: 'Zamówienie',
    orderIndentDatawillBeAvailableAfterSave: 'Dane Indent będą dostępne po zapisaniu zamówienia',
    originalShipmentDate: 'Data wysyłki z Chin',
    product: 'Produkt',
    productAdditionalData: 'Szczegóły produktu',
    products: 'Produkty',
    productsRegistry: 'Rejestr produktów Indent',
    quantity: 'Ilość',
    registry: 'Rejestr',
    sampleProductionDays: 'Czas produkcji próby (w dniach)',
    selectFreightType: 'Wybierz rodzaj transportu',
    selectRegistry: 'Wybierz rejestr Indent',
    sellPrice: 'Cena sprzedaży do klienta',
    service: 'Zdobienia',
    serviceAcceptedAt: 'Data akceptacji próby przez klienta',
    serviceObtainingAt: 'Data otrzymania zdjęć próby z fabryki',
    shipperDate: 'Przewidywana data zakończenia produkcji',
    shipping: 'Dostawa',
    showDetails: 'Pokaż informacje',
    theseInformationsWillBeUpdatedAfterSave: 'Informacje w tej zakładce są aktualizowane po zapisaniu zamówienia',
    timeframeProduction: 'Czas produkcji zamówienia (w dniach)',
    title: 'Rejestr Indent',
    unitSellPrice: 'Cena jednostkowa'
  },
  inquiries: {
    acceptOffer: 'Akceptuj ofertę',
    addComments: 'Dodaj swoje uwagi',
    addFirstProductInstructionInfo: 'Dodaj swój pierwszy produkt klikając \"Dodaj produkt\"',
    addInquiry: 'Dodaj zapytanie ofertowe',
    addMoreProductsInstructionInfo: 'Dodałeś pierwszy produkt do zapytania ofertowego. Jeśli chcesz dodać kolejny produkt, skorzystaj z przycisku \"Dodaj produkt\" na liście poniżej. Możesz wyszukiwać produkty dla każdej pozycji klikając \"Szukaj\".',
    addOfferErrorText: 'Dodawanie oferty nie powiodło się. Spróbuj ponownie.',
    addOfferSccessTitle: 'Dodano ofertę',
    addOfferSuccessText: 'Podana oferta została dodana',
    addServiceToInquiry: 'Dodaj zdobienie do zapytania',
    attachFilesInfo: 'Możesz dołączyć do zapytania dodatkowe wizualizacje, które pomogą w analizie zapytania oraz jego wycenie.',
    caanotCreateOrder: 'Nie można utworzyć zamówienia',
    combineModelInQuote: 'Łącz modele w wycenie',
    contactUsIfYouNeedToChangeInquiry: 'Jeśli potrzebujesz zmodyfikować swoje zapytanie/zamówienie - prosimy o bezpośredni kontakt.',
    editOfferErrorText: 'Edycja oferty nie powiodła się. Spróbuj ponownie.',
    editOfferSuccessText: 'Podana oferta została zmodyfikowana',
    editOfferSuccessTitleShort: 'Zapisano ofertę',
    failedToAddProductsToOrder: 'Nie dodano produktów do zamówienia',
    followUpSent: 'Follow up wysłany',
    followUpSentText: 'Przypomnienie do klienta zostało wysłane',
    inquiriy: 'Zapytanie ofertowe',
    inquiryAcceptErrorText: 'Akceptowanie oferty nie powiodło się. Spróbuj ponownie.',
    inquiryAcceptSuccessText: 'Wybrana oferta została zaakceptowana',
    inquiryAcceptSuccessTitle: 'Zaakceptowano ofertę',
    inquiryForProductsNumberRange: 'Zapytanie na przedział liczby produktów',
    inquirySaveErrorText: 'Dodawanie zapytania ofertowego nie powiodło się. Spróbuj ponownie.',
    inquirySaveSccessTitle: 'Zapisano zapytanie ofertowe',
    inquirySaveSuccessText: 'Twoje zapytanie ofertowe zostało zapisane',
    inquiryStatus: 'Status oferty',
    needExecutionTill: 'Potrzebuję realizacji do dnia',
    noComments: 'Brak uwag',
    noDateSelected: 'Brak terminu',
    offerDative: 'ofercie',
    offerDativeCap: 'Ofercie',
    orderAdditionalInfo: 'Dodatkowe uwagi do zamówienia',
    sendFollowUp: 'Wyślij follow up',
    sendForCustomerApproval: 'Wyślij do akceptacji klienta',
    sendForCustomerApprovalErrorText: 'Wysyłanie do akceptacji klienta nie powiodło się. Spróbuj ponownie.',
    sendForCustomerApprovalSuccessText: 'Oferta została wysłana do akceptacji klienta.',
    sendForCustomerApprovalSuccessTitle: 'Wysłano do klienta',
    sendInquiry: 'Wyślij zapytanie',
    sendOrder: 'Wyślij zamówienie',
    someProductAreUnavailable: 'Niektóre produkty w Twoim zamówieniu są niedostępne lub są dostępne w zbyt małej ilości aby utworzyć zamówienie.',
    unexpectedErrorOccured: 'Wystąpił nieoczekiwany problem',
    yourOrderContainsDecorationsSoSendInquiry: 'Twoje zamówienie zawiera zdobienia. W takiej sytuacji należy wysłać zapytanie.'
  },
  kpi: {
    addKpi: 'Dodaj KPI',
    addKpiErrorText: 'Dodawanie KPI nie powiodło się. Spróbuj ponownie.',
    addKpiSuccessText: 'Podany KPI został zapisany',
    addKpiSuccessTitle: 'Dodano KPI',
    addNewKpi: 'Dodaj nowy KPI',
    addNewWorkerGoal: 'Dodawanie nowego celu pracownika',
    amountOfStartedOrders: 'Kwota rozpoczętych zamówień',
    averageResults: 'Uśrednione wyniki',
    contactsNumberRegardingNewOrders: 'Liczba kontaktów w sprawie nowych zamówień',
    editKpiErrorText: 'Zmodyfikowanie KPI nie powiodło się. Spróbuj ponownie.',
    editKpiSuccessText: 'Wybrany KPI został zmodyfikowany',
    editKpiSuccessTitle: 'Zmodyfikowano KPI',
    editWorkerGoal: 'Edycja celu pracownika',
    goals: 'Cele',
    kpiImplementation: 'Realizacja KPI',
    mean: 'ŚREDNIA',
    noUserSelectedKpiErrorText: 'Musisz wybrać pracownika powiązanego z tym KPI',
    noWorkersGoalsToDisplay: 'Brak celów pracowników do wyświetlenia',
    numberOfNewContacts: 'Liczba pozyskanych nowych kontaktów',
    numberOfNewCustomers: 'Liczba pozyskanych nowych klientów',
    numberOfStartedOffers: 'Liczba rozpoczętych ofert',
    numberOfStartedOrders: 'Liczba rozpoczętych zamówień',
    onAvergae: 'Średnio',
    period: 'Okres',
    removeGoalConfirmTitle: 'Czy na pewno chcesz usunąć ten cel KPI?',
    removeGoalErrorText: 'Usuwanie celu KPI nie powiodło się. Spróbuj ponownie.',
    removeGoalSuccessText: 'Wybrany cel KPI pracownika został usunięty',
    removeGoalSuccessTitle: 'Usunięto cel KPI',
    sum: 'SUMA',
    workersGoals: 'Cele pracowników',
    workersGoalsList: 'Lista KPI pracowników'
  },
  login: {
    authError: 'Błąd autoryzacji. Spróbuj ponownie',
    customerPanelInfo: 'Panel klienta został przeniesiony. Skontaktuj się z nami w celu uzyskania dostępu do nowego panelu klienta.',
    emailPlaceholder: 'Twój adres e-mail',
    loginInProgress: 'Logowanie...',
    loginLabel: 'Zaloguj',
    password: 'Hasło',
    passwordPlaceholder: '********'
  },
  longRealizedOrdersPopup: {
    created: 'Utworzono',
    modified: 'Zmodyfikowano',
    order: 'Zamówienie',
    status: 'Status',
    title: 'Zamówienia z długim czasem produkcji'
  },
  marketCustomers: {
    accountManager: 'Opiekun',
    addCustomerErrorText: 'Wystąpił błąd podczas dodawania klienta. Spróbuj ponownie.',
    addCustomerSuccessText: 'Pomyślnie dodano klienta z targów',
    addCustomerSuccessTitle: 'Dodano klienta',
    addNewContact: 'Dodaj nowy kontakt',
    addNewMarketCustomer: 'Dodaj nowego klienta',
    addNewMarketCustomerContact: 'Dodaj kontakt z klientem z targów',
    address: 'Adres',
    building: 'Nr budynku',
    city: 'Miasto',
    contactName: 'Imię',
    contacts: 'Kontakty z klientem z targów',
    contactSurname: 'Nazwisko',
    contactsWillBeAvailableAfterSavingMarketCustomer: 'Kontakty będą dostępne po zapisaniu klienta z targów',
    country: 'Kraj',
    createCustomerFromMarketCustomer: 'Zamień na klienta',
    customerExistsDesc: 'Klient o takim NIP już istnieje. Nie ma konieczności dodawania go ponownie.',
    customerExistsTitle: 'Taki klient już istnieje',
    dataLoadedCorrectlyDesc: 'Pomyślnie wczytano dane klienta z targów',
    dataLoadedCorrectlyTitle: 'Wczytano dane',
    deleteConfirmTitle: 'Czy na pewno chcesz usunąć klienta?',
    deleteErrorText: 'Nie udało się usunąć klienta. Spróbuj ponownie.',
    deleteSuccessText: 'Pomyślnie usunięto klienta z targów',
    deleteSuccessTitle: 'Usunięto klienta',
    description: 'Opis',
    editCustomerErrorText: 'Wystąpił błąd podczas edycji klienta. Spróbuj ponownie.',
    editCustomerSuccessText: 'Pomyślnie zmodyfikowano klienta z targów',
    editCustomerSuccessTitle: 'Zapisano klienta',
    email: 'E-mail',
    emptyTaxDataDesc: 'Przed zamianą w klienta, należy podać prefix VAT oraz numer NIP/VAT i zapisać klienta z targów.',
    emptyTaxDataTitle: 'Brak wymaganych danych',
    errorLoadingData: 'Nie udało się wczytać danych klienta z targów',
    existingCustomerDesc: 'Klient powiązany z podanym numerem NIP/VAT już istnieje. Jeśli zmieniono numer NIP/VAT - pamiętaj o zapisaniu klienta przed próbą konwersji.',
    existingCustomerTitle: 'Taki klient już istnieje',
    importHistory: 'Historia importów',
    importMarketCustomers: 'Importuj klientów',
    invoiceCountryPrefix: 'Prefix VAT',
    invoiceTaxNumber: 'Numer NIP/VAT',
    locale: 'Nr lokalu',
    marketCustomer: 'Klient z targów',
    marketCustomerEdit: 'Edycja klienta z targów',
    marketCustomerNew: 'Nowy klient z targów',
    marketCustomersLabel: 'Klienci z targów',
    marketCustomersList: 'Lista klientów z targów',
    marketCustomersSearchPlaceholder: 'Podaj nazwę klienta',
    marketCustomersTagPlaceholder: 'Podaj nazwę tagu klienta',
    noMarketCustomersToDisplay: 'Brak klientów z targów do pokazania',
    otherData: 'Dodatkowe informacje',
    phone: 'Telefon',
    postCode: 'Kod pocztowy',
    saveMarketCustomer: 'Zapisz klienta z targów',
    shopUrl: 'Adres URL sklepu internetowego',
    tag: 'Tag klienta',
    websiteUrl: 'Adres URL strony internetowej'
  },
  marketCustomersImportPopup: {
    errorWhileLoadingImportsList: 'Wystąpił błąd podczas ładowania historii importów...',
    importDeleteConfirmTitle: 'Czy na pewno chcesz usunąć dane z tego importu?',
    importHistoryIsEmpty: 'Brak importów do wyświetlenia',
    importHistoryTitle: 'Historia ostatnich importów',
    importList: {
      author: 'Importujący',
      count: 'Liczba kontaktów',
      date: 'Data importu',
      delete: 'Usuń'
    },
    importRemoveErrorText: 'Wystąpił błąd podczas usuwania danych importu',
    importRemoveSuccessText: 'Pomyślnie usunięto dane z wybranego importu',
    importRemoveSuccessTitle: 'Usunięto import',
    importSuccessDesc: 'Zaimportowano klientów z targów',
    importSuccessTitle: 'Import zakończony',
    importTitle: 'Importuj klientów z targów',
    xlsxFile: 'Wybierz plik XLSX'
  },
  marketing: {
    addingTranslationsAvailableAfterMailingSave: 'Zapisz wiadomość aby móc dodawać tłumaczenia',
    addMailingErrorText: 'Dodawanie wiadomości nie powiodło się. Spróbuj ponownie.',
    addMailingSuccessText: 'Podana wiadomość została dodana',
    addMailingSuccessTitle: 'Dodano wiadomość e-mail',
    addMessage: 'Dodaj wiadomość e-mail',
    addNewMessage: 'Dodaj nową wiadomość',
    addNewSegment: 'Dodaj nowy segment',
    addSegment: 'Dodaj segment',
    addSegmentErrorText: 'Dodawanie segmentu nie powiodło się. Spróbuj ponownie.',
    addSegmentSuccessText: 'Podany segment został dodany',
    addSegmentSuccessTitle: 'Dodano segment',
    addTranslation: 'Dodaj tłumaczenie',
    atLeastOneFilterRequired: 'Należy dodać przynajmniej jeden filtr.',
    availableVariablesInfo: 'Możesz użyć poniższych tagów, aby spersonalizować wiadomość',
    choose: 'Wybierz...',
    chooseOnCalendar: 'Wybierz z kalendarza',
    customersOrderBy: 'Sortuj klientów po',
    daysAgo: 'dni temu',
    editEmailMessage: 'Edycja wiadomości e-mail',
    editMailingErrorText: 'Edycja wiadomości nie powiodła się. Spróbuj ponownie.',
    editMailingSuccessText: 'wybrana wiadomość została zmieniona',
    editMailingSuccessTitle: 'Zmodyfikowano wiadomość e-mail',
    editSegment: 'Edycja segment',
    emailMessages: 'Wiadomości e-mail',
    emailsCount: 'Wysłano wiadomości',
    emailSubject: 'Temat wiadomości',
    enterValue: 'Wpisz wartość...',
    exportClientsList: 'Eksportuj listę klientów',
    filtersCount: 'Liczba filtrów',
    howManyDaysAgo: 'Ile dni temu',
    insertMessageContent: 'Wpisz treść wiadomości...',
    listGenerationDate: 'Data generowania listy',
    mailingCannotBeSent: 'Wysyłka wiadomości do klientów jest zablokowana.',
    mailingCannotBeUpdated: 'Ta wiadomość nie może być teraz edytowana.',
    mailingNotSentYet: 'Mailing nie został jeszcze wysłany. Lista adresów e-mail będzie dostępna po rozpoczęciu wysyłki.',
    maxCustomers: 'Maksymalna liczba klientów',
    maxCustomersTable: 'Max. klientów',
    messageContent: 'Treść wiadomości',
    newEmailMessage: 'Nowa wiadomość e-mail',
    newSegment: 'Nowy segment',
    noMatchingCustomersFound: 'Nie znaleziono pasujących klientów',
    noMessagesToDisplay: 'Brak wiadomości do wyświetlenia',
    noSegmentsToDisplay: 'Brak segmentów do wyświetlenia',
    numberRange: 'Przedział liczbowy',
    ordersAmount: 'Kwota zamówień',
    ordersCount: 'Liczba zamówień',
    preview10Results: 'Pobierz 10 wyników segmentu',
    rebuildClientsList: 'Przebuduj listę klientów',
    reloadClientsList: 'Odśwież listę klientów',
    removeMailingConfirmTitle: 'Czy na pewno chcesz usunąć tę wiadomość?',
    removeMailingErrorText: 'Usuwanie wiadomości nie powiodło się. Spróbuj ponownie.',
    removeMailingSuccessText: 'Wybrana wiadomość e-mail została usunięta',
    removeMailingSuccessTitle: 'Usunięto wiadomość',
    removeSegmentConfirmTitle: 'Czy na pewno chcesz usunąć ten segment?',
    removeSegmentErrorText: 'Usuwanie segmentu nie powiodło się. Spróbuj ponownie.',
    removeSegmentSuccessText: 'Wybrany segment został usunięty',
    removeSegmentSuccessTitle: 'Usunięto segment',
    resultsPreview: 'Podgląd wyników',
    salesTools: 'Funkcje sprzedażowe',
    saveAndClose: 'Zapisz i wróć',
    segmentFilters: 'Filtry segmentu',
    segmentFormValidationError: 'Błąd walidacji formularza. Aby pobrać dane klientów należy stworzyć poprawny segment.',
    segments: 'Segmenty',
    segmentsCount: 'Ilość segmentów',
    sendMailing: 'Wyślij do klientów',
    sendMailingConfirmText: '<strong>Uwaga:</strong> Upewnij się, że zapisałeś wszystkie zmiany przed wysyłką! Niezapisane zmiany w formularzu nie zostaną uwzględnione.<br><br>Czy na pewno chcesz rozpocząć wysyłkę do klientów?',
    sendMailingConfirmTitle: 'Czy na pewno chcesz wysłać ten mailing?',
    sendMailingErrorText: 'Wystąpił błąd podczas zlecania wysyłki mailingu. Spróbuj ponownie.',
    sendMailingSuccessText: 'Mailing został dodany do kolejki wysyłkowej.',
    sendMailingSuccessTitle: 'Wysyłka rozpoczęta',
    sendTestEmail: 'Wyślij test',
    sentAt: 'Data wysyłki',
    sentEmails: 'Wysłane wiadomości',
    subject: 'Temat',
    testEmailAddress: 'Adres e-mail do testu',
    testEmailErrorText: 'Nie udało się wysłać wiadomości testowej. Sprawdź adres e-mail i spróbuj ponownie.',
    testEmailSuccessText: 'Wiadomość testowa została pomyślnie wysłana na podany adres.',
    testEmailSuccessTitle: 'Wysłano wiadomość testową',
    translations: 'Tłumaczenia'
  },
  noPermissions: {
    noPermissionsDescription: 'Jeżeli uważasz, że to błąd - skontaktuj się z administratorem systemu.',
    noPermissionsText: 'Nie masz uprawnień do przeglądania tej strony',
    noPermissionsTitle: 'Brak uprawnień'
  },
  notifications: {
    addNewNotification: 'Dodaj nowe powiadomienie',
    completedFilterAll: 'Wszystkie',
    completedFilterIsCompleted: 'Ukończone',
    completedFilterIsNotCompleted: 'Nieukończone',
    dateTime: 'Termin',
    description: 'Treść powiadomienia',
    editNotification: 'Edytuj powiadomienie',
    form: {
      addCC: 'Dodaj kopię DW',
      addNotificationErrorText: 'Wystąpił błąd podczas dodawania powiadomienia. Spróbuj ponownie.',
      addNotificationSuccessText: 'Pomyślnie dodano powiadomienie',
      addNotificationSuccessTitle: 'Dodano powiadomienie',
      date: 'Data',
      description: 'Treść powiadomienia',
      editNotificationErrorText: 'Wystąpił błąd podczas edytowania powiadomienia. Spróbuj ponownie.',
      editNotificationSuccessText: 'Pomyślnie zmodyfikowano powiadomienie',
      editNotificationSuccessTitle: 'Zmodyfikowano powiadomienie',
      emailCarbonCopy: 'Do kogo jeszcze wysłać powiadomienie (kopia DW)?',
      frequency: 'Częstotliwość',
      frequencyValues: {
        daily: 'Codziennie',
        monthly: 'Co miesiąc',
        selectValue: 'Wybierz',
        weekly: 'Co tydzień'
      },
      isRepeatable: 'Powtarzalne?',
      reminderBefore: 'Ile godzin przed terminem przypomnieć o powiadomieniu?',
      repeatNumber: 'Liczba powtórzeń',
      repeatNumberNote: '0 oznacza nieskończoną liczbę powtórzeń',
      sendReminder: 'Wyślij e-mail',
      showInDashboard: 'Pokaż na stronie głównej',
      time: 'Godzina'
    },
    goToFullList: 'Idź do pełnej listy',
    hideChildrenNotifications: 'Ukryj powtórne powiadomienia',
    isConnectedWithContact: 'To powiadomienie powiązane jest z kontaktem z klientem',
    markAsCompleted: 'Oznacz jako wykonane',
    markAsNotCompleted: 'Oznacz jako niewykonane',
    markingFailedTryAgain: 'Oznaczenie powiadomienia nie powiodło się. Spróbuj ponownie',
    noNotificationsToDisplay: 'Brak powiadomień do wyświetlenia',
    notifications: 'Twoje powiadomienia',
    notificationsLabel: 'Powiadomienia',
    notificationsNearest: 'Twoje najbliższe wydarzenia',
    onlyFutureFilter: 'Tylko przyszłe',
    order: 'Zamówienie',
    reminderBefore: 'Przypomnienie',
    removeNotificationConfirmTitle: 'Czy na pewno chcesz usunąć to powiadomienie?',
    removeNotificationErrorText: 'Wystąpił błąd podczas usuwania powiadomienia. Spróbuj ponownie.',
    removeNotificationSuccessText: 'Wybrane powiadomienie zostało usunięte',
    removeNotificationSuccessTitle: 'Usunięto powiadomienie',
    seeList: 'Zobacz listę',
    sendReminder: 'E-mail',
    showAllFilter: 'Pokazuj wszystkie',
    showChildrenNotifications: 'Pokaż powtórne powiadomienia',
    showInDashboard: 'Strona główna',
    showInDashboardFilter: 'Tylko ze strony głównej',
    times: 'razy',
    viewConnectedContact: 'Zobacz powiązany kontakt',
    youHaveUpcomingEvents: 'Posiadasz zbliżające się wydarzenia'
  },
  order: {
    addAdditionalInfoInternal: 'Dodaj dodatkowe uwagi wewnętrzne do oferty',
    addDataOnInvoice: 'Dodaj dane na fakturę',
    addIndentOfferServicesDescription: 'Wklej tutaj dodatkowe informacje...',
    additionalDispatchCost: 'Dodatkowe koszty wysyłki',
    additionalInfo: 'Dodatkowe informacje',
    additionalInfoInternal: 'Dodatkowe uwagi (wewnętrzne)',
    additionalShippingCost: 'Dodatkowe koszty spedycji',
    additionalShippingCostAfterDiscount: 'Dodatkowe koszty spedycji po rabacie',
    addNewContactPerson: 'Dodaj nową osobę kontaktową',
    addNewFemenine: 'Dodaj nową',
    addNewInquiry: 'Dodaj nowe zapytanie',
    addNewOffer: 'Dodaj nową ofertę',
    addNewOrder: 'Dodaj nowe zamówienie',
    addNewOrderIndent: 'Dodaj nowe zamówienie Indent',
    addNewShippingAddress: 'Dodaj nowy adres wysyłki',
    addOffer: 'Dodaj ofertę',
    addressConfirmed: 'Potwierdzony adres wysyłki',
    addressConfirmedAt: 'Potwierdzono',
    addressConfirmedBy: 'Potwierdzony przez',
    addressIsRequiredForInvoice: 'Należy określić adres wysyłki',
    addressIsRequiredForInvoiceDesc: 'Przed wysłaniem prośby o wystawienie faktury, należy określić adres wysyłki i zapisać zamówienie.',
    addressOfCorrespondence: 'Adres korespondencyjny',
    addressRemoved: 'Poprzednio używany adres został usunięty. Proszę wybrać nowy adres.',
    advance: 'Zaliczka',
    advanceNotPaid: 'Zaliczka NIEzapłacona',
    advancePaid: 'Zaliczka zapłacona',
    amountOfAdvance: 'Kwota zaliczki',
    assingedWorker: 'Przypisany pracownik',
    attachmentForWarehouseman: 'Załącznik dla magazyniera',
    attentionPriorityOrder: 'Uwaga! To zamówienie jest priorytetowe',
    awaitingInvoice: 'czekających na wystawienie faktury',
    awaitingProductionComplete: 'czekających na zakończenie produkcji',
    awaitingSample: 'czekających na próbę',
    awaitingSampleAcceptance: 'czekających na akceptację próby',
    badPayerRequiresAdvance: 'Słaby klient (wymaga zaliczki)',
    basePricePerCarton: 'Bazowa cena za karton',
    beeingCollected: 'W trakcie zbierania',
    billingInvoice: 'Faktura rozliczeniowa',
    blockade: 'Blokada',
    blocked: 'Zablokowane',
    blockedOrderDifferentUser: 'To zamówienie jest zablokowane, bo jest edytowane przez innego użytkownika ({user}).',
    blockedOrderSameUser: 'To zamówienie jest zablokowane, bo jest edytowane przez Ciebie w innej zakładce.',
    blockedQuestionMark: 'Blokada?',
    blockErpInvoiceRequest: 'Blokuj wystawienie faktury w ERP Optima',
    boxCommentsPopup: {
      createdAt: 'Dodany',
      description: 'Komentarz',
      noComments: 'Brak komentarzy dla tego produktu',
      operation: 'Działanie',
      operationCollection: 'Zbieranie',
      operationReturn: 'Zwrot',
      operationVerification: 'Weryfikacja',
      title: 'Komentarze ze zbierania i weryfikowania produktu'
    },
    boxMarkingNumber: 'Numer BOX MARKING',
    brand: {
      brand: 'Marka',
      enterBrand: 'Wprowadź markę',
      noBrandsMatchingPhrase: 'Brak marek pasujących do podanej frazy'
    },
    canChangeAdvanceToNormalPayment: 'Uwaga!',
    canChangeAdvanceToNormalPaymentDesc: 'Ten klient opłacił już kilka proform. Po konsultacji z administracją można zrezygnować z zaliczki.',
    cannotBeVirtual: 'To zamówienie nie może być wirtualne',
    cannotBeVirtualDesc: 'Produkty w tym zamówieniu zawierają zamówienia u dostawców lub rezerwacje w kontenerach.',
    cannotBeVirtualDescSync: 'To zamówienie jest już zsynchronizowane',
    cannotPlaceOrderWithUnavailableProductsChangeAndTryAgain: 'Nie można dodać zamówienia, które posiada niedostępne produkty. Zmodyfikuj zamówienie i spróbuj ponownie.',
    cartonsNumber: 'Ilość kartonów',
    changed: 'Zmienione zamówienia',
    changeOrderStatus: 'Zmień status zamówienia',
    checkCartonsAmount: 'Uwaga - sugerowana liczba kartonów różni się od wprowadzonej - upewnij się, że ilość kartonów została skonfigurowana poprawnie.',
    chooseShippingAddress: 'Wybierz adres wysyłki',
    clientContactPerson: 'Osoba kontaktowa klienta',
    cod: 'Za pobraniem',
    collectedAgain: 'Zbierane ponownie',
    collectedProductsCountDifferentThanOrdered: 'Liczba zebranych produktów różni się od zamówionych ilości.',
    commentsForCustomer: 'Uwagi od klienta',
    commentsForWarehouseman: 'Uwagi dla magazyniera',
    commentsFromWarehouse: 'Uwagi z magazynu',
    commentsRegardingOrder: 'Uwagi dotyczące zamówienia',
    commentsSaved: 'Zapisano uwagi',
    commentsToOrder: 'Uwagi do zamówienia',
    confirmationsPopup: {
      confirmationText: 'Informacja do potwierdzenia',
      iConfirm: 'Potwierdzam - kontynuuj zapis',
      notAllConfirmedText: 'Zapoznaj się z treścią wszystkich informacji i zatwierdź je aby kontynuować.',
      notAllConfirmedTitle: 'Musisz potwierdzić wszystkie informacje',
      title: 'To zamówienie wymaga weryfikacji przed zapisem - zapoznaj się z poniższymi uwagami - potwierdź je aby kontynuować zapis'
    },
    confirmOrder: 'Zatwierdzaj zamówienie',
    confirmOrderDisabled: 'Zatwierdzanie zamówienia jest wyłączone',
    connected: {
      addRelatedOrders: 'Dodaj powiązane zamówienia',
      addRelation: 'Dodaj powiązanie',
      noOrdersToAssociate: 'Brak zamówień, które można powiązać',
      selectRelatedOrder: 'Wybierz powiązane zamówienie'
    },
    connectedInvoices: 'Powiązane faktury',
    connectedOrders: 'Powiązane zamówienia',
    createdFromOfferInquiry: 'Utworzone z zapytania ofertowego',
    createInvoiceOrChangeToSent: 'WYSTAW FV VAT LUB ZMIEŃ STATUS ZAMÓWIENIA NA WYSŁANE JEŚLI NA COŚ CZEKASZ',
    creationDate: 'Data utworzenia',
    customerAndName: 'Klient i nazwa',
    customerCheck: {
      check: 'Weryfikuj dane',
      desc: 'Jeśli nie, kliknij przycisk do weryfikacji danych kontrahenta przed wystawieniem faktury',
      ok: 'Dane są poprawne',
      title: 'Czy upewniłeś się, że dane do faktury są poprawne?'
    },
    customerDiscountsDisabledDesc: 'Z powodu ręcznej zmiany ceny jednego z elementów, rabaty klienta zostały wyłączone.',
    customerDiscountsDisabledTitle: 'Wyłączono rabaty klienta',
    customerOrderDescription: 'Tekstowe zamówienie klienta',
    customerOrderNumber: 'Własna nazwa zamówienia klienta',
    customerTags: 'Tagi klienta',
    customPrice: 'Własna cena',
    customPricesResetDesc: 'W produktach i zdobieniach były ustawione własne ceny, które zostały zresetowane',
    customPricesResetTitle: 'Zresetowano własne ceny',
    customTransactionType: 'Wymuszaj rodzaj transakcji',
    dashOrderAwaitingShipping: '- zamówienia oczekujące wysyłki',
    dashReadyForShipping: '- gotowe do wysyłki',
    dataOnInvoice: 'Dane na fakturze',
    dateOfIssue: 'Data wystawienia',
    delayed: 'Opóźnione',
    delayedSamples: 'Opóźnione sample',
    deleted: 'Usunięte',
    deletedStatusCannotBeChanged: 'Tego statusu nie można cofnąć. Czy na pewno chcesz zmienić status zamówienia?',
    delivery: 'Dostawa',
    deliveryNote: 'Delivery Note / List przewozowy',
    deliveryNotesFileNamePrefix: 'dokument-dostawy-zamowienie-nr-',
    differentsPopup: {
      boxesQty: 'Sztuk w kartonach',
      orderQty: 'Sztuk w zamówieniu',
      productName: 'Nazwa produktu',
      title: 'Znalezione różnice w zamówieniu i kartonach'
    },
    dispatchCost: 'Koszt wysyłki',
    download: 'Pobierz',
    downloadOrderAttachment: 'Pobierz załącznik do zamówienia',
    downloadOrderMarkingDoc: 'Pobierz oznaczenie do zamówienia',
    downloadOrderSummary: 'Pobierz podsumowanie zamówienia',
    downloadProforma: 'Pobierz fakturę Proforma',
    downloadStock: 'Pobierz stan produktów',
    downloadXls: 'Pobierz XLS',
    doYouReallyWantToChangeOrderSatus: 'Czy na pewno chcesz zmienić status zamówienia?',
    doYouWantToUpdatePrices: 'Czy na pewno chcesz zaktualizować ceny?',
    doYouWantToUpdatePricesDesc: 'Wszystkie ceny produktów i zdobień zostaną zaktualizowane zgodnie z aktualnymi cennikami.',
    duplicatePopup: {
      copyFiles: 'Duplikuj wraz z plikami',
      duplicateOrder: 'Duplikuj zamówienie',
      text: 'Czy chcesz zduplikować to zamówienie wraz z załączonymi do niego plikami? <br><br><span style="color:red;">SPRAWDŹ CZY NIE TRZEBA ZAKTUALIZOWAĆ CEN</span>',
      title: 'Duplikowanie zamówienia'
    },
    editInProgressBy: 'Edytowane przez {user}',
    ended: 'Zakończone',
    enterOrderNumber: 'Podaj numer zamówienia',
    erp: {
      excludeFailedDesc: 'To zamówienie zostało wyłączone z integracji z ERP',
      excludeFailedTitle: 'Wyłączono z integracji z ERP',
      excludeFrom: 'Wyłącz z integracji z ERP',
      includeFailedDesc: 'To zamówienie zostało włączone do integracji z ERP',
      includeFailedTitle: 'Włączono do integracji z ERP',
      includeTo: 'Włącz do integracji z ERP',
      integratedWithErp: 'Zintegrowano z ERP',
      isErpSynchronised: 'Zintegrowano z ERP?',
      isExcluded: 'Wyłączono z integracji z ERP',
      latestQuery: 'Ost. status integracji z ERP',
      latestQueryStatus: {
        DONE: 'Zintegrowano',
        ERROR: 'Błąd',
        QUEUED: 'Oczekuje',
        WAITING: 'Oczekuje'
      },
      notIntegratedWithErp: 'Nie zintegrowano z ERP',
      popup: {
        action: 'Akcja',
        actions: {
          ADD_ORDER: 'Dodawanie zamówienia',
          DELETE_ORDER: 'Usunięcie zamówienia',
          DELETE_PURCHASE: 'Usunięcie zakupu',
          GENERATE_GNR_FOR_PURCHASE: 'Wygenerowanie PZ',
          GENERATE_INVOICE: 'Wygenerowanie faktury',
          INSERT_PURCHASE: 'Dodanie zakupu',
          SEND_ORDER: 'Wysłanie zamówienia',
          UPDATE_ORDER: 'Aktualizacja zamówienia',
          UPDATE_PURCHASE: 'Aktualizacja zakupu'
        },
        errorMessage: 'Komunikat błędu',
        queryStartedAt: 'Data zapytania',
        status: 'Status',
        title: 'Historia integracji z ERP'
      }
    },
    errorDuringLoadingShippingPrice: 'Wystąpił błąd podczas ładowania cen dostawy. Zweryfikuj cenę dostawy.',
    errors: {
      block_erp_invoice_request: 'Do tego zamówienia została wystawiona zaliczka. Wystaw fakturę końcową z ERP Optima',
      container_not_closed: 'Kontener nie został zamknięty',
      empty_prices: 'Uzupełnij ceny przed wystawieniem faktury',
      empty_receiver_email: 'Brak adresu e-mail odbiorcy faktury',
      empty_tracking_number: 'Brak numeru trakingowego',
      exclude_from_erp_integration: 'To zamówienie jest wykluczone z integracji z ERP',
      invalid_address_country_prefix: 'Niepoprawny prefix kraju w adresie dostawy',
      invalid_invoice_country_prefix: 'Niepoprawny prefix kraju w danych do faktury',
      invalid_status: 'Niepoprawny status zamówienia',
      invoice_exists: 'Faktura do tego zamówienia już została wystawiona',
      invoice_request: 'Żądanie faktury zostało już zlecone',
      not_synchronized: 'Zamówienie nie zostało jeszcze zsynchronizowane z Softlabem',
      purchase_not_closed: 'Zamówieniu od dostawcy nie zostało zamknięte',
      shipping_price_not_fetched: 'Nie udało się zaktualizować ceny dostawy. Zweryfikuj cenę dostawy.'
    },
    estimatedShippmentDate: 'Szacowany termin wysyłki',
    evidence: 'Historia zmian',
    evidenceInfoAvailableAfterSave: 'Historia zmian, będzie dostępna po zapisaniu zamówienia',
    evidencePopup: {
      amount: 'Ilość',
      price: 'Cena',
      productName: 'Nazwa produktu',
      serviceName: 'Nazwa zdobienia',
      title: 'Stan zamówienia z '
    },
    excludeFromInvoiceReminder: 'Wyklucz z wysyłki przypomnień o fakturach',
    excludeInInvoice: 'Nie wysyłaj do ERP',
    executionDate: 'Termin realizacji',
    executionTime: 'Czas realizacji',
    exisitngProductsInHplOrder: 'W zamówieniu HPL istnieją powiązane produkty',
    files: {
      addFile: 'Dodaj plik(i)',
      addFiles: 'Dodaj pliki',
      addingFile: 'Dodawanie pliku',
      cancelAddingFile: 'Anuluj dodawanie pliku',
      cannotAddFiles: 'Pliki można dodawać tylko do zamówień, które są zapisane. Zapisz zamówienie aby dodać pliki.',
      cannotAddServiceFiles: 'Pliki można dodawać tylko do zdobień, które są zapisane. Zapisz zamówienie aby dodać pliki.',
      deleteFile: 'Usuń plik',
      editFile: 'Edytuj plik',
      editFileText: 'Podaj zaktualizowany opis pliku',
      editFileTitle: 'Zmiana opisu pliku',
      fileEditedTitle: 'Plik został zedytowany',
      fileEditError: 'Wystąpił błąd podczas edycji pliku. Spróbuj ponownie.',
      fileName: 'Opis pliku',
      fileNameCannotBeEmpty: 'Opis pliku nie może być pusty',
      noFilesToDisplay: 'Brak plików powiązanych z tym zamówieniem',
      noServiceFilesToDisplay: 'Brak plików powiązanych z tym zdobieniem',
      removeFileDesc: 'Tej operacji nie można cofnąć',
      removeFileTitle: 'Czy na pewno chcesz usunąć ten plik?',
      selectFileToUpload: 'Wybierz plik(i) do dodania',
      title: 'Pliki przypisane do zamówienia',
      uploadError: 'Wystąpił błąd podczas dodawania pliku'
    },
    forAcceptance: 'Do akceptacji',
    forceInvoiceRequestAnyway: 'Wystaw fakturę mimo to',
    forFree: 'Produkt gratisowy',
    foundDifferencesInCollectedProductsQuantity: 'Wykryto różnice w ilości zebranych produktów',
    freeDelivery: 'Darmowa dostawa',
    gusComparision: {
      dataFromGus: 'GUS',
      dataFromOrder: 'Zamówienie',
      dataInCustomer: 'Obecne dane klienta w systemie',
      dataOkContinue: 'Dane poprawne, kontynuuj',
      rowTitle: {
        city: 'Miasto',
        houseNumber: 'Nr lokalu',
        name: 'Nazwa',
        postCode: 'Kod pocztowy',
        street: 'Ulica',
        streetNumber: 'Nr budynku',
        taxNumber: 'NIP'
      },
      title: 'Porównanie danych do faktury w zamówieniu i GUS',
      titleNoComparision: 'Aktualne dane do faktury klienta',
      update: 'Zaktualizuj dane u klienta i w zamówieniu',
      updateOnlyCustomer: 'Zaktualizuj dane u klienta'
    },
    hafciarnia: {
      dateOfTransferToHafciarnia: 'Data przekazania do Hafciarni',
      embrioderyLogs: {
        action: 'Akcja',
        actionType: {
          add_sample: 'Dodanie próby',
          add_status: 'Dodany status',
          synchronize: 'Synchronizacja zamówienia',
          synchronize_embroidery_return: 'Rejestracja zwrotu produktów z Hafciarni',
          synchronize_files: 'Synchronizacja plików',
          synchronize_production_ended: 'Synchronizacja daty zakończenia produkcji'
        },
        createdAt: 'Data utworzenia logu',
        source: 'Źródło',
        sourceType: {
          order: 'Zamówienie',
          product: 'Produkt',
          service: 'Zdobienie'
        },
        status: 'Status'
      },
      embrioderyReturns: {
        createdAt: 'Data utworzenia zwrotu',
        products: 'Zwracane produkty',
        status: 'Status zwrotu',
        statuses: {
          receivedInHPL: 'Otrzymano zwrot w HPL',
          returned: 'Zwrócono z Hafciarni',
          toReturn: 'Przygotowanie zwrotu w Hafciarni'
        }
      },
      hafciarnia: 'Hafciarnia',
      listOfOordersInHafciarnia: 'Lista zamówień w Hafciarni',
      noHafciarniaIdInfo: 'Brak ID zamówienia w Hafciarnia - nie można wygenerować odnośnika do zamówienia w Hafciarni.',
      notSynced: 'Nie zsynchronizowano',
      orderInHafciarnia: 'Zamówienie w Hafciarni',
      ordersInHafciarnia: 'Zamówienia w Hafciarni',
      sendAgainToEmbroidery: 'Wyślij ponownie do Hafciarni',
      sendingAgainToEmbroideryDesc: 'Zamówienie wysłano ponownie do hafciarni',
      sendingAgainToEmbroideryTitle: 'Wysłano ponownie do hafciarni',
      sendToHafciarnia: 'Wyślij do Hafciarni',
      sendToHafciarniaErrorText: 'Wystąpił błąd podczas wysyłania zamówienia do Hafciarni. Spróbuj ponownie.',
      sendToHafciarniaSuccessText: 'Zamówienie zostanie dodane w Hafciarni w ciągu kilku minut.',
      sendToHafciarniaSuccessTitle: 'Zamówienie wysłano do Hafciarni',
      syncDate: 'Data synchronizacji',
      synced: 'Zsynchronizowano',
      syncInProgress: 'W trakcie synchronizacji'
    },
    hasIECommunicate: 'IE KOŃCOWY - TAK',
    hasNoSaleProducts: 'Nie zawiera produktów wyprzedażowych',
    hasNoSpecialRequirement: 'Brak specjalnych wymagań',
    hasNotIECommunicate: 'IE KOŃCOWY - NIE',
    hasSaleProducts: 'Tak, zawiera produkty wyprzedażowe',
    hasSaleProductsQuestion: 'Zawiera produkty wyprzedażowe?',
    hasSpecialRequirement: 'Ma specjalne wymagania',
    hasSpecialRequirementMark: 'Specjalne wymagania?',
    hasSpecialRequirementsWarning: 'Uwaga! W tym zamówieniu określono specjalne wymagania',
    hasSpecialRequirementsWarningPopupDesc: 'KLIENT MA USTAWIONE SPECJALNE WYMAGANIA - SPRAWDŹ',
    hasSpecialRequirementsWarningPopupTitle: 'UWAGA!',
    history: 'Historia',
    iAcceptOrder: 'Przyjmuję zamówienie',
    ieCommunicate: 'Komunikat eksportowy IE KOŃCOWY',
    iefiles: {
      addFile: 'Dodaj plik(i)',
      addFiles: 'Dodaj pliki',
      addingFileFinal: 'Dodaj pliki dla "Komunikat końcowy"',
      addingFileInitial: 'Dodaj pliki dla "Komunikat początkowy"',
      cancelAddingFile: 'Anuluj dodawanie pliku',
      cannotAddFiles: 'Pliki można dodawać tylko do zamówień, które są zapisane. Zapisz zamówienie aby dodać pliki.',
      cannotRemoveLastInitialFile: 'Jeśli istnieją pliki dla "Komunikat końcowy", musi istnieć co najmniej jeden plik dla "Komunikat początkowy". Usuń wszystkie pliki dla "Komunikat końcowy" aby móc usunąć wszystkie pliki dla "Komunikat początkowy".',
      deleteFile: 'Usuń plik',
      noFilesToDisplay: 'Brak plików powiązanych z tym zamówieniem',
      removeFileDesc: 'Tej operacji nie można cofnąć',
      removeFileTitle: 'Czy na pewno chcesz usunąć ten plik?',
      selectFileToUpload: 'Wybierz plik(i) do dodania',
      title: 'Pliki komunikatów eksportowych IE599',
      uploadError: 'Wystąpił błąd podczas dodawania pliku'
    },
    indent: {
      selectWarehouse: 'Wybierz magazyn',
      warehouse: 'Magazyn właściwy'
    },
    indentOffers: 'Oferty Indent',
    indentOfferServicesDescription: 'Dodatkowy opis dla zdobień Indent',
    inProduction: 'W produkcji',
    inquiryName: 'Nazwa zapytania',
    inquirySubmissionDate: 'Data złożenia zapytania',
    invalidGlobalServicesSums: 'Nieprawidłowo rozpisane zdobienia globalne',
    invalidGlobalServicesSumsIntro: 'Poniższe zdobienia globalne posiadają za mało lub za dużo przypisanych produktów:',
    invalidShippingCostDesc: 'Nieprawidłowa konfiguracja zamówienia: koszt spedycji wynosi 0, a darmowa dostawa jest wyłączona.',
    invalidShippingCostTitle: 'Nieprawidłowy koszt dostawy',
    invoice: {
      advanceInvoiceAmount: 'Kwota faktury zaliczkowej',
      diffPopup: {
        invoice_building: 'Numer budynku',
        invoice_city: 'Miasto',
        invoice_country_prefix: 'Kod kraju',
        invoice_locale: 'Numer lokalu',
        invoice_name: 'Nazwa na fakturze',
        invoice_postcode: 'Kod pocztowy',
        invoice_street: 'Ulica',
        invoice_tax_number: 'NIP / VAT ID'
      },
      issueAnAdvanceInvoice: 'Wystaw fakturę zaliczkową'
    },
    invoiceCountryPrefixIsRequiredForInvoice: 'Brakujące informacje o kliencie',
    invoiceCountryPrefixIsRequiredForInvoiceDesc: 'Wybrany klient nie posiada określonego w danych faktury prefiksu kraju. Należy przejść do edycji klienta powiązanego z zamówieniem i zaktualizować dane. Następnie należy wrócić do zamówienia i kliknąć przycisk "Aktualizuj dane klienta na fakturze"',
    invoiceCustomerValue: 'Aktualne dane klienta',
    invoiceDataUpdated: 'Zaktualizowano dane',
    invoiceDataUpdatedDesc: 'Dane klienta do faktury zostały zaktualizowane.',
    invoiceDiffPopupDesc: 'Zweryfikuj czy dane do faktury w zamówieniu są poprawne. Jeśli nie - zamknij ten popup i kliknij przycisk "Aktualizuj dane klienta na fakturze"',
    invoiceDiffPopupTitle: 'Aktualne dane klienta do faktury różnią się od tych zapisanych w zamówieniu',
    invoiceField: 'Nazwa wartości',
    invoiceOrderValue: 'Dane w zamówieniu',
    invoicePdf: 'Faktura (PDF)',
    invoiceRequestCancel: 'Cofnij żądanie<br> wystawienia faktury',
    invoiceRequestCancelError: 'Wystąpił błąd podczas cofania żądania wystawienia faktury',
    invoiceRequestCancelText: 'Żądanie cofnięcia faktury zostało cofnięte',
    invoiceRequestCancelTitle: 'Cofnięto żądanie wystawienia faktury',
    invoiceRequestSent: 'Wysłano żądanie<br> wystawienia faktury',
    invoiceRequestSentText: 'Wysłano żądanie wystawienia faktury',
    invoiceRequestStatusQuestionMark: 'Wysłano żądanie wystawienia faktury?',
    invoicesInfoAvailableWhenOfferIsInquiry: 'Dane o fakturach będą dostępne gdy oferta stanie się zamówieniem',
    invoicesIssued: 'Wystawionych faktur',
    invoiceZip: 'Faktura (ZIP)',
    isBoxMarking: 'BOX MARKING',
    isContractor: 'Wykonawca?',
    isDelayed: 'Opóźnione?',
    isDelayedSample: 'Opóźnione sample?',
    isPriority: 'Priorytetowe?',
    isRepeated: 'Zamówienie powtórne',
    isSpecialRequirement: 'Specjalne wymagania',
    issueAnInvoice: 'Wystaw fakturę',
    isVirtual: 'Zamówienie wirtualne',
    isWorker: 'Pracownik?',
    itemDuplicateError: 'Wystąpił błąd podczas duplikowania',
    itemDuplicateSuccess: 'Zduplikowano wybraną pozycję',
    lastChange: 'ost. zmiana',
    lastItemModified: 'Ostatnio zmieniane',
    lastItemViewed: 'Ostatnio oglądane',
    lastSendReminderDate: 'Ost. wysłane przypomnienie',
    leaveWithoutSave: 'Wyjdź bez zapisywania',
    loadHistoryOfChanges: 'Wczytaj historię zmian',
    lock: {
      configureOrderLock: 'Konfiguruj blokadę zamówienia',
      dateOfBlocking: 'Data założenia blokady',
      dateOfProductsReturn: 'Data zwrotu produktów',
      noLock: 'Brak blokady',
      orderLock: 'Blokada zamówienia',
      returnPrductWarningInfo: 'Po zwrocie produktów zamówienie zmieni status na \"Do zebrania\"',
      unBlock: 'Zdejmij blokadę',
      warehousemanReturningProducts: 'Magazynier zwracający produkty'
    },
    lockOrder: 'Zablokuj edycję',
    lockSuccessText: 'Możliwość edycji tego zamówienia została zablokowana',
    lockSuccessTitle: 'Edycja zamówienia zablokowana',
    markingFileNamePrefix: 'oznaczenie-zamowienie-nr-',
    modificationDate: 'Data modyfikacji',
    moq: 'MOQ',
    nameCheck: {
      inProgress: 'Sprawdzam nazwę zamówienia',
      inUse: 'Wybrana nazwa zamówienia jest już w użyciu przez inne zamówienia.',
      inUseCTA: 'Zobacz te zamówienia ({count})',
      isAvailable: 'Wybrana nazwa zamówienia jest dostępna',
      popup: {
        id: 'ID',
        lastModified: 'Ostatnia zmiana',
        name: 'Nazwa',
        status: 'Status',
        title: 'Zamówienia o tej samej nazwie'
      }
    },
    newOffer: 'Nowa oferta',
    newOrdersQuestionMark: 'Nowe zamówienia?',
    noAddresses: 'Brak adresów',
    noAddressesForThisClient: 'Brak adresów przypisanych do klienta.',
    noAddressFound: 'Brak wybranego adresu',
    noAdvanceInfo: 'Brak zaliczki, nie wysyłać towaru, nie wystawiać faktury',
    noConnectedOrders: 'Brak powiązanych zamówień',
    noContactPeople: 'Brak osób kontaktowych',
    noContactPeopleAssignedToClient: 'Brak osób przypisanych do klienta.',
    noFile: 'Brak pliku',
    noInvoice: 'Brak faktury',
    noInvoicesConnectedToOrder: 'Brak faktur powiązanych z tym zamówieniem',
    nonExistingCustomerText: 'Klient, który był przypisany do tego zamówienia, został usunięty. Należy na nowo ustawić klienta w zamówieniu.',
    nonExistingCustomerTitle: 'Wybrany klient nie istnieje',
    noOfferInquriesToDisplay: 'Brak zapytań ofertowych do wyświetlenia',
    noOffersOrOrdersToDisplay: 'Brak ofert i zamówień do wyświetlenia',
    noOrderMatchingPhraseFound: 'Brak zamówień pasujących do podanej frazy',
    noPriority: 'Bez priorytetu',
    noProductsOrServicesIn: 'Brak produktów i zdobień w',
    noRemindersSent: 'Brak wysłanych przypomnień',
    noSettlementsText: 'Ustawienie statusu na Zakończone spowoduje zakończenie integracji z ERP. Czy na pewno zmienić status zamówienia?',
    noSettlementsTitle: 'Brak wystawionych faktur',
    noTagsMatchingGivenPhrase: 'Brak cech pasujących do podanej frazy',
    notAllProductsHaveItemsInCartonInfoWarning: 'Nie wszystkie produkty z zamówienia posiadają informację o ilości sztuk w kartonie - potrzebna ilość kartonów może być wyższa niż zalecana.',
    notChanged: 'Nie zmienione zamówienia',
    notDelayedSamples: 'Bez opóźnionych sampli',
    notRepeated: 'Bez zamówień powtórnych',
    number: 'Numer',
    numberOfOrderdItems: 'Liczba zamawianych sztuk',
    numberOfOrderdProducts: 'Liczba zamawianych produktów',
    numberOfOrderdServices: 'Liczba zamawianych zdobień',
    offerAccusative: 'ofertę',
    offerClosed: 'Nieaktualna oferta',
    offerFileNamePrefix: 'oferta-nr-',
    offerInquiriessList: 'Lista zapytań ofertowych',
    offerLanguage: 'Język oferty',
    offerLoading: 'Trwa wczytywanie oferty',
    offers: 'Oferty',
    offersAndOrders: 'Oferty i Zamówienia',
    offersList: 'Lista ofert',
    offersListIndent: 'Lista ofert Indent',
    offersToCheck: 'Oferty do sprawdzenia',
    offerSubmissionDate: 'Data złożenia oferty',
    offerSummaryFileNamePrefix: 'podsumowanie-oferta-nr-',
    okIUnderstand: 'Ok, rozumiem',
    optionInvoiceRequestNotSent: 'Nie wysłano żądania wystawienia faktury',
    optionInvoiceRequestSent: 'Wysłano żądanie wystawienia faktury',
    orderAccusative: 'zamówienie',
    orderAssignedTo: 'Zamówienie przypisane do',
    orderChangedStatus: 'Zamówienie zmienione',
    orderCollectedPartiallyOutOfStock: 'Zamówienie zebrane częściowo - wyczerpanie magazynu.',
    orderCollectErrorText: 'Przyjęcie zamówienia nie powiodło się. Spróbuj ponownie.',
    orderContainsUnavailableProducts: 'Zamówienie zawiera niedostępne produkty',
    orderCostNet: 'Koszt zamówienia (netto)',
    orderCurrency: 'Waluta zamówienia',
    orderDative: 'zamówieniu',
    orderDativeCap: 'Zamówieniu',
    orderDeleteConfirmTitle: 'Czy na pewno chcesz usunąć to zamówienie?',
    orderDeleteErrorText: 'Usuwanie zamówienia nie powiodło się. Spróbuj ponownie.',
    orderDeleteSuccessText: 'Wybrane zamówienie zostało usunięte',
    orderDeleteSuccessTitle: 'Usunięto zamówienie',
    orderFileNamePrefix: 'zamowienie-nr-',
    orderFromSupplier: 'Zamówienie od dostawcy',
    orderLoadingErrorTryAgain: 'Wystąpił błąd podczas wczytywania danych zamówienia. Spróbuj ponownie',
    orderNotExistsDesc: 'Wystąpił błąd podczas wczytywania wybranego zamówienia - prawdopodobnie to zamówienie nie istnieje, lub zostało usunięte.',
    orderNotExistsTitle: 'Nie udało się załadować wybranego zamówienia',
    orderNumber: 'Numer zamówienia',
    orderPlacedByClientMissingInfo: 'Zamówienie złożone przez Klienta. Brak uzupełnionych danych.',
    orderPreview: 'Podgląd zamówienia',
    orderProformaFileNamePrefix: 'faktura-proforma-',
    orderPurchaseProductsConfirmErrorText: 'Nie udało się potwierdzić odbioru produktów. Spróbuj ponownie',
    orders: 'Zamówienia',
    ordersCollectedPartially: 'Zamówienie zebrane częściowo',
    ordersIndent: 'Zamówienia Indent',
    ordersList: 'Lista zamówień',
    ordersListIndent: 'Lista zamówień Indent',
    orderStatus: 'Status zamówienia',
    orderSubmissionDate: 'Data złożenia zamówienia',
    orderSummaryFileNamePrefix: 'podsumowanie-zamowienie-nr-',
    ordersXlsFilename: 'lista-zamowien',
    orderTags: 'Tagi zamówienia',
    orderWontBeSentToErpDueLackOfVerifiedVIES: 'To zamówienie nie zostanie przekazane do ERP z powodu braku weryfikacji numeru VAT w VIES.',
    paymentDate: 'Data płatności',
    paymentDeadline: 'Termin płatności',
    pendingPayment: 'Oczekuje na płatność',
    pendingProductsFromSupplier: 'Oczekujące na produkty od dostawcy',
    postCodeCheckFailed: 'Weryfikacja kodu pocztowego nie powiodła się',
    preferedByClientExecutionDate: 'Preferowana przez klienta data realizacji',
    prepaidInvoice: 'Faktura zaliczkowa',
    priceChangePopup: {
      applied: 'Wprowadzone',
      globalServiceName: 'Nazwa zdobienia',
      globalServicesTitle: 'Wspólne zdobienia',
      multiplierChange: 'Zmiana mnożnika',
      notApplied: 'Pominięto',
      priceChange: 'Zmiana ceny',
      priceSetupChange: 'Zmiana ceny setup',
      productName: 'Nazwa produktu',
      productsTitle: 'Produkty',
      serviceName: 'Nazwa zdobienia',
      servicesTitle: 'Zdobienia w produktach',
      status: 'Status',
      title: 'Lista wprowadzonych zmian cen'
    },
    priority: 'Priorytetowe',
    priorityCap: 'PRIORYTET',
    priorityOrder: 'Zamówienie PRIORYTETOWE',
    problemWithInvoice: 'Problem z fakturą',
    productMinQty: 'Min. ilość',
    productsTags: 'Cechy produktów',
    puesc: {
      canChangeOrderWeight: 'Wagę zamówienia można zmienić podczas wysyłania zgłoszenia SENT_100 do PUESC',
      carrierKey: 'Klucz autoryzujący przewoźnika',
      createdAt: 'Data utworzenia',
      integrationNotAvailable: 'Integracja z PUESC jest niedostępna dla tego zamówienia',
      keys: 'Klucze',
      message: 'Dodatkowe informacje',
      noItemsToDisplay: 'Brak zgłoszeń do wyświetlenia...',
      orderChangeDetected: 'Wykryto zmiany w produktach zamówienia - zapisz zamówienie przed dodaniem zgłoszenia SENT_100 do PUESC, aby uzyskać zaktualizowaną wagę zamówienia',
      orderWeight: 'Waga zamówienia',
      recipientKey: 'Klucza autoryzujący podmiotu odbierającego',
      senderKey: 'Klucz autoryzujący podmiotu wysyłającego',
      sent100popup: {
        addRequest: 'Dodaj zgłoszenie',
        addRequestSuccessText: 'Zgłoszenie SENT_100 do PUESC zostało wysłane',
        addRequestSuccessTitle: 'Dodano zgłoszenie',
        carriageDate: 'Planowana data wysyłki',
        city: 'Miasto',
        countryCode: 'Kod kraju',
        flatNumber: 'Nr lokalu',
        houseNumber: 'Nr budynku',
        loadingSection: 'Dane adresu załadunku',
        name: 'Nazwa odbiorcy',
        postCode: 'Kod pocztowy',
        recipientSection: 'Dane odbiorcy',
        street: 'Ulica',
        taxNumber: 'NIP / VAT ID klienta',
        title: 'Dodaj zgłoszenie SENT_100 do PUESC',
        weight: 'Waga przesyłki'
      },
      sentNumber: 'Numer SENT',
      status: 'Status',
      statuses: {
        ADD_TO_PUESC: 'Oczekuje na dodanie',
        ERROR: 'Błąd',
        PUESC_INTEGRATED: 'Wysłano, oczekuje na akceptację PUESC',
        PUESC_SUCCESS: 'Zgłoszono w PUESC'
      },
      submitSent100: 'Dodaj zgłoszenie SENT_100 do PUESC',
      title: 'PUESC'
    },
    purchaseInfoInvoiceAdded: 'Fakturę wprowadzono do systemu',
    purchaseInfoInvoiceFile: 'Wystawiono fakturę',
    purchaseInfoStatus: 'Status zamówienia od dostawcy:',
    purchaseQtyNeedsCheck: 'Zmieniono ilość - upewnij się, że zamówienie u dostawcy zawiera prawidłową ilość produktów potrzebną dla realizacji tego zamówienia',
    readyForShipping: 'Gotowe do wysyłki',
    reallyWantToUpdateCustomerInvoiceData: 'Czy na pewno chcesz zaktualizować dane?',
    reallyWantToUpdateCustomerInvoiceDataDesc: 'Po wykonaniu tej operacji, dane klienta do faktury w zamówieniu zostaną zaktualizowane o najnowsze dane klienta obecne w systemie. Zamówienie po tej operacji zostanie przeładowane. Wszystkie niezapisane dane zostaną utracone.',
    recommendedCartonsNumber: 'Zalecana ilość kartonów',
    reminderDate: 'Data wysyłki przypomnienia',
    reminderErrorTitle: 'Wystąpił błąd podczas wysyłania przypomnienia. Spróbuj ponownie',
    reminderSentDesc: 'Przypomnienie zostało wysłane.',
    reminderSentTitle: 'Przypomnienie wysłane!',
    remindersList: 'Wysłane przypomnienia',
    reminderType: 'Rodzaj przypomnienia',
    reminderTypeDraft: 'Przypomnienie o projekcie',
    reminderTypeNewCustomerOrder: 'Nowe zamówienie klienta',
    reminderTypeNoSampleInIndent: 'Brak sampli w zdobieniu',
    reminderTypeNoShipperDateInIndent: 'Brak szacowanej daty wysyłki',
    reminderTypePodReminder: 'Przypomnienie o dostawie produktów',
    reminderTypeSampleNotApprovedInIndent: 'Brak akceptacji sampli',
    reminderTypeWaitingAccept: 'Przypomnienie o akceptacji wzoru',
    reminderTypeWaitingProduction: 'Przypomnienie o zakończeniu produkcji',
    reminderTypeWaitingSample: 'Przypomnienie o próbie',
    reminderTypeWorkerReminder: 'Przypomnienie do pracownika',
    remindMeAfter: 'Odłóż i przypomnij mi później:',
    removeAllProductsConfirmText: 'Wszystkie produkty i zdobienia z tej oferty zostaną usunięte.',
    removeAllProductsConfirmTitle: 'Czy na pewno chcesz usunąć wszystkie produkty?',
    removeDate: 'Usuń termin',
    repeated: 'Zamówienia powtórne',
    repeatedOrdersQuestionMark: 'Zamówienia powtórne?',
    repeatNumber: 'Numer(y) powtórzonych zamówień',
    requestForBillingInvoiceSentSuccessText: 'Wysłano żądanie wystawienia faktury rozliczeniowej',
    requestForInvoiceInAdvanceSentSuccessText: 'Wysłano żądanie wystawienia faktury zaliczkowej',
    requestInvoice: 'Wystaw fakturę',
    requestSent: 'Wysłano żądanie',
    requestSentErrorText: 'Wysłanie żądania nie powiodło się. Spróbuj ponownie.',
    requiresAdvance: 'Wymaga zaliczki',
    reservationsInContainersAndSuppliersCancelledAfterStatusChange: 'Rezerwacje w kontenerach oraz u dostawców zostaną anulowane po zmianie statusu.',
    returnToStock: 'Zwrot na stock',
    sampleRequirementDate: 'Data wymagalności sampla',
    sampleRequirementDays: 'Ilość dni do terminu',
    samplesNotRequired: 'Nie wymaga sampli',
    saveChangesBeforeLeaveDesc: 'Czy chcesz zapisać zmiany przed przejściem dalej?',
    saveChangesBeforeLeaveTitle: 'Czy zapisać zmiany?',
    saveComments: 'Zapisz uwagi',
    saveDate: 'Data zapisu zmian',
    saveOffer: 'Zapisz ofertę',
    saveOrderWithNewCustomerToRequestInvoice: 'Zapisz zmiany po zmianie klienta aby móc wystawić fakturę',
    see: 'Zobacz',
    selectExecutionTime: 'Wybierz czas realizacji',
    selectNewStatus: 'Wybierz nowy status',
    selectOrder: 'Wybierz zamówienie',
    selectTransactionType: 'Wybierz rodzaj transakcji',
    selectWarehouseman: 'Wybierz magazyniera',
    sendReminder: 'Wyślij przypomnienie',
    sent: 'Wysłane',
    sentToCustomer: 'Wysłana do klienta',
    servicesGenitive: 'Zdobień',
    servicesNotReceived: 'Nie otrzymano dekoracji',
    servicesReceived: 'Otrzymano dekoracje',
    settlementNumber: 'Numer faktury',
    shipment: 'Wysyłka',
    shipperAndAddressAreNecessaryToCalculatePrice: 'Spedytor i adres wysyłki są niezbędne do wyliczenia kosztu spedycji',
    shippingAddress: 'Adres wysyłki',
    shippingCost: 'Koszt spedycji',
    shippingCostAfterDiscount: 'Koszt spedycji po rabacie',
    shippingCostCustom: 'Dedykowany koszt spedycji',
    shippingCostPreviousVersion: 'Cena dostawy przed zmianami',
    showAddress: 'Pokaż adres',
    showAllOrders: 'Pokaż wszystkie zamówienia',
    showContact: 'Pokaż kontakt',
    showOrders: 'Pokaż zamówienia',
    showOtherWorkersData: 'Pokaż dane wszystkich pracowników',
    softlabBlockadeStatus: 'Blokada w SL',
    softlabBlockadeStatusFull: 'pełna',
    softlabBlockadeStatusPartial: 'częściowa',
    someProductsInDelivery: 'Niektóre produkty są w trakcie dostawy',
    someProductsLackAvailabilityInfoChangeAndTryAgain: 'Niektóre z wybranych produktów nie posiadają informacji o dostępności. Zmodyfikuj zamówienie i spróbuj ponownie.',
    specialConfiguration: 'Dodatkowa konfiguracja',
    specialRequirement: 'Opisz specjalne wymagania...',
    specialRequirementSetText: 'Treść specjalnych wymagań pobrano z ustawień aktualnie wybranego klienta',
    specialRequirementSetTitle: 'Ustawiono specjalne wymagania',
    statusHistory: 'Historia statusów',
    summary: 'Podsumowanie',
    summeryPreview: 'Podgląd zamówienia',
    toCheckInWarehouse: 'Do sprawdzenia w magazynie',
    toCollect: 'Do zebrania',
    toDelete: 'Do usunięcia',
    totalCost: 'Koszt całkowity',
    totalNet: 'Razem (netto)',
    trackingNumber: 'Numer trakingowy',
    trackingNumberIsLocked: 'To pole zostanie automatycznie zaktualizowane z uwagi na fakt dodania nowej przesyłki powiązanej z tym zamówieniem',
    transactionType: 'Rodzaj transakcji',
    transactionTypeFieldUnlocked: 'Odblokowano pole rodzaju transakcji',
    transactionTypeFieldUnlockedDesc: 'Należy zweryfikować czy rodzaj transakcji jest poprawny',
    transactionTypes: {
      domestic: 'Krajowa',
      eu: 'Unijna',
      export: 'Eksportowa',
      noVatEU: 'Brak VAT EU'
    },
    transactionTypeSetToDomestic: 'Zmieniono rodzaj transakcji',
    transactionTypeSetToDomesticDesc: 'Z uwagi na dane klienta, zmieniono rodzaj transakcji na krajowy',
    transactionTypeSetToDomesticDescSaveNeeded: 'To zamówienie na podstawie wybranych wcześniej danych klienta wymaga, aby transakcja była rodzaju krajowego. Zapisz zamówienie aby zachować krajowy rodzaj transakcji.',
    transactionTypeSetToExport: 'Zmieniono rodzaj transakcji',
    transactionTypeSetToExportDesc: 'Z uwagi na dane adresowe, zmieniono rodzaj transakcji na eksportowy',
    transactionTypeSetToExportDescSaveNeeded: 'To zamówienie na podstawie wybranych wcześniej danych adresowych wymaga, aby transakcja była rodzaju eksportowego. Zapisz zamówienie aby zachować eksportowy rodzaj transakcji.',
    transactionTypeSetToNoEuVAT: 'Zmieniono rodzaj transakcji',
    transactionTypeSetToNoEuVATDescSaveNeeded: 'To zamówienie na podstawie wybranych wcześniej danych adresowych wymaga, aby transakcja była rodzaju brak VAT EU. Zapisz zamówienie aby zachować ten rodzaj transakcji.',
    unblockError: 'Odblokowanie nie powiodło się. Spróbuj ponownie.',
    unblockOrder: 'Odblokuj',
    unblockOrderDesc: 'Jeśli zamówienie jest edytowane przez kogoś innego, to może zostać przez niego nadpisane. Upewnij się, że nie nadpiszesz zmian innych użytkowników systemu.',
    unblockOrderTitle: 'Odblokować zamówienie?',
    unlockOrder: 'Odblokuj edycję',
    unlockOrderNotice: 'To zamówienie jest w trybie tylko do odczytu',
    unlockSuccessText: 'Edycja zamówienia została odblokowana. Po zamknięciu tego popupu strona się odświeży i będzie można edytować to zamówienie.',
    unlockSuccessTitle: 'Odblokowano edycję',
    updateCustomerInfoOnInvoice: 'Aktualizuj dane klienta na fakturze',
    updatePricesUsingCurrentPricing: 'Aktualizuj ceny',
    useCustomPrice: 'Użyj własnej ceny',
    useThisValue: 'Zastosuj',
    waitingForShipping: 'Czeka na wysyłkę',
    waitingPurchaseProducts: 'Oczekuje na produkty',
    warehouse: {
      addCommentsForWarehouse: 'Dodaj uwagi dla magazynu',
      attachDeliveryNote: 'Dołącz Delivery Note / List przewozowy do paczki',
      boxes: {
        acceptBoxes: 'Zaakceptuj podział na kartony',
        acceptDesc: 'Po akceptacji podziału na kartony, nie będzie można go edytować.',
        acceptTitle: 'Czy na pewno chcesz zaakceptować podział?',
        addBox: 'Dodaj karton',
        addProduct: 'Dodaj produkt',
        boxesWarning: 'Edytuj podział na kartony, popraw wszystkie wartości i ponownie zapisz podział. Po zapisaniu, zatwierdź podział. Pamiętaj, że jeśli dodasz lub usuniesz karton, musisz ponownie wygenerować etykiety',
        cancelBoxes: 'Edytuj podział na kartony',
        cancelDesc: 'Po wprowadzeniu zmian w edytowanym podziale kartonów pamiętaj aby ponownie je zapisać i zaakceptować podział na kartony.',
        cancelTitle: 'Edytuj podział na kartony',
        changesHistory: 'Historia zmian',
        cheatsheet: {
          collected: 'Zebrano',
          divided: 'W kartonach',
          fromSupplier: 'Od dostawcy',
          includingSupplier: 'W tym od dostawcy',
          piecesInCarton: 'W kartonie',
          productName: 'Produkt',
          realPiecesInCarton: 'Realnie w kartonie',
          status: 'Aktualny stan podziału produktów',
          title: 'Ilość produktów w kartonie',
          toDivide: 'Do podziału',
          verified: 'Zweryfikowano'
        },
        clickToConfirmDeletion: 'Kliknij ponownie by usunąć',
        clickToConfirmReturnToStock: 'Kliknij ponownie aby zwrócić na stock',
        collected: 'Zebrano',
        collectHistory: 'Historia zbierania',
        deliveryNoteConfirmedAt: 'Potwierdzenie dołączenia dokumentu dostawy',
        deliveryNoteConfirmedBy: 'Potwierdzone przez',
        downloadAllLabels: 'Pobierz wszystkie etykiety',
        downloadLabel: 'Pobierz etykietę',
        fillLevel: 'Wypełnienie',
        generateBoxes: 'Wygeneruj propozycję podziału na kartony',
        hasDifferentInProducts: 'Zamówienie zostało zmodyfikowane. Należy zmodyfikować podział na kartony.',
        inBox: 'W kartonie',
        info: {
          boxesAlert: 'Uwaga! Wykryto różnice w liczbie produktów w kartonach w porównaniu do potrzebnej liczby produktów',
          embroideryAlert: 'Uwaga! Zgłoszono uwagi do kartonów przyjętych z hafciarni',
          embroideryComment: 'Uwagi przyjmującego karton z hafciarni',
          embroideryReceivedAt: 'Data otrzymania kartonu z hafciarni',
          embroideryReceivedBy: 'Przyjęte z hafciarni przez',
          embroiderySentAt: 'Data wysyłki kartonu do hafciarni',
          embroiderySentBy: 'Wysłane do hafciarni przez',
          shipmentSentAt: 'Data wysyłki kartonu',
          shipmentSentBy: 'Wysłane przez'
        },
        notes: 'Uwagi',
        outOfStock: 'Wyczerpanie magazynu',
        popup: {
          status: {
            logs: {
              COLLECT: 'Dodanie zbierania',
              RETURN: 'Dodanie zwrotu',
              SCAN: 'Skanowanie etykiety z kodem QR',
              VERIFY: 'Dodanie sprawdzenia'
            },
            statuses: {
              COLLECTION_COMPLETED: 'Zbieranie zakończone',
              COLLECTION_IN_PROGRESS: 'Zbieranie w trakcie',
              PREPARE_LABEL: 'Przygotowywanie etykiety',
              RETURN_COMPLETED: 'Zwrot zakończony',
              RETURN_IN_PROGRESS: 'Zwrot w trakcie',
              TO_COLLECT: 'Do zebrania',
              TO_RETURN: 'Do zwrotu',
              TO_VERIFY: 'Oczekuje na sprawdzenie',
              VERIFICATION_COMPLETED: 'Sprawdzanie zakończone',
              VERIFYING_IN_PROGRESS: 'Sprawdzanie w trakcie'
            }
          },
          table: {
            createdAt: 'Data zdarzenia',
            notes: 'Uwagi',
            quantity: 'Zebrano',
            returned: 'Zwrócono',
            status: 'Status',
            type: 'Typ akcji',
            user: 'Użytkownik',
            verified: 'Zweryfikowano'
          },
          title: {
            collections: 'Historia zbierania produktu',
            logs: 'Historia operacji dotyczących kartonu',
            returns: 'Histoia zwrotów',
            statuses: 'Historia statusów kartonu',
            verifications: 'Historia weryfikowania produktu'
          }
        },
        productNotExistsInOrder: 'Ten produkt nie występuje już w zamówieniu',
        productQtyError1: 'Zebrano więcej niż zaplanowano w kartonach',
        productQtyError2: 'W kartonach rozdysponowano za mało produktów',
        productQtyError3: 'W kartonach rozdysponowano za dużo produktów',
        productQtyError4: 'Ilość zebrana w kartonach nie zgadza się z ilością zebranych w podsumowaniu',
        productQtyError5: 'Ilość produktów od dostawców przekracza ilość w kartonach',
        productsAreNotDividedIntoBoxesYet: 'Produkty jeszcze nie są podzielone na kartony...',
        productsOver250Desc: 'Za dużo produktów w kartonie',
        productsOver250Title: 'Pojedynczy karton nie może zawierać więcej jak 250 produktów',
        productsTooMuchDesc: 'Liczba produktów w kartonach jest większa od liczby produktów w zamówieniu',
        productsTooMuchTitle: 'Za dużo produktów w kartonach',
        removeBox: 'Usuń karton',
        removeBoxProductSuccessDesc: 'Produkt został usunięty z kartonu',
        removeBoxProductSuccessTitle: 'Usunięto produkt',
        resetBoxes: 'Resetuj kartony',
        resetText: 'Obecny podział na kartony zostanie usunięty i zostanie wygenerowany na nowo.',
        resetTitle: 'Czy chcesz zresetować podział?',
        returned: 'Zwrócono',
        returnedToStockAt: 'Produkt zwrócony na stock',
        returnedToStockBy: 'przez',
        returnHistory: 'Historia zwrotów',
        returnInProgress: 'Zwrot w toku',
        saveBoxes: 'Zapisz i zaakceptuj podział na kartony',
        saveSuccessDesc: 'Pomyślne zapisano podział na kartony',
        saveSuccessTitle: 'Zapisano podział',
        seeDetails: 'Zobacz szczegóły',
        status: {
          boxesCollected: 'Zebrano kartony',
          boxesCollectedBy: 'Zbierane przez',
          boxesCollectedToday: 'Kartony zebrano dzisiaj',
          boxesReturned: 'Zwrócono kartony',
          boxesReturnedBy: 'Kartony zwrócone przez',
          boxesReturnedToday: 'Kartony zwrócono dzisiaj',
          boxesVerificationStatus: 'Status weryfikacji',
          boxesVerified: 'Kartony zweryfikowano',
          boxesVerifiedBy: 'Weryfikowane przez',
          boxesVerifiedToday: 'Kartony zweryfikowano dzisiaj',
          full: 'W pełni sprawdzone',
          partial: 'Częściowo sprawdzone',
          title: 'Status kartonów'
        },
        statusHistory: 'Historia statusów',
        title: 'Podział na kartony',
        verificationHistory: 'Historia weryfikacji',
        verified: 'Zweryfikowano',
        yesReset: 'Tak, resetuj'
      },
      collectedAll: 'Zebrane w całości',
      collectedPartially: 'Zebrane częściowo',
      collectedPartiallyOutOfStock: 'Zebrane częściowo, wyczerpanie magazynu',
      commentsForWarehouse: 'Uwagi dla magazynu',
      deliveryDocument: 'Dokument dostawy',
      deliveryNote: 'List przewozowy',
      enteredValueIsGeaterThanCurrentStock: 'Wpisana wartość jest większa <br>niż obecny stock ({valueStock} szt.) <br>lub większa niż potrzebna ilość ({valueQty} szt.)',
      iChecked: 'Sprawdziłem',
      IHaveReceivedOrderFromSupplier: 'Przyjąłem zamówienie od dostawcy',
      incorrectQuantity: 'Nieprawidłowa ilość',
      mark: 'Oznaczenie',
      notCollected: 'Nie zebrano',
      notReturned: 'Nie zwrócono',
      orderBlockedAtCustomerRequest: 'To zamówienie jest zablokowane na prośbę klienta',
      orderCancelledReturnToStock: 'Zamówienie ANULOWANE - zwrot na stock',
      orderCollectingAgain: 'To zamówienie jest zbierane ponownie.',
      orderIsAlreadyBeeingCollectedByDifferentPerson: 'To zamówienie jest już w trakcie kompletowania przez inną osobę.',
      purchases: {
        orderName: 'Nazwa',
        received: 'Odebrano',
        receivedFromSubSupplier: 'Odebrałem produkty',
        receivedFromSupplier: 'Odebrałem produkty',
        title: 'Powiązane zamówienia u dostawców'
      },
      receiveFromSupplierErrorText: 'Przyjęcie zamówienia od dostawcy nie powiodło się. Spróbuj ponownie.',
      receiveFromSupplierSuccessText: 'Zamówienie od dostawcy zostało oznaczone jako przyjęte',
      receiveFromSupplierSuccessTitle: 'Przyjęto zamówienie',
      returned: 'Zwrócono',
      returnedPartially: 'Zwrócono częściowo',
      returnedWhole: 'Zwrócono w całości',
      returnToStock: 'Zwróć na stock',
      submitCollectedSuccessText: 'Podane zamówienie zostało oznaczone jako zebrane w całości.',
      submitCollectedSuccessTitle: 'Oznaczono jako zebrane',
      submitErrorText: 'Zapis zmian nie powiódł się. Spróbuj ponownie.',
      submitPartialSuccessText: 'Podane zamówienie zostało oznaczone jako częściowo zebrane.',
      submitPartialSuccessTitle: 'Oznaczono jako częściowo zebrane',
      submitPartialWithEmptyStorageSuccessText: 'Podane zamówienie zostało oznaczone jako częściowo zebrane.',
      submitPartialWithEmptyStorageSuccessTitle: 'Oznaczono jako częściowo zebrane',
      submitReturnSuccessText: 'Podane zamówienie zostało oznaczone jako do usunięcia.',
      submitReturnSuccessTitle: 'Zwrócono produkty na stock',
      submitWaitingForProductsSccessTitle: 'Oznaczono jako oczekujące na produkty',
      submitWaitingForProductsSuccessText: 'Podane zamówienie zostało oznaczone jako oczekujące na produkty od dostawcy.',
      toStartCollectingOrderAcceptOrder: 'Aby rozpocząć kompletowanie tego zamówienia przyjmij zamówienie',
      toStartHandlingOrderReturnAcceptOrder: 'Aby rozpocząć obsługę zwrotu tego zamówienia przyjmij zamówienie',
      waitingForMerchandiseFromSupplier: 'Czeka na towar od dostawcy',
      warehouseAvailability: 'Stan magazynowy'
    },
    warehouseNewOrders: 'Tylko nowe zamówienia',
    warehouseNotNewOrders: 'Bez nowych zamówień',
    warehouseNotRepeatedOrders: 'Bez powtórnych zamówień',
    warehouseRepeatedOrders: 'Tylko powtórne zamówienia',
    weakPayerWarning: 'Uwaga! Klient jest słabym płatnikiem.',
    withDeadlineApproaching: 'którym zbliża się deadline',
    yesSave: 'Tak, zapisz zmiany',
    yesUnblock: 'Tak, odblokuj',
    yesUpdate: 'Tak, zaktualizuj dane'
  },
  potentialCustomers: {
    activityStartAt: 'Data rozpoczęcia działalności',
    addNewContact: 'Dodaj nowy kontakt z potencjalnym klientem',
    addNewPotentialCustomerContact: 'Dodaj nowy',
    address: 'Dane adresowe',
    contacts: 'Kontakty z potencjalnym klientem',
    createCustomerFromPotentialCustomer: 'Zamień na klienta',
    dataLoadedCorrectlyDesc: 'Niektóre pola zostały ustawione na bazie danych wybranego potencjalnego klienta',
    dataLoadedCorrectlyTitle: 'Wczytano dane potencjalnego klienta',
    deleteConfirmTitle: 'Czy na pewno chcesz usunąć potencjalnego klienta?',
    deleteErrorText: 'Nie udało się usunąć potencjalnego klienta. Spróbuj ponownie.',
    deleteSuccessText: 'Wybrany potencjalny klient został usunięty',
    deleteSuccessTitle: 'Usunięto potencjalnego klienta',
    description: 'Opis kontaktu',
    errorLoadingData: 'Wystąpił błąd podczas wczytywania danych potencjalnego klienta',
    exportFilename: 'potencjalni-klienci',
    noPotentialCustomersToDisplay: 'Brak potencjalnych klientów do wyświetlenia',
    otherData: 'Pozostałe dane',
    potentialCustomersLabel: 'Potencjalni klienci',
    potentialCustomersList: 'Lista potencjalnych klientów',
    potentialCustomersSearchPlaceholder: 'Wprowadź nazwę',
    potentialCustomerView: 'Potencjalny klient',
    taxNumber: 'Numer NIP / VAT ID'
  },
  price: {
    addNewPrice: 'Dodaj nową cenę',
    addNewProductPrice: 'Dodaj nową cenę produktu',
    addNewServicePrice: 'Dodaj nową cenę zdobienia',
    addNewSetupPrice: 'Dodaj nową cenę setup',
    addPrice: 'Dodaj cenę',
    addPriceErrorText: 'Dodawanie ceny nie powiodło się. Spróbuj ponownie.',
    addPriceSuccessText: 'Podana cena została zapisana',
    addPriceSuccessTitle: 'Dodano cenę',
    bruttonPrice: 'Cena brutto',
    chosenPriceIsSetupPrice: 'Podana cena jest ceną za setup',
    deletePriceConfirmTitle: 'Czy na pewno chcesz usunąć tę cenę?',
    deletePriceErrorText: 'Usuwanie ceny nie powiodło się. Spróbuj ponownie.',
    deletePriceSuccessText: 'Wybrana cena została usunięta',
    deletePriceSuccessTitle: 'Usunięto cenę',
    differentPriceMultipleFromInfo: 'Zastosowany mnożnik ceny "za sztukę od" różni się od aktualnego mnożnika ceny ({value} szt.)',
    editPrice: 'Edytuj cenę',
    export: 'Eksportuj',
    exportPrices: 'Eksportuj cenniki',
    exportSuccessfull: 'Wyeksportowano cenniki',
    exportSuccessfullDesc: 'Pomyślnie wyeksportowano cenniki',
    importPrices: 'Importuj cenniki',
    importSuccessfull: 'Zaimportowano cenniki',
    importSuccessfullDesc: 'Pomyślnie zaimportowano cenniki',
    includeSetupPrices: 'Uwzględniaj ceny setup',
    isSale: 'Wyprzedaż',
    noPricesFoundForServiceGroup: 'Nie znaleziono cenników dla wybranej grupy zdobień',
    noPricesToDisplay: 'Brak cen do wyświetlenia',
    onlyChildren: 'Tylko warianty',
    onlyPriceUpdate: 'Tylko aktualizacja cen',
    pln: 'PLN',
    plnBrutto: 'PLN brutto',
    plnNet: 'PLN netto',
    plnVat: 'PLN VAT',
    price: 'Cena',
    price25pcs: 'do 25 szt.',
    priceBeforeDicount: 'Cena przed rabatem',
    priceBox: 'Stawka od ilości',
    priceEdit: 'Edycja ceny',
    priceFirstBox: 'Pierwszy karton',
    priceFlat: 'Płaska stawka',
    priceFrom: 'Cena od',
    priceImportFrom: 'Import cen z',
    priceNet: 'Cena netto',
    priceNextBox: 'Kolejny karton',
    pricePerItem: 'Cena za sztukę',
    pricePerItemFrom: 'Cena za sztukę od {price} szt.',
    pricePerItemShort: 'Cena za szt.',
    prices: 'Ceny',
    priceSecondBox: 'Drugi karton',
    pricesList: 'Cennik',
    pricesLists: 'Cenniki',
    pricesListsLowCase: 'cenniki',
    priceTo: 'Cena do',
    productGenitive: 'produktu',
    productsPricesList: 'Lista cen produktów',
    quantityFrom: 'Ilość od',
    quantityTo: 'Ilość do',
    removeAndReplacePrices: 'Usuń ceny i dodaj na nowo',
    savePriceErrorText: 'Edycja ceny nie powiodła się. Spróbuj ponownie.',
    savePriceSuccessText: 'Wybrana cena została zmieniona',
    savePriceSuccessTitle: 'Zmieniono cenę',
    seePricelist: 'Zobacz cennik',
    serviceGenitive: 'zdobienia',
    servicesPriceList: 'Cennik zdobień',
    servicesPricesList: 'Lista cen zdobień',
    setup: 'setup',
    setupPricesList: 'Lista cen setup',
    supplierPricesFileNamePrefix: 'cenniki-dostawcy-',
    unitPricesIn: 'ceny za sztukę w',
    vat: 'VAT',
    vatRate: 'Stawka VAT',
    xlsxFileWithPrices: 'Plik XLSX z cenami'
  },
  product: {
    actually: 'Realnie',
    actualPiecesInBox: 'Realnie sztuk w kartonie',
    addingMorePhotosAvailableAfterProductSave: 'Dodawanie dodatkowych zdjęć będzie możliwe po zapisaniu produktu.',
    addingNewIndentProduct: 'Dodawanie nowego produktu Indent',
    addingNewProduct: 'Dodawanie nowego produktu HPL',
    addingProductCardsAvailableAfterProductSave: 'Dodawanie kart produktu będzie możliwe po zapisaniu produktu.',
    addingTranslationsAvailableAfterProductSave: 'Dodawanie tłumaczeń będzie możliwe po zapisaniu produktu.',
    addNewIndentProduct: 'Dodaj nowy produkt Indent',
    addNewProduct: 'Dodaj nowy produkt HPL',
    addProduct: 'Dodaj produkt',
    addMultipleProducts: 'Dodaj wiele produktów',
    addProductCard: 'Dodaj kartę produktu',
    addProductCardErrorText: 'Dodawanie karty produktu nie powiodło się. Spróbuj ponownie.',
    addProductCardSuccessText: 'Podana karta produktu została zapisana',
    addProductCardSuccessTitle: 'Dodano kartę produktu',
    addProductErrorText: 'Dodawanie produktu nie powiodło się. Spróbuj ponownie.',
    addProductSuccessText: 'Podany produkt został zapisany',
    addProductSuccessTitle: 'Dodano produkt',
    addVariant: 'Dodaj wariant',
    addVariantPopup: {
      addVariant: 'Dodaj wariant',
      addVariantErrorText: 'Wystąpił błąd podczas dodawania wariantu produktu. Spróbuj ponownie',
      addVariantSuccessText: 'Pomyślnie dodano wariant produktu',
      addVariantSuccessTitle: 'Dodano wariant',
      fieldName: 'Pole z produktu głównego',
      importPriceMethod: 'Cena',
      importPriceMethods: {
        custom: 'Własna',
        other_child: 'Z innego wariantu',
        other_product: 'Z innego produktu',
        parent: 'Z produktu głównego'
      },
      noProductsMatchingPhraseFound: 'Nie znaleziono pasujących produktów',
      noVariantsMatchingPhraseFound: 'Nie znaleziono pasujących wariantów',
      priceCode: 'Kod ceny produktu',
      selectProduct: 'Wybierz produkt',
      selectProductVariant: 'Wybierz wariant produktu',
      selectVariant: 'Wybierz wariant',
      title: 'Dodaj wariant produktu'
    },
    addVisualizationFile: 'Dodaj plik z wizualizacją',
    allProducts: 'Wszystkie produkty',
    approve: 'Zatwierdź',
    automaticallySetSamplesDates: 'Automatycznie ustawiaj daty prób',
    availabilityUpdating: 'Dostępność w trakcie aktualizacji',
    availableInPurchases: 'Dostępne w zakupach',
    availableQuantity: 'Stan',
    backToParentProduct: 'Wróć do produktu głównego',
    breakProductsIntoSeparateOffers: 'Rozbij produkty na osobne oferty',
    cannotCopyToVariantsDesc: 'Aby skopiować dane do wariantów, należy wybrać co najmniej jeden wariant produktu oraz co najmniej jedno pole do skopiowania',
    cannotCopyToVariantsTitle: 'Nie można wykonać operacji kopiowania',
    cannotRemoveDuePurchaseDesc: 'Produkt posiada rezerwację w zamówieniu u dostawcy. Aby usunąć produkt usuń najpierw rezerwację z zamówienia u dostawcy.',
    cannotRemoveDuePurchaseTitle: 'Nie można usunąć produktu',
    checkAvailabilityInContainers: 'Sprawdź dostępność w kontenerach',
    checkAvailabilityInOrders: 'Sprawdź dostępność w zamówieniach',
    chooseProduct: 'Wybierz produkt',
    collected: 'Zebrano',
    copyToVariants: 'Kopiowanie do wariantów',
    copyToVariants2: 'Skopiuj do wariantów',
    copyToVariantsFailed: 'Kopiowanie nie powiodło się',
    copyToVariantsTitle: 'Kopiowanie do wariantów',
    currentFile: 'Obecny plik',
    dataCopiedDesc: 'Wybrane dane zostały skopiowane do wybranych wariantów produktu',
    dataCopiedTitle: 'Skopiowano dane',
    defaultServicesConfirm: {
      addForMultipleText: 'Poniższe produkty posiadają domyślne zdobienia. Czy chcesz je automatycznie dodać?',
      addForMultipleTitle: 'Domyślne zdobienia',
      cannotAddDefaultServicesText: 'Domyślne zdobienia dostępne dla tego produktu nie zostaną dodane',
      cannotAddDefaultServicesTitle: 'Produkt posiada już ustawione zdobienia',
      doYouWantToAddDefaultServicesText: 'Czy chcesz je automatycznie dodać?',
      doYouWantToAddDefaultServicesTitle: 'Wybrany produkt posiada domyślne zdobienia',
      yesPleaseAdd: 'Tak, dodaj zdobienia'
    },
    deleteProductCardConfirmTitle: 'Czy na pewno chcesz usunąć wybraną kartę produktu?',
    deleteProductCardErrorText: 'Usuwanie karty produktu nie powiodło się. Spróbuj ponownie.',
    deleteProductCardSuccessText: 'Wybrana karta produktu została usunięta',
    deleteProductCardSuccessTitle: 'Usunięto kartę produktu',
    descriptionForCustomer: 'Opis dla klienta na WWW',
    disableForCustomer: 'Wyłącz w panelu klienta',
    disableForCustomerAPI: 'Wyłącz w API klienta',
    downloadVisualization: 'Pobierz wizualizację',
    doYouReallyWantCopyDataToVariantsDesc: 'Tej operacji nie można cofnąć. Z produktu bazowego, zostaną skopiowane wyłącznie dane, które zostały uprzednio zapisane. Jeśli posiadasz jakieś niezapisane zmiany, zapisz je przed operacją kopiowania.',
    doYouReallyWantCopyDataToVariantsTitle: 'Czy na pewno chcesz skopiować dane?',
    doYouWantEditPriceCode: 'Czy chcesz zmienić kod ceny?',
    doYouWantEditPriceCodeInOtherProducts: 'Czy ta zmiana ma też zmienić kod ceny w innych produktach, które używają obecnego kodu ceny?',
    eanGtinCode: 'Kod EAN / GTIN',
    editIndentProduct: 'Edycja produktu Indent',
    editProduct: 'Edycja produktu',
    editProductCard: 'Edycja karty produktu',
    editProductCardErrorText: 'Edycja karty produktu nie powiodła się. Spróbuj ponownie.',
    editProductCardSuccessText: 'Wybrana karta produktu została zmodyfikowana',
    editProductCardSuccessTitle: 'Zmodyfikowano kartę produktu',
    editProductErrorText: 'Edycja produktu nie powiodła się. Spróbuj ponownie.',
    editProductSuccessText: 'Wybrany produkt został zmodyfikowany',
    editProductSuccessTitle: 'Zmodyfikowano produkt',
    editProductVariant: 'Edycja wariantu produktu',
    embroideryEndedProductionAt: 'Koniec planowanej produkcji',
    enterAdditionalProductDescriptionForCustomerOptional: 'Wprowadź dodatkowy opis produktu dla klienta (opcjonalnie)',
    enterAdditionalProductDescriptionOptional: 'Wprowadź dodatkowy opis produktu (opcjonalne)',
    enterProductCodeForSearch: 'Wprowadź kod produktu do wyszukania',
    enterProductNameOrCode: 'Podaj nazwę lub kod produktu',
    fieldName: 'Pole',
    fileName: 'Nazwa pliku',
    fileWithProducts: 'Plik z produktami',
    globalServices: 'Zdobienia globalne',
    importantPriceInfo: 'Ważne informacje dotyczące ceny produktu',
    importantPriceInfoTitle: 'Zobacz ważne informacje dotyczące ceny tego produktu',
    importPriceMethod: {
      custom: 'Własna cena',
      other_child: 'Z innego wariantu',
      other_product: 'Z innego produktu',
      parent: 'Z produktu głównego'
    },
    includeDiscounts: 'Uwzględnij w rabatach',
    includeInServices: 'Uwzględniaj w zdobieniach',
    inContainers: 'w kontenerach',
    indentProduct: {
      cnCode: 'Kod CN',
      originCountry: 'Kraj pochodzenia',
      properties: 'Informacje',
      type: 'Typ produktu',
      types: {
        cap: 'Czapka z daszkiem',
        none: 'Brak',
        winter: 'Czapka zimowa'
      },
      weight: 'Waga'
    },
    inOrder: ' w zamówieniu',
    isSale: 'Produkt wyprzedażowy',
    isSaleInfo: 'Produkt wyprzedażowy, dostępny do wyczerpania zapasów',
    linkToDropbox: 'Link do Dropbox',
    linkToWWWPage: 'Link do strony WWW',
    lowAvailability: 'Niska dostępność',
    mainProduct: 'główny',
    minimalQty: 'Minimalna ilość',
    moveToOffer: 'Przenieś do oferty',
    noPhotosForThisProduct: 'Brak zdjęć dla tego produktu',
    noPricesDefinedForThisProduct: 'Brak cen zdefiniowanych dla tego produktu',
    noProductCardsForThisProduct: 'Brak kart produktu dla tego produktu',
    noProductsMatchingGivenPhrase: 'Brak produktów pasujących do podanej frazy',
    noProductsToDisplay: 'Brak produktów do wyświetlenia',
    notIncludedInDiscounts: 'Nie podlega rabatom',
    noTranslationsForThisProduct: 'Brak tłumaczeń dla tego produktu',
    numberOfItemsDamagedInProduction: 'Liczba sztuk uszkodzonych podczas produkcji',
    piecesInBox: 'Sztuk w kartonie',
    prductPriceCode: 'Kod ceny produktu',
    priceCodeWillBeUpdatedInOtherProducts: 'Kod ceny zostanie zaktualizowany także w innych produktach/wariantach, które używają obecnego kodu ceny',
    pricesListWillBeAvailableAfterProductSave: 'Lista cen będzie dostępna po zapisaniu produktu',
    product: 'Produkt',
    productAvailability: 'Dostępność produktu',
    productCards: 'Karty produktu',
    productCode: 'Kod produktu',
    productDefaultServices: 'Domyślne zdobienia produktu',
    productDescription: 'Opis produktu',
    productDescriptionForCustomer: 'Opis produktu dla klienta',
    productDuplicateErrorText: 'Duplikowanie produktu nie powiodło się. Spróbuj ponownie.',
    productImagesGallery: 'Galeria zdjęć produktu',
    productIncludesDefaultServices: 'Liczba domyślnych zdobień',
    productIndentBaseProduct: 'Bazowy produkt HPL',
    productName: 'Nazwa produktu',
    productPhoto: 'Zdjęcie produktu',
    productPrices: 'Ceny produktu',
    productProcesVisibleAfterProductSave: 'Ceny produktu będą widoczne po zapisaniu produktu i ich dodaniu w sekcji \"Cenniki\"',
    products: 'Produkty',
    productsApprovalList: 'Lista produktów do zatwierdzenia ze szwalni',
    productsCodes: 'Kody produktów',
    productsIndentList: 'Lista produktów Indent',
    productsList: 'Lista produktów HPL',
    productsWithSamePriceCode: 'Lista produktów/wariantów z tym samym kodem ceny',
    productTags: 'Tagi produktu',
    productTranslations: 'Tłumaczenia produktu',
    productVariantsToModify: 'Warianty produktu do zmodyfikowania',
    productVisualizationFileNamePrefix: 'wizualizacja-produktu-',
    productWithGivenCodeNotFound: 'Nie znaleziono produktu o danym kodzie',
    properties: {
      chooseProcedure: 'Wybierz procedury',
      chooseStrand: 'Wybierz nić',
      color: 'Kolor',
      material: 'Materiał',
      noSuchProcedure: 'Brak takiej procedury',
      noSuchStrand: 'Brak takiej nici',
      procedures: 'Procedury',
      sizes: 'Rozmiary',
      strand: 'Nić'
    },
    purchaseIsRequiredForZZProduct: 'Dla tego produktu, należy utworzyć/podpiąć zamówienie u dostawcy',
    quantityAvailableAtTimeOfOrdering: 'Dostępna ilość w momencie złożenia zamówienia {quantity} szt.',
    recordProductionDamage: 'Odnotuj zniszczenia przy produkcji',
    rememberAboutVariants: 'Po zapisie, upewnij się, czy nie trzeba skopiować zmian do wariantów tego produktu.',
    removeAllProducts: 'Usuń wszystkie produkty',
    removeProductConfirmTitle: 'Czy na pewno chcesz usunąć ten produkt?',
    removeProductErrorText: 'Usuwanie produktu nie powiodło się. Spróbuj ponownie.',
    removeProductSuccessText: 'Wybrany produkt został usunięty',
    removeProductSuccessTitle: 'Usunięto produkt',
    removeVariantConfirmTitle: 'Czy na pewno chcesz usunąć ten wariant?',
    removeVariantErrorText: 'Usuwanie wariantu nie powiodło się. Spróbuj ponownie.',
    removeVariantSuccessText: 'Wybrany wariant został usunięty',
    removeVariantSuccessTitle: 'Usunięto wariant',
    reservationAssignmentRemoveFail: 'Usuwanie nie powiodło się',
    reservationAssignmentRemoveFailDesc: 'Spróbuj ponownie lub sprawdź zamówienie u dostawcy',
    reservationAssignmentRemoveSuccess: 'Powiązanie usunięte',
    reservationAssignmentRemoveSuccessDesc: 'Pomyślnie usunięto powiązanie z zamówieniem u dostawcy',
    reservationRemoveAssignmentFailDesc: 'Nie udało się usunąć wybranego powiązania z zamówieniem u dostawcy',
    reservationRemoveAssignmentQuestion: 'Czy na pewno chcesz usunąć powiązanie?',
    reservationRemoveAssignmentQuestionDesc: 'Tej operacji nie można cofnąć.',
    reservationRemoveFail: 'Usuwanie nie powiodło się',
    reservationRemoveFailDesc: 'Nie udało się usunąć wybranej rezerwacji u dostawcy',
    reservationRemoveFromPurchaseErrorDesc: 'Nie udało się usunąć produktu w zamówieniu u dostawcy',
    reservationRemoveFromPurchaseFail: 'Usuwanie nie powiodło się',
    reservationRemoveFromPurchaseFailDesc: 'Spróbuj ponownie lub sprawdź zamówienie u dostawcy',
    reservationRemoveFromPurchaseQuestion: 'Czy na pewno chcesz usunąć produkt u dostawcy?',
    reservationRemoveFromPurchaseQuestionDesc: 'Tej operacji nie można cofnąć. Jeśli to jedyny produkt w zamówieniu u dostawcy to zostanie ono również usunięte.',
    reservationRemoveFromPurchaseSuccess: 'Usunięto',
    reservationRemoveFromPurchaseSuccessDesc: 'Pomyślnie usunięto produkt z zamówienia u dostawcy',
    reservationRemoveQuestion: 'Czy na pewno chcesz usunąć rezerwację?',
    reservationRemoveQuestionDesc: 'Tej operacji nie można cofnąć.',
    reservationRemoveSuccess: 'Rezerwacja usunięta',
    reservationRemoveSuccessDesc: 'Pomyślnie usunięto rezerwację u dostawcy',
    saleNoteForNonParentProduct: 'Ten parametr może być edytowany tylko w produkcie głównym',
    saleNoteForParentProduct: 'Parametr ten zostanie ustawiony także w wariantach',
    seeSamePriceCodeProducts: 'zobacz te produkty',
    selectFileWithVisualizationOptional: 'Wybierz plik z wizualizacją (opcjonalne)',
    selectProduct: 'Wybierz produkt',
    shouldBeCopied: 'Kopiować?',
    shouldBeModified: 'Modyfikować?',
    siteDescription: 'Opis na stronę WWW',
    stateHistory: {
      availableAfterProductSave: 'Historia stanów będzie dostępna po zapisaniu produktu.',
      date: 'Data',
      itemType: {
        CHANGED_IN_ORDER: 'Zmiana w zamówieniu',
        CHANGED_STOCK: 'Zmiana stanu magazynowego',
        DELETED_IN_ORDER: 'Usunięcie w zamówieniu'
      },
      loadHistory: 'Załaduj historię stanów produktu',
      order: 'Zamówienie',
      quantity: 'Stan',
      stateHistoryTitle: 'Historia stanów produktu',
      tabTitle: 'Historia stanów',
      type: 'Rodzaj zmiany'
    },
    tag: {
      addCategoryErrorText: 'Dodawanie kategorii tagów nie powiodło się. Spróbuj ponownie.',
      addCategorySuccessText: 'Podana kategoria tagów została zapisana',
      addCategorySuccessTitle: 'Dodano kategorię',
      addingTagsAvailableAfterProductSave: 'Dodawanie tagów będzie możliwe po zapisaniu produktu.',
      addNewCategory: 'Dodaj nową kategorię',
      addNewTagCategory: 'Dodawanie nowej kategorii tagów',
      addTag: 'Dodaj tag',
      addTagCategory: 'Dodaj kategorię tagów',
      categoryName: 'Nazwa kategorii',
      categoryOrderChangeErrorText: 'Nie udało się zapisać zmian kolejności kategorii',
      categoryTranslations: 'Tłumaczenia kategorii',
      deleteTagConfirmTitle: 'Czy na pewno chcesz usunąć ten tag?',
      deleteTagErrorText: 'Usuwanie tagu nie powiodło się. Spróbuj ponownie.',
      deleteTagSuccessText: 'Wybrany tag został usunięty',
      deleteTagSuccessTitle: 'Usunięto tag',
      editCategoryErrorText: 'Aktualizacja kategorii tagów nie powiodła się. Spróbuj ponownie.',
      editCategorySuccessText: 'Podana kategoria tagów została zaktualizowana',
      editCategorySuccessTitle: 'Zaktualizowano kategorię',
      editingTagCategory: 'Edycja kategorii tagów',
      editTagCategory: 'Edytuj kategorię tagów',
      enterNewTagName: 'Podaj nową nazwę taga',
      isMain: 'Kategoria główna',
      mainCategories: 'Kategorie główne',
      mainCategoriesDesc: 'Wybierz kategorie główne w ramach których kategoria "{name}" ma być wyświetlana na etapie doboru produktów w panelu klienta:',
      name: 'Nazwa tagu',
      noAvailableTags: 'Brak dostępnych tagów',
      noAvailableTagsForThisCategory: 'Brak dostępnych tagów w tej kategorii',
      noMatchingTagsFound: 'Nie znaleziono pasujących tagów',
      noTagCategoriesToDisplay: 'Brak kategorii tagów do wyświetlenia',
      noTagsInThisCategory: 'Brak tagów w tej kategorii',
      noTranslationsForThisTagCategory: 'Brak tłumaczeń dla tej kategorii tagów',
      noTranslationsForThisTags: 'Brak tłumaczeń dla tagów w tej kategorii tagów',
      numberOfTags: 'Ilość tagów',
      productTags: 'Tagi produktu',
      removeCategoryConfirmTitle: 'Czy na pewno chcesz usunąć tę kategorię?',
      removeCategoryErrorText: 'Usuwanie kategorii nie powiodło się. Spróbuj ponownie.',
      removeCategorySuccessText: 'Wybrana kategoria została usunięta',
      removeCategorySuccessTitle: 'Usunięto kategorię',
      showAsList: 'Pokazuj jako listę',
      showAsTree: 'Pokazuj hierarchię kategorii',
      tagAddedSuccessText: 'Podany tag został dodany',
      tagAddedSuccessTitle: 'Dodano tag',
      tagCategoriesList: 'Lista kategorii tagów',
      tagEditSuccessText: 'Podany tag został zmieniony',
      tagEditSuccessTitle: 'Zmieniono tag',
      tagManagemnetAvailableAfterCategorySave: 'Zarządzanie tagami będzie dostępne po zapisaniu kategorii.',
      tagNameCannotBeEmpty: 'Nazwa tagu nie może być pusta',
      tagTranslations: 'Tłumaczenia tagów',
      withoutMainCategory: 'Kategorie bez kategorii głównej'
    },
    totalProductsCostNet: 'Łączny koszt produktów (netto)',
    usedByXOtherProducts: 'Liczba produktów i wariantów używających tego samego kodu ceny: {count}',
    valuesToUseInVariants: 'Wartości do skopiowania do wariantów',
    variantProduct: 'wariant',
    variants: 'Warianty',
    variantsCount: 'Wariantów',
    variantValuesWillBeReplacedDuringCopyOperation: 'Dane w wariantach zostaną ZASTĄPIONE na dane z obecnego produktu podczas operacji kopiowania do wariantów.',
    visualizationTemplate: 'Szablony do wizualizacji',
    yesCopyData: 'Tak, skopiuj dane',
    youMustSaveOrderToSaveReservations: 'Uwaga! Aby powyższe zmiany w rezerwacjach zostały zapisane, musisz zapisać zamówienie.'
  },
  productCategories: {
    addCategory: 'Dodaj kategorię',
    addCategoryErrorText: 'Wystąpił błąd podczas dodawania kategorii...',
    addCategorySuccessText: 'Dodano kategorię',
    addCategorySuccessTitle: 'Pomyślnie dodano nową kategorię...',
    additionalCategories: 'Kategorie dodatkowe',
    addTranslation: 'Dodaj tłumaczenie',
    categories: 'Kategorie',
    editCategory: 'Edytuj kategorię',
    editCategoryErrorText: 'Wystąpił błąd podczas edycji kategorii...',
    editCategorySuccessText: 'Zmodyfikowano kategorię',
    editCategorySuccessTitle: 'Wybrana kategoria została pomyślnie zmodyfikowana',
    mainCategory: 'Kategoria główna',
    name: 'Nazwa kategorii',
    noCategoriesToDisplay: 'Brak kategorii produktów do wyświetlenia...',
    noMainCategory: 'Brak kategorii głównej',
    noParentCategory: 'Brak kategorii nadrzędnej',
    noTranslationsForThisCategory: 'Brak tłumaczeń kategorii do wyświetlenia...',
    parentCategory: 'Kategoria nadrzędna',
    removeCategoryConfirmTitle: 'Czy na pewno chcesz usunąć wybraną kategorię?',
    removeCategoryErrorText: 'Wystąpił błąd podczas usuwania kategorii...',
    removeCategorySuccessText: 'Wybrana kategoria produktów została pomyślnie usunięta.',
    removeCategorySuccessTitle: 'Usunięto kategorię',
    selectMainCategory: 'Wybierz kategorię główną',
    title: 'Kategorie produktów',
    translations: 'Tłumaczenia'
  },
  purchase: {
    addCommentsToOrder: 'Dodaj uwagi do zamówienia',
    addingOrderInProgress: 'Trwa dodawanie zamówienia',
    addNew: 'Dodaj nowe',
    addOrder: 'Dodaj zamówienie',
    addOrderErrorText: 'Dodawanie zamówienia nie powiodło się. Spróbuj ponownie.',
    addOrderErrorTitle: 'Wystąpił błąd podczas dodawania zamówienia',
    addOrderForProduct: 'Dodaj zamówienie na produkt',
    addOrderSuccessText: 'Podane zamówienie zostało dodane',
    addOrderSuccessTitle: 'Dodano zamówienie',
    addProductOrderSuccessText: 'Zamówienie na wybrany produkt zostało dodane.',
    addProductOrderToOrderSuccessText: 'Zamówienie na wybrany produkt zostało dodane do wybranego zamówienia.',
    addProductOrderToOrderSuccessTitle: 'Dodano do zamówienia',
    addProductsToExistingOrder: 'Dołącz produkty do istniejącego zamówienia',
    addProductToOrderErrorTitle: 'Wystąpił błąd podczas dodawania produktu do zamówienia',
    allProductsReceived: 'Przyjęto wszystkie produkty',
    assignProductToExistingOrder: 'Przypisz produkt do istniejącego zamówienia',
    available: 'Dostępne',
    awaitingPayment: 'Oczekujące na płatność',
    awaitingProducts: 'Oczekujące na produkty',
    bookIt: 'Rezerwuj',
    closed: 'Zamknięte',
    closeOrder: 'Zamknij zamówienie',
    contains: 'zawiera',
    customerType: 'Wykonawca',
    customerTypeCustomer: 'Wykonawca 2',
    customerTypeSubCustomer: 'Wykonawca 1',
    description: 'Opis',
    downloadFile: 'Pobierz plik',
    downloadInvoice: 'Pobierz fakturę',
    editOrder: 'Edytuj zamówienie',
    editOrderErrorText: 'Edycja zamówienia nie powiodła się. Spróbuj ponownie.',
    editOrderSuccessText: 'Podane zamówienie zostało zmodyfikowane',
    editOrderSuccessTitle: 'Zapisano zamówienie',
    enterInvoiceNumber: 'Podaj numer faktury',
    enterOrderName: 'Podaj nazwę zamówienia',
    erpNumber: 'Numer PZ',
    existingOrdersDesc: 'Dla wybranej konfiguracji wykonawców istnieją zamówienia do których można dodać ten produkt. Czy na pewno chcesz utworzyć nowe zamówienie?',
    existingOrdersPleaseAdd: 'Tak, utwórz',
    existingOrdersTitle: 'Istnieją już zamówienia, których można użyć',
    fabric: {
      addFabricColorErrorText: 'Wystąpił błąd podczas dodawania koloru materiału',
      addFabricColorSuccessText: 'Dodano nowy kolor materiału dla szwalni',
      addFabricColorSuccessTitle: 'Dodano kolor materiału',
      addFabricErrorText: 'Wystąpił błąd podczas dodawania materiału',
      addFabricSuccessText: 'Dodano nowy materiał dla szwalni',
      addFabricSuccessTitle: 'Dodano materiał',
      chooseColor: 'Wybierz kolor',
      chooseFabric: 'Wybierz materiał',
      color: 'Kolor',
      fabric: 'Materiał',
      fabricColor: 'Kolor materiału',
      noSuchColor: 'Brak takiego koloru',
      noSuchFabric: 'Brak takiego materiału'
    },
    fileDeletedDesc: 'Wybrany plik został usunięty',
    fileDeletedTitle: 'Plik usunięto',
    finished: 'Zrealizowane',
    fleece: {
      addFleeceErrorText: 'Wystąpił błąd podczas dodawania polaru',
      addFleeceSuccessText: 'Dodano nowy polar dla szwalni',
      addFleeceSuccessTitle: 'Dodano polar',
      chooseFleece: 'Wybierz polar',
      fleece: 'Polar',
      noSuchFleece: 'Brak takiego polaru'
    },
    forceOrderClose: 'Wymuś zamknięcie',
    forceOrderCloseConfirmText: 'Czy na pewno chcesz wymusić zamknięcie tego zamówienia? Warunki wymagane do poprawnego zamknięcia zamówienia NIE będą weryfikowane w tym wypadku.',
    forceOrderCloseConfirmTitle: 'Wymuszenie zamknięcia zamówienia',
    forceOrderCloseErrorText: 'Wymuszenie zamknięcia zamówienia nie powiodło się. Spróbuj ponownie.',
    inOrder: 'W zamówieniu',
    invoiceDate: 'Data faktury (Wykonawca 2)',
    invoiceFile: 'Plik faktury (Wykonawca 2)',
    invoiceFileNamePrefix: 'faktury',
    invoiceNumber: 'Numer faktury (Wykonawca 2)',
    new: 'Nowe',
    newOrder: 'Nowe zamówienie',
    noDeliveryDate: 'Brak daty dostawy',
    noOrdersToDisplay: 'Brak zamówień do wyświetlenia',
    noOrdersWithSufficientProductQuantityFound: 'Nie znaleziono zamówień u dostawców z wystarczającą ilością wybranego produktu.',
    noPeopleAssignedToSupplier: 'Brak osób przypisanych do dostawcy.',
    noPurchases: 'Brak zakupów',
    noPurchasesMatchingPhrase: 'Brak zakupów pasujących do podanej frazy',
    noSewingRoomLogs: 'Brak informacji o synchronizacji ze szwalnią',
    noSuchOrder: 'Brak takiego zamówienia',
    noSupplierMarchingPhraseFound: 'Brak dostawców pasujących do podanej frazy',
    notifications: {
      createdAt: 'Data wysyłki',
      emailNotifications: 'Wysłane powiadomienia',
      noEmailNotifications: 'Brak wysłanych powiadomień',
      receiver: 'Odbiorca',
      sendingType: 'Sposób wysyłki',
      sendingTypes: {
        AUTO: 'automatycznie',
        MANUALLY: 'ręcznie'
      },
      type: 'Typ',
      types: {
        PRODUCTS_REMINDER: 'Przypomnienie o dostarczeniu produktów',
        SUPPLIER_INVOICE: 'Prośba o wystawienie faktury'
      },
      userName: 'Pracownik'
    },
    notificationSentDesc: 'Powiadomienie o zmianach zostało wysłane do dostawcy',
    notificationSentTitle: 'Powiadomienie wysłane',
    numberOfOrders: 'Liczba zamówień',
    numberOfPiecesNeeded: 'Liczba potrzebnych sztuk',
    orderCloseErrorText: 'Zamknięcie zamówienia nie powiodło się.',
    orderCloseErrorTextTryAgain: 'Zamknięcie zamówienia nie powiodło się. Spróbuj ponownie.',
    orderCloseErrorTitle: 'Nie udało się zamknąć zamówienia',
    orderIDInSewing: 'ID zamówienia (Wykonawca 2)',
    orderIDInSubSewing: 'ID zamówienia (Wykonawca 1)',
    ordersFromSuppliers: 'Zamówienia u dostawców',
    ordersSearchInProgress: 'Trwa wyszukiwanie zamówień',
    parentPurchaseRemoved: 'Zresetowano powiązanie zamówienia nadrzędnego. Dodaj powiązanie ponownie jeśli jest ono wymagane.',
    productsReceivedDate: 'Przyjęto produkty dnia ',
    productsReceivedInOrder: 'w zamówieniu',
    productsToOrder: 'Zamawiane produkty',
    purchase: 'Zakup',
    purchaseCategory: 'Rodzaj zakupu',
    purchases: 'Zakupy',
    purchaseStatus: 'Status zakupu',
    purchasesXlsFilename: 'lista-zamowien-u-dostawcow',
    purchaseType: {
      domestic: 'Krajowy',
      import: 'Import'
    },
    pzFor: 'PZ generowane dla',
    receivedAt: 'Data otrzymania zamówienia od wykonawcy 2',
    relation: {
      cannotBeAssignedToParent: 'Ten zakup nie może być przypisany do zakupu nadrzędnego',
      childrenPurchases: 'Zakupy podrzędne',
      openThisPurchase: 'Otwórz ten zakup',
      parentPurchase: 'Zakup nadrzędny'
    },
    relations: 'Powiązane zakupy',
    removeFile: 'Usuń plik',
    removeFileInProgress: 'Usuwanie pliku',
    removeInvoice: 'Usuń fakturę',
    removeProductText: 'Najpierw usuń powiązane produkty aby móc usunąć ten produkt',
    requiresShape: 'Wymaga wykroju',
    reservation: {
      cannotBeRemoved: 'Nie można usunąć tej rezerwacji',
      cannotBeRemovedDesc: 'Sprawdź zamówienie u dostawcy {customerName} gdyż produkty tam zamawiane są wykorzystywane w wielu zamówieniach',
      listOfReservationsFormOrdersWithSuppliers: 'Lista rezerwacji z zamówień u dostawców',
      noPurchasesReservationsToDisplay: 'Brak rezerwacji zakupów do wyświetlenia',
      removeAssignment: 'Usuń powiązanie',
      removeFromPurchase: 'Usuń produkt z zamówienia',
      removeReservations: 'Usuń rezerwację',
      reservedInOrder: 'Zarezerwowano w zamówieniu'
    },
    saveOrder: 'Zapisz zamówienie',
    saveOrderToBookProducts: 'Zapisz zamówienie aby móc rezerwować produkty',
    searchProductInOrders: 'Szukaj produktu w zamówieniach',
    seeOrderInSewingRoom: 'Zobacz zamówienie - Wykonawca 2',
    seeOrderInSubSewingRoom: 'Zobacz zamówienie - Wykonawca 1',
    selectInvoiceFile: 'Wybierz plik z fakturą (opcjonalne)',
    selectParentPurchase: 'Wybierz zakup nadrzędny',
    selectPurchase: 'Wybierz zakup',
    sendPurchaseEmail: 'Wyślij powiadomienie',
    sendPurchaseEmailCustomer: 'Do wykonawcy 2',
    sendPurchaseEmailSubCustomer: 'Do wykonawcy 1',
    sewingRoomLogs: 'Synchronizacja z wykonawcami',
    sewingRoomLogTypeStatus: 'Zmiana statusu',
    sewingRoomLogTypeSynchronize: 'Synchronizacja',
    sewingRoomStatusChanged: 'Zmiana statusu na ',
    sewingRoomSynchronized: 'Synchronizacja zamówienia',
    shapeStaysInHafciarnia: 'Wykrój zostaje w Hafciarni',
    size: {
      addSizeErrorText: 'Wystąpił błąd podczas dodawania rozmiaru',
      addSizeSuccessText: 'Dodano nowy rozmiar dla szwalni',
      addSizeSuccessTitle: 'Dodano rozmiar',
      noSuchSize: 'Brak takiego rozmiaru',
      selectSize: 'Wybierz rozmiar',
      size: 'Rozmiar'
    },
    statusInSewingRoom: 'Status (Wykonawca 2)',
    statusInSubSewingRoom: 'Status (Wykonawca 1)',
    statusLogs: 'Historia statusów',
    stitching: {
      addStitchingErrorText: 'Wystąpił błąd podczas dodawania przeszycia',
      addStitchingSuccessText: 'Dodano nowe przeszycie dla szwalni',
      addStitchingSuccessTitle: 'Dodano przeszycie',
      chooseStitching: 'Wybierz przeszycie',
      noSuchStitching: 'Brak takiego przeszycia',
      stitching: 'Przeszycie'
    },
    subInvoiceDate: 'Data faktury (Wykonawca 1)',
    subInvoiceFile: 'Plik faktury (Wykonawca 1)',
    subInvoiceNumber: 'Numer faktury (Wykonawca 1)',
    suborderReceivedAt: 'Data otrzymania zamówienia od wykonawcy 1',
    supplierChanged: 'Zmieniono wykonawcę 2',
    supplierChangedDesc: 'Należy zweryfikować ceny produktów, które były dodane do zamówienia przed zmianą dostawcy',
    syncDate: 'Data synchronizacji',
    syncDateSubSewing: 'Data synchronizacji (wykonawca 1)',
    warehouse: 'Magazyn',
    yesClose: 'Tak, zamknij',
    yourOrderSaveSuccessText: 'Twoje zamówienie zostało zapisane'
  },
  purchaseEditPopup: {
    newPurchaseQuantity: 'Nowa ilość produktu w zamówieniu u dostawcy',
    newQuantity: 'Potrzebna ilość produktu',
    order: 'Zamówienie',
    purchaseValueTooLow: 'Liczba sztuk w zamówieniu dostawcy nie może być mniejsza od sumy zarezerwowanych sztuk.',
    reservedProductsForOrderAmount: 'W tym sztuk zarezerwowanych obecnie dla tego zamówienia',
    sewingRoomStatus: 'Status zamówienia ({name})',
    sewingRoomSyncDate: 'Data synchronizacji',
    sewingRoomSynced: 'Czy zamówienie zsynchronizowano ({name})',
    subSewingRoomStatus: 'Status zamówienia ({name})',
    subSewingRoomSyncDate: 'Data synchronizacji',
    subSewingRoomSynced: 'Czy zamówienie zsynchronizowano ({name})',
    title: 'Edycja zamówienia u dostawcy',
    totalOrderedProductsAmount: 'Sztuk zamówionych u dostawcy',
    totalReservedProductsAmount: 'Sztuk zarezerwowanych z wszystkich zamówień'
  },
  report: {
    dailyReport: 'Raport dzienny',
    dateRange: 'Zakres dat',
    generateReport: 'Generuj raport',
    purchasesReports: 'Raport zakupów',
    reports: 'Raporty',
    reportsGenerating: 'Generowanie raportów',
    reportType: 'Rodzaj raportu'
  },
  selectTag: {
    enterTag: 'Podaj nazwę tagu',
    errorOccurred: 'Wystąpił błąd podczas wczytywania',
    noTagsMatchingGivenPhrase: 'Brak tagów pasujących do podanej frazy'
  },
  service: {
    addDescriptionForCustomer: 'Dodaj opis dla klienta',
    addingTransialtionsAvailableAfterSave: 'Dodawanie tłumaczeń będzie możliwe po zapisaniu zdobienia...',
    addNewIndentService: 'Dodaj nowe zdobienie Indent',
    addNewService: 'Dodaj nowe zdobienie HPL',
    addService: 'Dodaj zdobienie',
    addServiceErrorText: 'Dodawanie zdobienia nie powiodło się. Spróbuj ponownie.',
    addServiceSuccessText: 'Podana zdobienie zostało dodane',
    addServiceSuccessTitle: 'Dodano zdobienie',
    addVariant: 'Dodaj wariant',
    attachSelectdServicesPricesLists: 'Załącz cenniki wybranych zdobień',
    availableInHafciarnia: 'Dostępny w Hafciarni',
    catalogUrl: 'Link do katalogu skórek grawerowanych',
    checkEstimatedDate: 'Sprawdź możliwy termin',
    chooseEmbroideryPosition: 'Wybierz pozycję zdobienia',
    chooseEmbroideryType: 'Wybierz rodzaj zdobienia',
    chooseService: 'Wybierz zdobienie',
    commonServices: 'Zdobienia wspólne',
    dateChangeErrorText: 'Zmiana daty {value} nie powiodła się. Spróbuj ponownie.',
    dateSaved: 'Zapisano datę',
    daysNoSampleIndent: 'Przypomnienia mailowe',
    daysNoSampleIndentAppend: 'dniach na brak próby',
    daysNoSampleIndentPrepend: 'E-mail po',
    daysToSample: 'Dni na zrobienie próby',
    deleteConfirmTitle: 'Czy na pewno chcesz usunąć to zdobienie?',
    deleteErrorText: 'Usuwanie zdobienia nie powiodło się. Spróbuj ponownie.',
    deleteSuccessText: 'Podane zdobienie zostało usunięte',
    deleteSuccessTitle: 'Usunięto zdobienie',
    descriptionFoCustomer: 'Opis dla klienta',
    detailsOfServiceInOrder: 'Szczegóły dot. zdobień w zamówieniu',
    dropboxCatalog: 'Katalog Dropbox',
    dstNumber: 'Numer DST',
    editIndentService: 'Edytuj zdobienie Indent',
    editService: 'Edytuj zdobienie HPL',
    editVariant: 'Edytuj wariant',
    embroidery: {
      colors: 'Kolory zdobienia',
      height: 'WYS',
      position: 'Pozycja zdobienia',
      size: 'Rozmiar zdobienia',
      sizes: {
        cm: 'Rozmiar zdobienia (cm)',
        mm: 'Rozmiar zdobienia (mm)'
      },
      type: 'Rodzaj zdobienia',
      width: 'SZER'
    },
    enterAdditionalServiceDescription: 'Wprowadź dodatkowy opis zdobienia',
    enterAdditionalServiceDescriptionForCustomer: 'Wprowadź dodatkowy opis zdobienia dla klienta',
    enterServiceCodeOrUseSearch: 'Wpisz kod zdobienia lub skorzystaj z wyszukiwarki',
    estimatedCompleteDate: 'Przewidywana data produkcji',
    estimationIssueText: 'Nie udało się określić najbliższego możliwego terminu produkcji dla tego zdobienia',
    estimationIssueTitle: 'Nie udało się określić terminu',
    files: {
      addFile: 'Dodaj plik(i)',
      addFiles: 'Dodaj pliki',
      addingFile: 'Dodawanie pliku',
      cancelAddingFile: 'Anuluj dodawanie pliku',
      cannotAddFiles: 'Pliki można dodawać tylko do zdobień, które są zapisane. Zapisz zamówienie aby dodać pliki do tego zdobienia.',
      deleteFile: 'Usuń plik',
      editFile: 'Edytuj plik',
      editFileText: 'Podaj zaktualizowany opis pliku',
      editFileTitle: 'Zmiana opisu pliku',
      fileEditedTitle: 'Plik został zedytowany',
      fileEditError: 'Wystąpił błąd podczas edycji pliku. Spróbuj ponownie.',
      fileName: 'Opis pliku',
      fileNameCannotBeEmpty: 'Opis pliku nie może być pusty',
      noFilesToDisplay: 'Brak plików powiązanych z tym zdobieniem',
      removeFileDesc: 'Tej operacji nie można cofnąć',
      removeFileTitle: 'Czy na pewno chcesz usunąć ten plik?',
      selectFileToUpload: 'Wybierz plik(i) do dodania',
      title: 'Pliki zdobienia',
      uploadError: 'Wystąpił błąd podczas dodawania pliku'
    },
    filterServicesByName: 'Filtruj usługi po nazwie',
    fromHowManyPiecesThePriceIsMultiplied: 'Od ilu sztuk mnożyć cenę',
    group: {
      addGroup: 'Dodaj grupę',
      addingServiceVariantsAvailableAfterSave: 'Dodawanie wariantów zdobień będzie możliwe po zapisaniu grupy zdobień...',
      addingTransialtionsAvailableAfterSave: 'Dodawanie tłumaczeń będzie możliwe po zapisaniu grupy zdobień...',
      addNewGroup: 'Dodaj nową grupę',
      addNewServiceGroup: 'Dodaj nową grupę zdobień',
      addServiceGroupErrorText: 'Dodawanie grupy zdobień nie powiodło się. Spróbuj ponownie.',
      addServiceGroupSuccessText: 'Podana grupa zdobień została dodana',
      addServiceGroupSuccessTitle: 'Dodano grupę zdobień',
      assortmentGroup: 'Grupa asortymentu',
      assortmentGroupName: 'Nazwa grupy asortymentu',
      editServiceGroup: 'Edycja grupy zdobień',
      enterServiceGroupNameOrCode: 'Podaj nazwę lub kod grupy zdobień',
      groupCode: 'Kod grupy',
      groupName: 'Nazwa grupy',
      noServicesGroupsToDisplay: 'Brak grup zdobień do wyświetlenia',
      noTranslationsForThisServiceGroup: 'Brak tłumaczeń dla tej grupy zdobień',
      numberOfServices: 'Liczba zdobień w pakiecie',
      numberOfVariants: 'Liczba wariantów',
      removeServiceGroupConfirmTitle: 'Czy na pewno chcesz usunąć tę grupę zdobień?',
      removeServiceGroupErrorText: 'Usuwanie grupy zdobień nie powiodło się. Spróbuj ponownie.',
      removeServiceGroupSuccessText: 'Podana grupa zdobień została usunięta',
      removeServiceGroupSuccessTitle: 'Usunięto grupę zdobień',
      serviceGroupCode: 'Kod grupy zdobień',
      serviceGroupName: 'Nazwa grupy zdobień',
      serviceGroupPhoto: 'Zdjęcie grupy zdobień',
      servicesGroupsList: 'Lista grup zdobień',
      servicesVariants: 'Warianty zdobień',
      cannotEnablePackageWithVariants: 'Nie można włączyć pakietu zdobień, gdy grupa ma już dodane warianty zdobień',
      showOnlyPackages: 'Pokazuj tylko pakiety zdobień',
      updateServiceGroupErrorText: 'Modyfikowanie grupy zdobień nie powiodło się. Spróbuj ponownie.',
      updateServiceGroupSuccessText: 'Podana grupa zdobień została zmodyfikowana',
      updateServiceGroupSuccessTitle: 'Zmodyfikowano grupę zdobień'
    },
    assignedToProducts: 'Przypisano do produktów',
    height: 'Wysokość',
    isPackage: 'Pakiet zdobień',
    addServicesPackage: 'Dodaj pakiet zdobień',
    complexity: 'Poziom skomplikowania',
    servicesPackage: {
      configureService: 'Należy skonfigurować złożoność i wymiary zdobienia',
      configureServiceWithoutLevels: 'Należy skonfigurować wymiary zdobienia',
      configureServiceValidation: 'Skonfiguruj zdobienie za pomocą kalkulatora'
    },
    servicesPackageInvalidConfig: {
      noMatchingService: 'Brak pasującego zdobienia dla podanej konfiguracji',
      wrongDimensions: 'Podano nieprawidłowe wymiary zdobienia'
    },
    servicesPackageManuallyModified: 'Zdobienie z kalkulatora zostało zmienione ręcznie',
    servicesPackageModify: 'Modyfikuj rozmiar i stopień skomplikowania zdobienia',
    servicesPackageVariant: 'Dobrany wariant',
    servicesPackagePopup: {
      addServicesPackage: 'Dodaj pakiet zdobień',
      includedServices: 'Zdobienia wchodzące w skład wybranego pakietu zdobień:',
      noServicesIncluded: 'Brak zdobień przypisanych do wybranego pakietu zdobień.',
      noServicesPackagesMatchingGivenPhrase: 'Brak pakietów pasujących do podanej frazy',
      selectServicesPackage: 'Wybierz pakiet zdobień',
      title: 'Wybierz pakiet zdobień do dodania'
    },
    hasStitchCalculator: 'Korzysta z kalkulatora',
    calculatorType: 'Rodzaj kalkulatora',
    calculatorUse: 'Używa kalkulatora',
    selectCalculatorType: 'Wybierz rodzaj kalkulatora',
    calculatorServices: 'Zdobienia brane pod uwagę w kalkulacji',
    calculatorTypeEmbroidery: 'Hafty',
    calculatorTypeSublime: 'Aplikacja sublimowana',
    calculatorTypeOverprint: 'Nadruki',
    calculatorTypeCustom: 'Własny wybór',
    issueDuringEstimation: 'Nie udało się określić najbliższego możliwego terminu produkcji',
    machines: 'Maszyna',
    noPricesForThisService: 'Brak cen dla tego zdobienia',
    noServicesMatchingPhrase: 'Brak zdobień pasujących do podanej frazy',
    noServicesToDisplay: 'Brak zdobień do wyświetlenia',
    noSetupPricesForThisService: 'Brak cen setup dla tego zdobienia',
    noTranslationsForThisService: 'Brak tłumaczeń dla tego zdobienia',
    priceAlwaysApiece: 'Cena zawsze za sztukę',
    priceForAll: 'cena za całość',
    productionCompleteDate: 'Data zakończenia produkcji',
    productionFinish: 'zakończenia produkcji',
    sample: {
      acceptBothEmbrioderySample: 'Akceptacja próby',
      acceptEmbrioderySample: 'Akceptacja HPL - prześlij do klienta',
      draftDate: 'Data otrzymania draftu',
      provideRejectionReason: 'Podaj powód odrzucenia',
      rejectEmbrioderyHistory: 'Historia prób',
      rejectEmbrioderySample: 'Brak akceptacji HPL',
      rejectHistory: 'Historia odrzuceń',
      rejectionDate: 'Data odrzucenia',
      rejectionReason: 'Powód odrzucenia',
      rejectionReasonCannotBeEmpty: 'Powód odrzucenia nie może być pusty',
      rejectionStatus: 'Status',
      rejectSample: 'Odrzuć próbę',
      requiresDraft: 'Wymaga draftu',
      sampleAccept: 'zaakceptowania próby',
      sampleAcceptConfirmText: '',
      sampleAcceptConfirmTitle: 'Czy na pewno chcesz zaakceptować tę próbę?',
      sampleAcceptDate: 'Data zaakceptowania próby',
      sampleAcceptErrorText: 'Zaakceptowanie próby nie powiodło się. Spróbuj ponownie.',
      sampleAcceptSuccessTitle: 'Zaakceptowano próbę',
      sampleDate: 'Data próby',
      sampleHplAcceptedAt: 'Data akceptacji próby:',
      samplePhotosDateCreated: 'Data dodania',
      samplePhotosDownload: 'Pobierz',
      samplePhotosDownloadAll: 'Pobierz wszystkie',
      samplePhotosSeePreview: 'Zobacz zdjęcie próby',
      samplePhotosTitle: 'Zdjęcia prób',
      sampleReceive: 'otrzymania próby',
      sampleReceiveDate: 'Data otrzymania próby',
      sampleRejectConfirmText: 'Odrzucenie próby spowoduje wyczyszczenie dat dotyczących próby',
      sampleRejectConfirmTitle: 'Czy na pewno chcesz odrzucić tę próbę?',
      sampleRejectErrorText: 'Odrzucenie próby nie powiodło się. Spróbuj ponownie.',
      sampleRejectSuccessTitle: 'Odrzucono próbę',
      sampleStatus: 'Status próby',
      sampleStatuses: {
        approved: 'Zaakceptowana',
        rejected: 'Odrzucona',
        waiting: 'Oczekująca'
      },
      yesAccept: 'Tak, zaakceptuj',
      yesReject: 'Tak, odrzuć'
    },
    sampleFiles: {
      addingFile: 'Dodaj plik',
      deleteFile: 'Usuń plik',
      fileDeletedDesc: 'Pomyślnie usunięto wybrany plik',
      fileDeletedTitle: 'Plik usunięto',
      removeFileDesc: 'Tej operacji nie można cofnąć',
      removeFileTitle: 'Czy na pewno chcesz usunąć ten plik?',
      title: 'Pliki próby',
      uploadError: 'Wysyłanie pliku nie powiodło się'
    },
    samples: {
      add: 'Dodaj próbę',
      hideFiles: 'Ukryj pliki ({count})',
      noSamples: 'Brak prób',
      rejectReason: 'Powód odrzucenia',
      sample: 'Próba',
      saveBeforeAddingFiles: 'Zapisz zamówienie aby móc dodawać pliki',
      showFiles: 'Pokaż pliki ({count})',
      status: 'Status próby',
      statuses: {
        accepted: 'Zaakceptowano',
        rejected: 'Odrzucono'
      },
      title: 'Próby zdobienia'
    },
    schedule: {
      monthlyView: 'Widok miesięczny',
      planningServices: 'Planowanie zdobień',
      weeklyView: 'Widok tygodniowy'
    },
    searchServices: 'Szukaj zdobienia',
    selectService: 'Wybierz zdobienie',
    selectServiceType: 'Wybierz typ zdobienia',
    sericesAdded: 'Dodane zdobienia',
    service: 'Zdobienie',
    serviceAndContractor: 'Zdobienie i wykonawca',
    serviceCode: 'Kod zdobienia',
    serviceDescription: 'Opis zdobienia',
    serviceDescriptionForCustomer: 'Opis zdobienia dla klienta',
    serviceGroup: 'Grupa zdobienia',
    serviceName: 'Nazwa zdobienia',
    servicePreview: 'Podgląd zdobienia',
    servicePrices: 'Ceny zdobienia',
    servicePricesVisibleAfterSave: 'Ceny zdobienia będą widoczne po zapisaniu go...',
    services: 'Zdobienia',
    serviceSearchPlaceholder: 'Podaj nazwę lub kod zdobienia',
    servicesGroup: 'Grupa zdobień',
    servicesIndentList: 'Lista zdobień Indent',
    servicesList: 'Lista zdobień HPL',
    servicesSearchInstructionInfo: 'Wyszukaj zdobienia, których cenę chciałbyś poznać.<br>Możesz wyszukać zdobienia wpisując kod zdobienia lub skorzystać z wyszukiwarki zdobień.',
    serviceType: 'Typ zdobienia',
    serviceWithoutGroup: 'Zdobienie bez grupy',
    setup: 'Setup',
    setupPrice: 'Koszt Setup',
    setupPrices: 'Ceny setup',
    setupPricesVisibleAfterSave: 'Ceny setup będą widoczne po zapisaniu zdobienia...',
    stitchNumber: 'Liczba ściegów',
    strandColors: 'Kolory nici',
    updateServiceErrorText: 'Modyfikacja zdobienia nie powiodła się. Spróbuj ponownie.',
    updateServiceSuccessText: 'Podane zdobienie zostało zmodyfikowane',
    updateServiceSuccessTitle: 'Zmodyfikowano zdobienie',
    wantToUseServices: 'Chcę skorzystać ze zdobień',
    yourCommentsOnServiceOptional: 'Twoje uwagi do wykonania zdobienia (opcjonalne)'
  },
  settings: {
    backToSettings: 'Wróć do ustawień',
    confirmations: {
      addConfirmation: 'Dodaj potwierdzenie',
      addConfirmationErrorText: 'Nie udało się dodać potwierdzenia',
      addConfirmationSuccessText: 'Potwierdzenie zostało dodane',
      addConfirmationSuccessTitle: 'Dodano potwierdzenie',
      addNewConfirmation: 'Dodaj nowe potwierdzenie',
      confirmationName: 'Treść potwierdzenia',
      confirmations: 'Dodatkowe potwierdzenia',
      customers: 'Dla klientów',
      editConfirmation: 'Modyfikuj potwierdzenie',
      editConfirmationErrorText: 'Nie udało się zmodyfikować potwierdzenia',
      editConfirmationSuccessText: 'Potwierdzenie zostało zmodyfikowane',
      editConfirmationSuccessTitle: 'Zmieniono potwierdzenie',
      name: 'Treść potwierdzenia',
      noConfirmationsToDisplay: 'Brak potwierdzeń do wyświetlenia',
      products: 'Dla produktów',
      productsOrCustomersRequired: 'Należy wybrać co najmniej jednego klienta lub co najmniej jeden produkt powiązany z potwierdzeniem',
      removeConfirmationConfirmTitle: 'Czy na pewno chcesz usunąć to potwierdzenie?',
      removeConfirmationErrorText: 'Nie udało się usunąć potwierdzenia',
      removeConfirmationSuccessText: 'Wybrane potwierdzenie zostało usunięte',
      removeConfirmationSuccessTitle: 'Usunięto potwierdzenie',
      searchProducts: {
        addFoundedProducts: 'Dodaj produkty',
        foundedProducts: 'Znalezione produkty',
        noProductsFounded: 'Nie znaleziono pasujących produktów',
        search: 'Wyszukaj produkty',
        searchProducts: 'Szukaj produktów',
        title: 'Wyszukaj produkty'
      },
      selectedCustomerExists: 'Już wybrano tego klienta',
      selectedProductExists: 'Już wybrano ten produkt'
    },
    country: {
      addCountry: 'Dodaj kraj',
      addCountryErrorText: 'Dodawanie kraju nie powiodło się. Spróbuj ponownie.',
      addCountrySuccessText: 'Podany kraj został dodany',
      addCountrySuccessTitle: 'Dodano kraj',
      addingTranslationsAvailableAfterSave: 'Zapisz kraj aby móc dodawać tłumaczenia',
      addNewCountry: 'Dodaj nowy kraj',
      countries: 'Kraje',
      country: 'Kraj',
      countryAddressCode: 'Kod do adresu',
      countryCode: 'Kod kraju',
      countryEditErrorText: 'Edycja kraju nie powiodła się. Spróbuj ponownie.',
      countryEditSuccessText: 'Podany kraj został zmieniony',
      countryEditSuccessTitle: 'Zmodyfikowano kraj',
      countryInvoiceCode: 'Kod do faktury',
      countryName: 'Nazwa kraju',
      editCountry: 'Edytuj kraj',
      EU: 'UE?',
      isEU: 'Kraj unijny?',
      noCountriesToDisplay: 'Brak krajów do wyświetlenia',
      noTranslationsForThisCountry: 'Brak tłumaczeń kraju do wyświetlenia',
      removeCountryConfirmTitle: 'Czy na pewno chcesz usunąć ten kraj?',
      removeCountryErrorText: 'Usuwanie kraju nie powiodło się. Spróbuj ponownie.',
      removeCountrySuccessText: 'Podany kraj został usunięty',
      removeCountrySuccessTitle: 'Usunięto kraj',
      selectCountry: 'Wybierz kraj',
      taxNumberCheck: 'Sprawdzać NIP/VAT?',
      translations: 'Tłumaczenia',
      verifyTaxNumber: 'Weryfikować NIP/VAT?'
    },
    currency: {
      addCurrency: 'Dodaj walutę',
      addCurrencyErrorText: 'Dodawanie waluty nie powiodło się. Spróbuj ponownie.',
      addCurrencySuccessText: 'Podana waluta została dodana',
      addCurrencySuccessTitle: 'Dodano walutę',
      addingTranslationsAvailableAfterSave: 'Zapisz walutę aby móc dodawać tłumaczenia',
      addNewCurrency: 'Dodaj nową walutę',
      chooseCurrency: 'Wybierz walutę',
      currencies: 'Waluty',
      currency: 'Waluta',
      currencyCode: 'Kod waluty',
      currencyName: 'Nazwa waluty',
      currencyTextWarningText: '<strong>Uwaga!</strong> Jeżeli waluta zostanie zmieniona spowoduje to wczytanie cen produktów, zdobień oraz spedycji na nowo w wybranej walucie.',
      editCurrency: 'Edytuj walutę',
      editCurrencyErrorText: 'Edycja waluty nie powiodła się. Spróbuj ponownie.',
      editCurrencySuccessText: 'Podana waluta została zmieniona',
      editCurrencySuccessTitle: 'Zmodyfikowano walutę',
      noCurrenciesAvailable: 'Brak dostępnych walut...',
      noCurrenciesToDisplay: 'Brak walut do wyświetlenia',
      noTranslationsForThisCurrency: 'Brak tłumaczeń waluty do wyświetlenia',
      removeCurrencyConfirmTitle: 'Czy na pewno chcesz usunąć tę walutę?',
      removeCurrencyErrorText: 'Usuwanie waluty nie powiodło się. Spróbuj ponownie.',
      removeCurrencySuccessText: 'Podana waluta została usunięta',
      removeCurrencySuccessTitle: 'Usunięto walutę',
      translations: 'Tłumaczenia'
    },
    customerContactTypes: {
      addCustomerContactTypeErrorText: 'Nie powiodło się dodawanie nowego typu kontaktu z klientem',
      addCustomerContactTypeSuccessText: 'Dodano nowy typ kontaktu z klientem',
      addCustomerContactTypeSuccessTitle: 'Dodano nowy typ kontaktu',
      addingTranslationsAvailableAfterSave: 'Zapisz typ kontaktu aby móc dodawać tłumaczenia',
      addNewCustomerContactType: 'Dodaj nowy typ kontaktu',
      contactTypes: 'Typy kontaktów z klientem',
      editCustomerContactType: 'Zapisz zmiany',
      editCustomerContactTypeErrorText: 'Nie powiodło się modyfikowanie typu kontaktu z klientem',
      editCustomerContactTypeSuccessText: 'Zmodyfikowano typ kontaktu z klientem',
      editCustomerContactTypeSuccessTitle: 'Zmodyfikowano typ kontaktu',
      icon: 'Ikonka',
      isDefault: 'Domyślny?',
      name: 'Nazwa',
      noContactTypesToDisplay: 'Brak typów kontaktu do wyświetlenia',
      noTranslationsForThisCustomerContactType: 'Brak tłumaczeń typu kontaktu do wyświetlenia',
      removeContactTypeConfirmTitle: 'Czy na pewno chcesz usunąć ten typ kontaktu z klientem?',
      removeContactTypeErrorText: 'Nie udało się usunąć typu kontaktu z klientem',
      removeContactTypeSuccessText: 'Typ kontaktu z klientem został usunięty',
      removeContactTypeSuccessTitle: 'Usunięto typ kontaktu',
      removeIcon: 'Usuń ikonkę',
      translations: 'Tłumaczenia',
      type: 'Typ'
    },
    customerTags: {
      addCustomerTag: 'Dodaj tag klienta',
      addCustomerTagErrorText: 'Dodawanie tagu klienta nie powiodło się. Spróbuj ponownie.',
      addCustomerTagSuccessText: 'Podany tag klienta został dodany',
      addCustomerTagSuccessTitle: 'Dodano tag klienta',
      addingTranslationsAvailableAfterSave: 'Zapisz tag aby móc dodawać tłumaczenia',
      addNewCustomerTag: 'Dodaj nowy tag klienta',
      customersTags: 'Tagi klientów',
      customerTags: 'Tagi klienta',
      editCustomerTag: 'Edytuj tag klienta',
      editCustomerTagErrorText: 'Edycja tagu klienta nie powiodła się. Spróbuj ponownie.',
      editCustomerTagSuccessText: 'Podany tag klienta został zmieniony',
      editCustomerTagSuccessTitle: 'Zmodyfikowano tag klienta',
      noTagsToDisplay: 'Brak tagów klientów do wyświetlenia',
      noTranslationsForThisCustomerTag: 'Brak tłumaczeń tagu do wyświetlenia',
      removeTagConfirmTitle: 'Czy na pewno chcesz usunąć ten tag klienta?',
      removeTagErrorText: 'Usuwanie tagu klienta nie powiodło się. Spróbuj ponownie.',
      removeTagSuccessText: 'Podany tag klienta został usunięty',
      removeTagSuccessTitle: 'Usunięto tag klienta',
      tagColor: 'Kolor tagu',
      tagDescription: 'Opis tagu',
      taggedCustomers: 'Liczba klientów',
      tagName: 'Nazwa tagu',
      tagNameAndDescription: 'Nazwa i opis tagu',
      translations: 'Tłumaczenia'
    },
    emailTemplates: {
      addEmailTemplateErrorText: 'Dodawanie szablonu e-mail nie powiodło się - spróbuj ponownie.',
      addEmailTemplateSuccessText: 'Szablon e-mail został zapisany',
      addEmailTemplateSuccessTitle: 'Dodano szablon',
      additionalInfo: 'Dodatkowe dane',
      addNewEmailTemplate: 'Dodaj nowy szablon e-mail',
      address1: 'Adres',
      address2: 'Adres (dodatkowe informacje)',
      companyName: 'Nazwa firmy',
      editEmailTemplate: 'Edytuj szablon e-mail',
      editEmailTemplateErrorText: 'Modyfikowanie szablonu-emial nie powiodło się - spróbuj ponownie.',
      editEmailTemplateSuccessText: 'Szablon e-mail został zmodyfikowany',
      editEmailTemplateSuccessTitle: 'Zapisano szablon',
      email: 'E-mail',
      emailTemplates: 'Szablony e-mail',
      excludedCustomers: 'Wykluczeni klienci',
      excludedCustomersInfo: 'Wykluczonych klientów',
      facebookUrl: 'Facebook',
      footerImage: 'Grafika',
      footerUrl: 'URL grafiki',
      instagramUrl: 'Instagram',
      language: 'Język',
      languageCode: 'Kod języka',
      linkedinUrl: 'LinkedIn',
      noEmailTemplatesToDisplay: 'Brak szablonów e-mail do wyświetlenia...',
      noExcludedCustomers: 'Brak wykluczonych klientów',
      phone: 'Numer telefonu',
      removeEmailTemplateErrorText: 'Usuwanie szablonu e-mail nie powiodło się. Spróbuj ponownie.',
      removeEmailTemplateSuccessText: 'Wybrany szablon e-mail został usuniety.',
      removeEmailTemplateSuccessTitle: 'Usunięto szablon',
      removeEmailTemplteConfirmTitle: 'Czy na pewno chcesz usunąć ten szablon e-mail?',
      url: 'WWW',
      youtubeUrl: 'YouTube'
    },
    integrations: {
      disabled: 'Integracja wyłączona',
      disableIntegration: 'Wyłącz integrację',
      enabled: 'Integracja włączona',
      enableIntegration: 'Włącz integrację',
      integrationHasBeenDisabled: 'Integracja została wyłączona',
      integrationHasBeenEnabled: 'Integracja została włączona',
      integrationIsDisabled: 'Integracja jest wyłączona',
      integrations: 'Integracje',
      name: 'Nazwa integracji',
      noIntegrationsToDisplay: 'Brak integracji do wyświetlenia',
      status: 'Status integracji'
    },
    language: {
      addingTranslationsAvailableAfterSave: 'Zapisz język aby móc dodawać tłumaczenia',
      addLanguage: 'Dodaj język',
      addLanguageErrorText: 'Dodawanie języka nie powiodło się. Spróbuj ponownie.',
      addLanguageSuccessText: 'Podany język został dodany',
      addLanguageSuccessTitle: 'Dodano język',
      addNewLanguage: 'Dodaj nowy język',
      chooseLanguage: 'Wybierz język',
      editLanguage: 'Edytuj język',
      editLanguageErrorText: 'Edycja języka nie powiodła się. Spróbuj ponownie.',
      editLanguageSuccessText: 'Podany język został zmieniony',
      editLanguageSuccessTitle: 'Zmodyfikowano język',
      languageCode: 'Kod języka',
      languageLocative: 'języku',
      languageName: 'Nazwa języka',
      languages: 'Języki',
      languagesLocative: 'językach',
      noLanguagesAvailable: 'Brak dostępnych języków',
      noLoanguagesToDisplay: 'Brak języków do wyświetlenia',
      noTranslationsForThisLanguage: 'Brak tłumaczeń języka do wyświetlenia',
      removeLanguageConfirmTitle: 'Czy na pewno chcesz usunąć ten język?',
      removeLanguageErrorText: 'Usuwanie języka nie powiodło się. Spróbuj ponownie.',
      removeLanguageSuccessText: 'Podany język został usunięty',
      removeLanguageSuccessTitle: 'Usunięto język',
      translations: 'Tłumaczenia'
    },
    orderTags: {
      addNewOrderTag: 'Dodaj nowy tag zamówienia',
      addOrderTag: 'Dodaj tag zamówienia',
      addOrderTagErrorText: 'Dodawanie tagu zamówienia nie powiodło się. Spróbuj ponownie.',
      addOrderTagSuccessText: 'Podany tag zamówienia został dodany',
      addOrderTagSuccessTitle: 'Dodano tag zamówienia',
      editOrderTag: 'Edytuj tag zamówienia',
      editOrderTagErrorText: 'Edycja tagu zamówienia nie powiodła się. Spróbuj ponownie.',
      editOrderTagSuccessText: 'Podany tag zamówienia został zmieniony',
      editOrderTagSuccessTitle: 'Zmodyfikowano tag zamówienia',
      noTagsToDisplay: 'Brak tagów zamówień do wyświetlenia',
      ordersTags: 'Tagi zamówień',
      orderTags: 'Tagi zamówienia',
      removeTagConfirmTitle: 'Czy na pewno chcesz usunąć ten tag zamówienia?',
      removeTagErrorText: 'Usuwanie tagu zamówienia nie powiodło się. Spróbuj ponownie.',
      removeTagSuccessText: 'Podany tag zamówienia został usunięty',
      removeTagSuccessTitle: 'Usunięto tag zamówienia',
      tagColor: 'Kolor tagu',
      tagDescription: 'Opis tagu',
      taggedOrders: 'Liczba zamówień',
      tagName: 'Nazwa tagu',
      tagNameAndDescription: 'Nazwa i opis tagu'
    },
    phraseSearchPlaceholder: 'Wpisz fragment tekstu do wyszukania',
    processingTime: {
      addingTranslationsAvailableAfterSave: 'Zapisz czas realizacji aby móc dodawać tłumaczenia',
      addNewProcessingTime: 'Dodaj nowy czas realizacji',
      addProcessingTime: 'Dodaj czas realizacji',
      addProcessingTimeErrorText: 'Dodawanie czasu realizacji nie powiodło się. Spróbuj ponownie.',
      addProcessingTimeSuccessText: 'Podany czas realizacji został dodany',
      addProcessingTimeSuccessTitle: 'Dodano czas realizacji',
      editProcessingTime: 'Edytuj czas realizacji',
      editProcessingTimeErrorText: 'Edycja czasu realizacji nie powiodła się. Spróbuj ponownie.',
      editProcessingTimeSuccessText: 'Wybrany czas realizacji został zmieniony',
      editProcessingTimeSuccessTitle: 'Zmodyfikowano czas realizacji',
      noProcessingTimesToDisplay: 'Brak czasów realizacji do wyświetlenia',
      noTranslationsForThisProcessingTime: 'Brak tłumaczeń do wyświetlenia',
      processingTimeName: 'Nazwa czasu realizacji',
      processingTimes: 'Czasy realizacji',
      removeProcessingTimeConfirmTitle: 'Czy na pewno chcesz usunąć ten czas realizacji?',
      removeProcessingTimeErrorText: 'Usuwanie czasu realizacji nie powiodło się. Spróbuj ponownie.',
      removeProcessingTimeSuccessText: 'Wybrany czas realizacji został usunięty',
      removeProcessingTimeSuccessTitle: 'Usunięto czas realizacji',
      translations: 'Tłumaczenia'
    },
    promotionalTags: {
      addNewPromotionalTag: 'Dodaj nowy tag promocyjny',
      addPromotionalTag: 'Dodaj tag promocyjny',
      addPromotionalTagErrorText: 'Dodawanie tagu promocyjnego nie powiodło się. Spróbuj ponownie.',
      addPromotionalTagSuccessText: 'Podany tag promocyjny został dodany',
      addPromotionalTagSuccessTitle: 'Dodano tag promocyjny',
      editPromotionalTag: 'Edytuj tag promocyjny',
      editPromotionalTagErrorText: 'Edycja tagu promocyjnego nie powiodła się. Spróbuj ponownie.',
      editPromotionalTagSuccessText: 'Podany tag promocyjny został zmieniony',
      editPromotionalTagSuccessTitle: 'Zmodyfikowano tag promocyjny',
      noTagsToDisplay: 'Brak tagów promocyjnych do wyświetlenia',
      promotionalTag: 'Akcja promocyjna',
      promotionalTags: 'Tagi promocyjne',
      removeTagConfirmTitle: 'Czy na pewno chcesz usunąć ten tag promocyjny?',
      removeTagErrorText: 'Usuwanie tagu promocyjnego nie powiodło się. Spróbuj ponownie.',
      removeTagSuccessText: 'Podany tag promocyjny został usunięty',
      removeTagSuccessTitle: 'Usunięto tag promocyjny',
      tagColor: 'Kolor tagu',
      tagDescription: 'Opis tagu',
      taggedOrders: 'Liczba zamówień',
      tagName: 'Nazwa tagu',
      tagNameAndDescription: 'Nazwa i opis tagu'
    },
    regions: {
      allRegions: 'Wszystkie regiony',
      region: 'Region',
      selectRegion: 'Wybierz region'
    },
    settingsLabel: 'Ustawienia',
    source: {
      addNewSource: 'Dodaj nowe źródło',
      addNewSourceOfGain: 'Dodaj nowe źródło pozyskania',
      addSourceErrorText: 'Dodawanie źródła pozyskania nie powiodło się. Spróbuj ponownie.',
      addSourceOfGain: 'Dodaj źródło pozyskania',
      addSourceSuccessText: 'Podane źródło pozyskania zostało dodane',
      addSourceSuccessTitle: 'Dodano źródło pozyskania',
      editSourceErrorText: 'Edycja źródła pozyskania nie powiodła się. Spróbuj ponownie.',
      editSourceOfGain: 'Edytuj źródło pozyskania',
      editSourceSuccessText: 'Wybrane źródło pozyskania zostało zmienione',
      editSourceSuccessTitle: 'Zmodyfikowano źródło pozyskania',
      noSourcesToDisplay: 'Brak źródeł pozyskania do wyświetlenia',
      sourceName: 'Nazwa źródła pozyskania',
      sources: 'Źródła pozyskania',
      sourcesDeleteConfirmTitle: 'Czy na pewno chcesz usunąć to źródło pozyskania?',
      sourcesDeleteErrorText: 'Usuwanie źródła pozyskania nie powiodło się. Spróbuj ponownie.',
      sourcesDeleteSuccessText: 'Wybrane źródło pozyskania zostało usunięte',
      sourcesDeleteSuccessTitle: 'Usunięto źródło pozyskania'
    },
    systemSettings: 'Ustawienia systemu CRM',
    transaltion: {
      addTranslation: 'Dodaj tłumaczenie',
      addTranslationErrorText: 'Dodawanie tłumaczenia nie powiodło się. Spróbuj ponownie.',
      addTranslationSuccessText: 'Podane tłumaczenie zostało zapisane',
      addTranslationSuccessTitle: 'Dodano tłumaczenie',
      deleteTranslationConfirmTitle: 'Czy na pewno chcesz usunąć to tłumaczenie?',
      deleteTranslationErrorText: 'Usuwanie tłumaczenia nie powiodło się. Spróbuj ponownie.',
      deleteTranslationSuccessText: 'Wybrane tłumaczenie zostało usunięte',
      deleteTranslationSuccessTitle: 'Usunięto tłumaczenie',
      dictionaryMultilang: 'Słowniki wielojęzyczności',
      editTranslation: 'Edytuj tłumaczenie',
      missingTranslationsIn: 'Brak tłumaczeń w ',
      noTranslationsToDisplay: 'Brak tłumaczeń do wyświetlenia',
      systemName: 'Nazwa systemowa',
      transaltionStatus: 'Status tłumaczeń',
      translated: 'Przetłumaczone',
      translation: 'Tłumaczenie',
      translationEditErrorText: 'Edycja tłumaczenia nie powiodła się. Spróbuj ponownie.',
      translationEditSuccessText: 'Wybrane tłumaczenie zostało zmienione',
      translationEditSuccessTitle: 'Zmodyfikowano tłumaczenie',
      translations: 'Tłumaczenia',
      valueInPolish: 'Wartość po polsku'
    },
    userGroups: {
      addNewUserGroup: 'Dodaj nową grupę',
      addUserGroupErrorText: 'Dodawanie nowej grupy użytkowników nie powiodło się',
      addUserGroupSuccessText: 'Pomyślnie dodano nową grupę użytkowników',
      addUserGroupSuccessTitle: 'Dodano nową grupę',
      editUserGroup: 'Edycja grupy użytkowników',
      editUserGroupErrorText: 'Modyfikacja wybranej grupy użytkowników nie powiodła się',
      editUserGroupSuccessText: 'Pomyślnie zmodyfikowano grupę użytkowników',
      editUserGroupSuccessTitle: 'Zmodyfikowano grupę',
      groupName: 'Nazwa grupy',
      noUserGroupsToDisplay: 'Brak grup do wyświetlenia',
      removeUserGroupConfirmTitle: 'Czy na pewno chcesz usunąć wybraną grupę użytkowników?',
      removeUserGroupErrorText: 'Nie uduało się usunąc wybranej grupy użytkowników',
      removeUserGroupSuccessText: 'Wybrana grupa użytkowników została usunięta',
      removeUserGroupSuccessTitle: 'Usunięto grupę',
      userGroup: 'Grupa użytkowników',
      userGroups: 'Grupy użytkowników'
    }
  },
  settlements: {
    addSettlement: 'Dodaj rozliczenie',
    amount: 'Kwota',
    changeToPaid: 'Zamień na rozliczone',
    changeToUnpaid: 'Zamień na nierozliczone',
    deadlines: 'Terminy',
    debtReport: {
      addNote: 'Dodaj notatkę',
      amountNet: 'Suma przeliczona',
      count: 'Ilość rozliczeń',
      customer: 'Klient',
      dates: 'Terminy',
      debtCalculated: 'Wartość przeliczona',
      debtOriginal: 'Wartość',
      debtPaid: 'Suma wpłacona',
      downloadXlsx: 'Pobierz XLSX',
      editNote: 'Edytuj notatkę',
      exchange: 'Kurs z dnia ',
      fileName: 'raport-zadluzenia',
      hideSettlements: 'Ukryj rozliczenia',
      invoiceDate: 'Data wystawienia dokumentu',
      invoiceNumber: 'Numer dokumentu',
      order: 'Zamówienie',
      paymentDate: 'Termin płatności',
      percentage: 'Udział %',
      seeSettlements: 'Rozliczenia',
      showSettlements: 'Pokaż rozliczenia',
      title: 'Raport zadłużenia',
      total: 'Suma',
      type: 'Rodzaj opóźnienia',
      types: {
        '30_DAYS': 'FV przeterminowane od 1 do 29 dni',
        '60_DAYS': 'FV przeterminowane od 30 do 59 dni',
        '90_DAYS': 'FV przeterminowane od 60 do 89 dni',
        '90_PLUS_DAYS': 'FV przeterminowane 90 dni i więcej',
        'CURRENT': 'Wszystkie wystawione FV jeszcze w terminie płatności'
      },
      yourNote: 'Notatki dla tego dokumentu'
    },
    deleteInvoiceRequest: 'Usuń',
    downloadAllInvoices: 'Pobierz wszystkie faktury',
    downloadFilteredInvoices: 'Pobierz wyfiltrowane faktury',
    downloadTodaysInvoices: 'Pobierz dzisiejsze faktury',
    errorOccuredDuringPrintout: 'Wystąpił błąd podczas zlecania wydruku faktury',
    errorOccuredDuringRollback: 'Wystąpił błąd podczas wycofywania żądania faktury',
    errorOccuredDuringSending: 'Wystąpił błąd podczas wysyłki',
    invoiceList: 'Lista faktur',
    invoicePrintout: 'Wydruk awaryjny',
    invoicePrintoutDesc: 'Wydruk będzie dostępny do kilku minut.',
    invoicePrintoutTitle: 'Zostało zlecone wygenerowanie wydruku w ERP',
    invoiceRollbackDesc: 'Wybrane rozliczenie zostało usunięte',
    invoiceRollbackTitle: 'Usunięto rozliczenie',
    invoiceSent: 'Faktura wysłana',
    invoiceSentDesc: 'Faktura została wysłana',
    invoiceSentTitle: 'Faktura wysłana',
    invoiceUnableToSent: 'Nie można wysłać',
    issued: 'Wystawiono',
    noSettlementsToDisplay: 'Brak rozliczeń do wyświetlenia',
    paymentDueDate: 'Płatność do',
    reminders: {
      active: 'Aktywne',
      disable: 'Wyłącz',
      enable: 'Włącz',
      inactive: 'Nieaktywne',
      status: 'Przypomnienia'
    },
    sendEmail: 'Wyślij FV mailem',
    sendEmailToCustomer: 'Do klienta',
    sendEmailToUser: 'Do opiekuna',
    sendInvoice: 'Wyślij fakturę',
    settle: 'Rozlicz',
    settled: 'Rozliczono',
    settlement: 'Rozliczenie',
    settlements: 'Rozliczenia',
    statusChangedDesc: '',
    statusChangedTitle: 'Zmieniono status płatności',
    submitStatus: 'Status wysyłki',
    type: 'Rodzaj',
    viewHistory: 'Zobacz historię operacji',
    waitingForInvoice: 'Oczekuje na plik faktury'
  },
  settlementsAddPopup: {
    addDesc: 'Rozliczenie zostało dodane',
    addTitle: 'Dodano rozliczenie',
    amount: 'Kwota',
    amountNet: 'Kwota netto',
    amountPaid: 'Zapłacono',
    currency: 'Waluta',
    customer: 'Klient',
    filePDF: 'Plik PDF',
    invoiceDate: 'Data wystawienia',
    number: 'Numer dokumentu',
    order: 'Numer zamówienia',
    paymentDate: 'Termin płatności',
    settlementDate: 'Data rozliczenia',
    status: 'Status',
    statuses: {
      PAID: 'Opłacone',
      UNPAID: 'Nieopłacone'
    },
    title: 'Dodaj rozliczenie'
  },
  settlementsHistoryPopup: {
    createdAt: 'Data operacji',
    noOperations: 'Brak operacji do wyświetlenia...',
    operation: 'Operacja',
    operations: {
      ADD: 'Dodanie faktury',
      DELETE: 'Usunięcie faktury',
      GET_INVOICE_PRINTOUT: 'Wygenerowanie wydruku',
      PAID: 'Oznaczono jako opłacone',
      UNPAID: 'Oznaczono jako nieopłacone'
    },
    title: 'Historia działań na rozliczeniu',
    user: 'Wykonane przez'
  },
  shipments: {
    addNewShipmentPOD: 'Dodaj dowód dostawy',
    addNewShipmentUPS: 'Dodaj nową przesyłkę UPS',
    addressNotConfirmed: 'Adres wysyłki nie został potwierdzony',
    addressNotConfirmedDesc: 'Potwierdź adres wysyłki i zapisz zamówienie, aby móc nadać przesyłkę.',
    cancelShipment: 'Anuluj przesyłkę',
    createdAt: 'Utworzona',
    createdBy: 'Utworzona przez',
    downloadLabelForShipment: 'Etykieta dla przesyłki',
    downloadPodForShipment: 'Dowód dostawy',
    enterCustomerName: 'Wprowadź nazwę odbiorcy',
    enterOrderName: 'Wprowadź nazwę zamówienia',
    enterTrackingNumber: 'Wprowadź numer przesyłki',
    labelFilePrefix: 'etykieta-przesylki-',
    lackOfAddressContactData: 'Brak adresu/kontaktu do wysyłki',
    lackOfAddressContactDataDesc: 'Przed dodaniem przesyłki należy ustawić adres oraz osobę kontaktową w zamówieniu a następnie zapisać zamówienie.',
    noRelatedOrder: 'Brak powiązanego zamówienia',
    noShipmentsToDisplay: 'Brak przesyłek do wyświetlenia',
    packages: 'Paczki',
    packagesCount: 'Liczba paczek',
    packagesWeight: 'Waga paczek',
    podFilePrefix: 'dowod-dostawy-',
    popups: {
      addPackage: 'Dodaj paczkę',
      addPOD: 'Dodaj dowód dostawy',
      addShipment: 'Dodaj wysyłkę',
      basicDataTitle: 'Podstawowe informacje',
      bulkCloneAdd: 'Kopiuj',
      bulkCloneError: 'Należy podać liczbę całkowitą',
      bulkCloneText: 'Ile kopii chcesz utworzyć?',
      bulkCloneTitle: 'Kopiowanie paczek',
      checkPostalCode: 'Sprawdź kod pocztowy',
      codAmount: 'Wartość płatności za pobraniem',
      codCurrencyCode: 'Waluta COD',
      emptyPackages: 'Brak paczek',
      emptyPackagesDesc: 'Musisz dodać paczki do wysyłki przed jej zapisaniem.',
      howManyPackages: 'Ile paczek?',
      invalidShipper: 'Nie wybrano nadawcy',
      invalidShipperDesc: 'Musisz wybrać nadawcę',
      isCOD: 'COD (pobierz płatność od odbiorcy podczas dostawy)',
      noPackages: 'Brak dodanych paczek do wyświetlenia',
      noTrackings: 'Brak statusów dostawy do wyświetlenia',
      packageDescription: 'Opis',
      packageReferenceNumber: 'Numer referencyjny',
      packagesDataTitle: 'Paczki',
      packageWeight: 'Waga (w kg)',
      paymentDataTitle: 'Płatność',
      podFile: 'Plik dowodu dostawy',
      podSaved: 'Zapisano dowód dostawy',
      podSavedDesc: 'Pomyślnie zapisano dowód dostawy',
      podSaveError: 'Nie udało się zapisać dowodu dostawy',
      postCodeExistDesc: 'Podany kod pocztowy istnieje w wybranym kraju',
      postCodeExistsTitle: 'Kod istnieje',
      postCodeMultipleExistsDesc: 'Podany kod pocztowy istnieje w wybranym kraju oraz w innych krajach: ',
      postCodeMultipleExistsTitle: 'Kod istnieje',
      postCodeNotExistsDesc: 'Podany kod pocztowy nie istnieje w wybranym kraju',
      postCodeNotExistsTitle: 'Kod nie istnieje',
      receiverAddress: 'Adres',
      receiverAttentionName: 'Imię i nazwisko odbiorcy',
      receiverBuilding: 'Nr budynku',
      receiverCity: 'Miasto',
      receiverCountryCode: 'Kraj',
      receiverDataTitle: 'Odbiorca',
      receiverEmail: 'Adres e-mail odbiorcy',
      receiverLine2: 'Dodatkowy adres 2',
      receiverLine3: 'Dodatkowy adres 3',
      receiverLocale: 'Nr lokalu',
      receiverName: 'Nazwa (firmy) odbiorcy',
      receiverPhone: 'Numer telefonu odbiorcy',
      receiverPostalCode: 'Kod pocztowy',
      receiverStreet: 'Ulica',
      relatedOrder: 'Powiązane zamówienie',
      saveErrorText: 'Wystąpił błąd podczas zapisu wysyłki',
      savePOD: 'Zapisz dowód dostawy',
      saveShipment: 'Zapisz wysyłkę',
      saveSuccessText: 'Przesyłka została pomyślnie zapisana',
      saveSuccessTitle: 'Zapisano wysyłkę',
      saveTracking: 'Zapisz numer trackingowy',
      saveTrackingErrorText: 'Wystąpił błąd podczas zapisu numeru trackingowego',
      saveTrackingSuccessText: 'Numer trackingowy został pomyślnie zapisany',
      saveTrackingSuccessTitle: 'Zapisano numer trackingowy',
      selectAddress: 'Wybierz adres odbiorcy',
      selectCountry: 'Wybierz kraj',
      selectCurrency: 'Wybierz walutę',
      selectService: 'Wybierz usługę',
      selectShipper: 'Wybierz nadawcę',
      serviceDataTitle: 'Usługa',
      setCustomerData: 'Wypełnij danymi klienta',
      setShipper: 'Wypełnij dane nadawcy',
      shipmentDescription: 'Ogólny opis towarów',
      shipmentInfo: 'Informacje o przesyłce',
      shipmentTrackingStatus: 'Status dostawy',
      shipper: 'Wybierz konto UPS',
      shipperAddress: 'Adres',
      shipperAttentionName: 'Imię i nazwisko nadawcy',
      shipperBuilding: 'Nr budynku',
      shipperCity: 'Miasto',
      shipperCode: 'Kod spedytora',
      shipperCountryCode: 'Kraj',
      shipperDataTitle: 'Nadawca',
      shipperEmail: 'Adres e-mail nadawcy',
      shipperLocale: 'Nr lokalu',
      shipperName: 'Nazwa (firmy) nadawcy',
      shipperNumber: 'Konto UPS nadawcy',
      shipperPhone: 'Numer telefonu nadawcy',
      shipperPostalCode: 'Kod pocztowy',
      shipperStreet: 'Ulica',
      trackingNumber: 'Numer śledzenia',
      upsService: 'Usługa UPS',
      useAddress: 'Użyj adresu',
      useCOD: 'Płatność za pobraniem?'
    },
    receiverData: 'Dane odbiorcy',
    relatedOrder: 'Powiązane zamówienie',
    selectStatus: 'Wybierz status',
    shipmentCancelError: 'Wystąpił błąd podczas anulowania przesyłki',
    shipmentCancelled: 'Przesyłka anulowana',
    shipmentCancelledDesc: 'Przesyłka została anulowana',
    shipments: 'Przesyłki',
    shipmentsAvailableAfterSave: 'Lista przesyłek będzie dostępna po zapisaniu zamówienia',
    shipmentsList: 'Lista przesyłek',
    shipper: 'Firma kurierska',
    shipperData: 'Dane wysyłającego',
    status: 'Status',
    statusDate: 'Data statusu',
    statuses: {
      cancelled: 'Anulowana',
      delivered: 'Dostarczona',
      error: 'Wystąpił błąd',
      integrated: 'Zintegrowana',
      new: 'Nowa'
    },
    trackingNumber: 'Numer śledzenia',
    trackingStatuses: {
      D: 'Doręczono',
      I: 'W doręczeniu',
      M: 'Otrzymano zlecenie',
      P: 'Odebrano',
      X: 'Wystąpił problem'
    },
    viewShipment: 'Zobacz informacje o przesyłce'
  },
  shipmentsReports: {
    amount: 'Przesyłek',
    createdAt: 'Utworzony',
    dateRange: 'Zakres dat raportu',
    downloadReport: 'Pobierz raport',
    errorDuringGeneratingReport: 'Wystąpił błąd podczas generowania raportu. Spróbuj ponownie.',
    lastChange: 'Ost. zmiana',
    noReportsToDisplay: 'Brak raportów',
    reports: 'Raporty przesyłek',
    reportsList: 'Lista raportów przesyłek',
    status: 'Status raportu',
    statuses: {
      EMAIL_SENDING: 'Wysyłanie e-maila',
      ENDED: 'Zakończony',
      GENERATING_POD: 'Generowanie dowodów dostaw',
      MERGING_FILES: 'Łączenie plików',
      NEW: 'Nowy',
      REMOVING_FILES: 'Usuwanie plików',
      ZIP_PACKING: 'Pakowanie plików'
    },
    type: 'Typ',
    typeAll: 'Wszystkie',
    typeWithoutReport: 'Bez raportu',
    viewPopup: {
      invoice: 'Faktura',
      invoiceMerged: 'Połączono',
      noShipments: 'Brak przesyłek powiązanych z raportem',
      pod: 'List przewozowy',
      podGenerated: 'Wygenerowano',
      title: 'Przesyłki powiązane z raportem'
    },
    viewRelatedShipments: 'Zobacz powiązane przesyłki'
  },
  shippers: {
    addingNewShipper: 'Dodawanie spedytora',
    addingPricesWillBeAvailableAfterShipperSave: 'Dodawanie cen będzie możliwe po zapisaniu spedytora',
    addNew: 'Dodaj nowego spedytora',
    addNewShipper: 'Dodaj spedytora',
    addShipperErrorText: 'Dodawanie spedytora nie powiodło się. Spróbuj ponownie.',
    addShipperSuccessText: 'Podany spedytor został zapisany',
    addShipperSuccessTitle: 'Dodano spedytora',
    chooseShipper: 'Wybierz spedytora',
    deleteConfirmTitle: 'Czy na pewno chcesz usunąć tego spedytora?',
    deleteErrorText: 'Usuwanie spedytora nie powiodło się. Spróbuj ponownie.',
    deleteSuccessText: 'Wybrany spedytor został usunięty',
    deleteSuccessTitle: 'Usunięto spedytora',
    editShipper: 'Edycja spedytora',
    editShipperErrorText: 'Edycja spedytora nie powiodła się. Spróbuj ponownie.',
    editShipperSuccessText: 'Wybrany spedytor został zmieniony',
    editShipperSuccessTitle: 'Zmodyfikowano spedytora',
    noPrices: 'Brak cen',
    noShippersAvailable: 'Brak dostępnych spedytorów',
    noShippersToDisplay: 'Brak spedytorów do wyświetlenia',
    price: 'cena',
    prices: 'ceny',
    shipperName: 'Nazwa spedytora',
    shipperQuestionMark: 'Wykonawca 2?',
    shippersLabel: 'Spedytorzy',
    shippersList: 'Lista spedytorów',
    shippersSearchPlaceholder: 'Podaj nazwę lub kod spedytora'
  },
  softlab: {
    errorDescription: 'Opis błędu',
    forceSoftlabDataUpdate: 'Wymuś aktualizację danych w Softlab',
    forceUpdateErrorText: 'Nie udało się wymusić aktualizacji danych. Spróbuj ponownie.',
    forceUpdateSuccessTitle: 'Wymuszono aktualizację danych',
    orderImportToSoftlabError: 'Błąd podczas importu zamówienia do systemu Softlab',
    updatingData: 'Aktualizowanie danych...'
  },
  statistics: {
    invoice: 'Faktura',
    invoices: 'Faktury',
    noInvoices: 'Brak wystawionych faktur'
  },
  stats: {
    avgRowTitle: 'Średnia',
    compareCustomers: 'Filtruj klientów utworzonych w wybranym okresie:',
    comparePeriods: 'Porównaj do:',
    downloadData: 'Pobierz dane',
    endedOrdersAmount: 'Kwota zakończonych zamówień',
    endedOrdersCount: 'Liczba zakończonych zamówień',
    maxRowTitle: 'Maksimum',
    minRowTitle: 'Minimum',
    offersAmount: 'Kwota złożonych ofert',
    offersCount: 'Liczba złożonych ofert',
    offersToOrdersAmount: 'Kwota ofert przekształconych w zamówienia',
    offersToOrdersCount: 'Liczba ofert przekształconych w zamówienia',
    ordersAmount: 'Kwota złożonych zamówień',
    ordersCount: 'Liczba złożonych zamówień',
    settlementOrdersAmount: 'Kwota zafakturowanych zamówień',
    settlementOrdersCount: 'Liczba zafakturowanych zamówień',
    statsFilename: 'statystyki',
    subtitle: 'Statystyki firmowe',
    sumRowTitle: 'Suma',
    title: 'Statystyki'
  },
  status: {
    cannotChangePurchaseStatusText: 'Należy określić deadline i zapisać zakup przed zmianą statusu na "Oczekuje na produkty"',
    cannotChangePurchaseStatusTitle: 'Nie można zmienić statusu',
    changeStatus: 'Zmień status',
    changeStatusConfirmText: 'Wszystkie niezapisane zmiany zostaną utracone. Zapisz je przed zmianą statusu.',
    changeStatusConfirmTitle: 'Czy na pewno chcesz zmienić status?',
    changeStatusErrorText: 'Zmiana statusu nie powiodła się. Spróbuj ponownie.',
    changeStatusSuccessText: 'Status został zmieniony',
    changeStatusSuccessTitle: 'Zmieniono status',
    changeStatusToDeleteConfirmText: 'Tego statusu już nie cofniesz. Czy jesteś pewny, że chcesz anulować to zamówienie?',
    changeStatusToDeleteConfirmTitle: 'UWAGA!',
    operationNotPermitted: 'Operacja niedozwolona',
    operationNotPermittedDesc: 'Tego statusu nie można zmienić.',
    purchaseStatusQuestionMark: 'Status zakupu?',
    receivers: 'Odbiorcy',
    reminderDate: 'Data wysłania przypomnienia',
    selectSatus: 'Wybierz status',
    status: 'Status',
    statusInSewingRoom: 'Szwalnia - status',
    statusInSewingRoomQuestionMark: 'Status w szwalni?',
    statusQuestionMark: 'Status?',
    yesChangeStatus: 'Tak, zmień status'
  },
  systemMessages: {
    addMessage: 'Dodaj komunikat',
    addMessageErrorText: 'Wystąpił błąd podczas dodawania komunikatu. Spróbuj ponownie.',
    addMessageSuccessText: 'Pomyślnie dodano komunikat',
    addMessageSuccessTitle: 'Dodano komunikat',
    addNewMessage: 'Dodawanie nowego komunikatu',
    editMessage: 'Edytuj komunikat',
    editMessageErrorText: 'Wystąpił błąd podczas edytowania komunikatu. Spróbuj ponownie.',
    editMessageSuccessText: 'Pomyślnie zmodyfikowano komunikat',
    editMessageSuccessTitle: 'Zmodyfikowano komunikat',
    failedToLoad: 'Nie udało się załadować powiadomień.',
    markAsRead: 'Oznacz jako przeczytaną',
    messagesList: 'Lista komunikatów',
    noMessages: 'Brak komunikatów.',
    noMessagesToDisplay: 'Brak komunikatów do wyświetlania',
    noNewMessages: 'Brak nowych komunikatów.',
    noUsersSelected: 'Nie wybrano żadnych użytkowników.',
    removeMessageConfirmTitle: 'Czy na pewno chcesz usunąć ten komunikat?',
    removeMessageErrorText: 'Wystąpił błąd podczas usuwania komunikatu. Spróbuj ponownie.',
    removeMessageSuccessText: 'Wybrany komunikat został usunięty',
    removeMessageSuccessTitle: 'Usunięto komunikat',
    sendToAllUsers: 'Wyślij do wszystkich użytkowników',
    systemMessages: 'Komunikaty systemowe',
    usersGroupsValidationError: 'Należy dodać przynajmniej jedną grupę lub użytkownika.'
  },
  ui: {
    actionFailedTryAgain: 'Operacja nie powiodła się. Spróbuj ponownie.',
    actions: 'Akcje',
    add: 'Dodaj',
    addDescription: 'Dodaj opis',
    addDescriptionForCustomer: 'Dodaj opis dla klienta',
    additionalInfo: 'Dodatkowe uwagi',
    addNew: 'Dodaj nowy',
    address: 'Adres',
    addToOffer: 'Dodaj do oferty',
    amount: 'Ilość',
    availability: 'Dostępność',
    back: 'Wróć',
    backToList: 'Wróć do listy',
    cancel: 'Anuluj',
    chooseDate: 'Wybierz datę',
    chooseOption: 'wybierz opcję',
    clearFilter: 'Wyczyść filtr',
    close: 'Zamknij',
    code: 'Kod',
    collapse: 'Zwiń',
    comments: 'Uwagi',
    companyName: 'Nazwa firmy',
    contactPerson: 'Osoba kontaktowa',
    content: 'Treść',
    created: 'Utworzono',
    customerOrder: 'Zamówienie partnera',
    customerOrders: 'Zamówienia partnerów',
    customerOrdersList: 'Lista zamówień partnerów',
    dataLoading: 'Trwa ładowanie danych',
    dataLoadingFailed: 'Wczytywanie danych nie powiodło się.',
    days: 'dni',
    daysOfWeek: {
      fri: 'Ptk',
      mon: 'Pon',
      sat: 'Sob',
      sun: 'Ndz',
      thur: 'Czw',
      tue: 'Wto',
      wed: 'Śro'
    },
    deadline: 'Termin',
    deadlineCap: 'DEADLINE',
    delete: 'Usuń',
    deleteConfirmText: 'Tej operacji nie można cofnąć',
    deliveryDate: 'Data dostawy',
    description: 'Opis',
    deselectAll: 'Odznacz wszystkie',
    download: 'Pobierz',
    downloadInProgress: 'Trwa pobieranie',
    duplicate: 'Duplikuj',
    edit: 'Edytuj',
    emailAddress: 'Adres e-mail',
    eMailCap: 'E-mail',
    eMailShort: 'e-mail',
    errorOccured: 'Wystąpił błąd',
    errorOccuredDesc: 'Wystąpił nieoczekiwany błąd - spróbuj ponownie.',
    errorOccuredDuringDownload: 'Wystąpił błąd podczas pobierania',
    errorOccuredDuringSending: 'Wystąpił błąd podczas wysyłki',
    expand: 'Rozwiń',
    exportErrorTitle: 'Wystąpił błąd podczas eksportu',
    file: 'Plik',
    from: 'od',
    generalInfo: 'Dane ogólne',
    goTo: 'Przejdź do...',
    immediate: 'natychmiast',
    importErrorTitle: 'Wystąpił błąd podczas importu',
    importFile: 'Importuj plik',
    importType: 'Typ importu',
    inquiries: 'Zapytania ofertowe',
    inquiry: 'Zapytanie',
    invoiceCannotSent: 'Nie można wysłać',
    invoiceDate: 'Data faktury',
    invoiceIsSent: 'Wysłano',
    invoiceIsSentQuestion: 'Faktura wysłana?',
    invoiceNotSent: 'Nie wysłano',
    invoiceNumber: 'Numer faktury',
    isSettled: 'Rozliczone?',
    lack: 'Brak',
    language: 'Język',
    lastContactAt: 'Ostatni kontakt',
    loadError: 'WYSTAPIŁ BŁAD WCZYTYWANIA',
    maximum: 'Maksymalnie',
    minimum: 'Minimalnie',
    monthNames: {
      apr: 'Kwi',
      aug: 'Sie',
      dec: 'Gru',
      feb: 'Lut',
      jan: 'Sty',
      jul: 'Lip',
      jun: 'Cze',
      mar: 'Mar',
      may: 'Maj',
      nov: 'Lis',
      oct: 'Paź',
      sep: 'Wrz'
    },
    move: 'Przenieś',
    name: 'Nazwa',
    nameAndSurename: 'Imię i nazwisko',
    no: 'Nie',
    noAvailabilityData: 'Brak danych o dostępności',
    noAvailableValues: 'Brak dostępnych wartości',
    noInfoToDisplay: 'Brak informacji do wyświetlenia',
    noOptionsAvailable: 'Brak dostepnych opcji',
    noResults: 'Brak wyników',
    notSettled: 'Nierozliczone',
    offer: 'Oferta',
    ok: 'OK',
    order: 'Zamówienie',
    orderName: 'Nazwa zamówienia',
    orderNameNotes: 'Dodatkowa notatka',
    pagination: {
      itemsAmount: 'Ilość pozycji:'
    },
    pdf: 'PDF',
    perUnit: 'za szt.',
    phoneShort: 'tel.',
    pieces: 'Sztuk',
    piecesAbbr: 'szt.',
    piecesAmount: 'Ilość sztuk',
    productsGenitive: 'Produktów',
    purchaseInvoiceEmail: 'E-mail do wysyłki prośby',
    range: 'Przedział',
    refreshPage: 'Odśwież stronę',
    repeatPassword: 'Powtórz hasło',
    resetFilters: 'Resetuj filtry',
    save: 'Zapisz',
    saveChanges: 'Zapisz zmiany',
    saveChangesErrorText: 'Zapisanie zmian nie powiodło się. Spróbuj ponownie.',
    saved: 'Zapisano',
    saveErrorTitle: 'Wystąpił błąd podczas zapisu',
    saving: 'Zapisywanie',
    search: 'Szukaj',
    searchFrom: ' szukaj od ',
    searching: 'Trwa wyszukiwanie',
    searchTo: ' do ',
    selectAll: ' Zaznacz wszystkie',
    selectContactPerson: 'Wybierz osobę kontaktową',
    selectedPersonNotFound: 'Brak wybranej osoby',
    selectFile: 'Wybierz plik',
    selectSubSupplier: 'Wybierz wykonawcę 1',
    selectSupplier: 'Wybierz wykonawcę 2',
    sendPurchaseInvoiceEmail: 'Wysyłaj e-mail z prośbą o fakturę',
    settled: 'Rozliczone',
    shipper: 'Spedytor',
    shortDescription: 'Krótki opis',
    showAll: 'Pokazuj wszystkie',
    sorting: {
      asc: 'Rosnąco',
      availability: 'Dostępność',
      code: 'Kod produktu',
      desc: 'Malejąco',
      label: 'Sortuj według',
      price: 'Cena'
    },
    subSupplier: 'Wykonawca 1',
    supplier: 'Wykonawca 2',
    supplierAlt: 'Dostawca',
    supplierProductsReminderEmail: 'E-mail do wysyłania powiadomień o terminach dostawy',
    tags: 'Tagi',
    thisFieldIsRequired: 'To pole jest wymagane',
    title: 'Tytuł',
    to: 'do',
    toCap: 'Do',
    toTryAgain: 'aby spróbować ponownie.',
    tryAgain: 'Spróbuj ponownie',
    updatedAt: 'Data aktualizacji',
    value: 'Wartość',
    viewInNewTab: 'Zobacz w nowej zakładce',
    warning: 'Uwaga!',
    xls: 'XLS',
    xlsx: 'XLSX',
    yes: 'Tak',
    yesChange: 'Tak, zmień',
    yesRemove: 'Tak, usuń',
    yesUpdate: 'Tak, zaktualizuj'
  },
  users: {
    accountActive: 'Konto aktywne',
    accountInactive: 'Konto nieaktywne',
    accountType: 'Rodzaj konta',
    active: 'Aktywne',
    addExcludedCustomer: 'Dodaj wykluczonego klienta',
    addingNewUser: 'Dodawanie nowego użytkownika',
    addUser: 'Dodaj użytkownika',
    addUserErrorText: 'Dodawanie użytkownika nie powiodło się. Spróbuj ponownie.',
    addUserSuccessText: 'Podany użytkownik został zapisany',
    addUserSuccessTitle: 'Dodano użytkownika',
    admin: 'Administrator',
    any: 'Dowolny',
    assign: 'Przypisz',
    customer: 'Klient',
    customerNotSelectedErrorText: 'Musisz wybrać klienta powiązanego z tym kontem',
    customerTaxNumber: 'NIP/VAT ID',
    customerTaxNumberFromRegister: 'NIP/VAT ID podany przy rejestracji',
    deleteConfirmTitle: 'Czy na pewno chcesz usunąć tego użytkownika?',
    deleteErrorText: 'Usuwanie użytkownika nie powiodło się. Spróbuj ponownie.',
    deleteSuccessText: 'Wybrany użytkownik został usunięty',
    deleteSuccessTitle: 'Usunięto użytkownika',
    editUser: 'Edycja użytkownika',
    editUserErrorText: 'Edycja użytkownika nie powiodła się. Spróbuj ponownie.',
    editUserSuccessText: 'Wybrany użytkownik został zmieniony',
    editUserSuccessTitle: 'Zmodyfikowano użytkownika',
    excludedCustomers: 'Wykluczeni klienci',
    excludedCustomersList: 'Lista wykluczonych klientów',
    inactive: 'Nieaktywne',
    isAccountActive: 'Konto aktywne?',
    loggedInAs: 'Zalogowany jako',
    noExcludedCustomers: 'Brak wykluczonych klientów',
    noUsersMatchingPhrase: 'Brak pracowników pasujących do podanej frazy',
    noUsersToDisplay: 'Brak użytkowników do wyświetlenia',
    orderTags: 'Tagi dodawane przy tworzeniu nowego zamówienia',
    pinCode: 'PIN do logowania',
    realWarehouseman: 'Magazynier',
    selectWorker: 'Wybierz pracownika',
    sendSalesReport: 'Wysyłaj raport o sprzedaży',
    uiLanguage: 'Język interfejsu',
    uiLanguageEnglish: 'Angielski',
    uiLanguagePolish: 'Polski',
    user: 'Użytkownik',
    userName: 'Nazwa użytkownika',
    usersLabel: 'Użytkownicy',
    usersList: 'Lista użytkowników',
    usersSearchPlaceholder: 'Podaj imię, nazwisko lub e-mail użytkownika',
    warehouseman: 'Kierownik magazynu',
    worker: 'Pracownik',
    workerAssingErrorText: 'Operacja przypisania pracownika do zamówienia nie powiodła się',
    workerAssingErrorTitle: 'Nie udało się przypisać pracownika',
    workerAssingSuccessText: 'Pomyślnie zmieniono przypisanie pracownika do zamówienia',
    workerAssingSuccessTitle: 'Przypisano pracownika',
    youMustSelectCustomerDesc: 'Należy wybrać klienta do wykluczenia',
    youMustSelectCustomerTitle: 'Wybierz klienta do wykluczenia'
  },
  validation: {
    checkRequired: 'To pole musi być zaznaczone.',
    fieldCanContainAtLeast1Char: 'To pole musi zawierać co najmniej jeden znak',
    fieldCanContainAtLeast24Chars: 'To pole musi zawierać co najmniej {min} znaki',
    fieldCanContainAtLeastNChars: 'To pole musi zawierać co najmniej {min} znaków',
    fieldCanContainAtMax1Char: 'To pole może zawierać maksymalnie jeden znak',
    fieldCanContainAtMax24Chars: 'To pole może zawierać maksymalnie {max} znaki',
    fieldCanContainAtMaxNChars: 'To pole może zawierać maksymalnie {max} znaków',
    onlyBigLetters: 'To pole może zawierać wyłącznie duże litery',
    onlyLettersAndDashes: 'To pole może zawierać wyłącznie litery i myślniki',
    onlyLettersAndNumbers: 'To pole może zawierać wyłącznie litery i cyfry',
    onlyNumbers: 'To pole musi zawierać liczbę',
    passwordsAreNotIdentical: 'Hasła nie są identyczne',
    postalCodePl: 'Wprowadź poprawny kod pocztowy w formacie XX-XXX',
    required: 'To pole jest wymagane',
    requiredDateRange: 'Podanie zakresu dat jest wymagane',
    validDoubleNumericRequired: 'Wymagana liczba w formacie 123.45',
    validEmailRequired: 'To pole musi zawierać poprawny adres e-mail',
    validUrlRequired: 'To pole musi zawierać poprawny adres URL',
    valueCannotBeGreaterThan: 'Wartość nie może być większa niż ',
    valueCannotBeLessThan: 'Wartość nie może być mniejsza niż ',
    valueMustContainOrderID: 'Nazwa zamówienia musi zawierać ID zamówienia: ',
    youMustSelectValue: 'Musisz wybrać wartość'
  },
  welcome: {
    baseballCaps: 'Czapki z daszkiem',
    capVizors: 'Daszki',
    choose: 'Wybierz',
    clear: 'Wyczyść',
    clientPanel: 'Panel klienta',
    companyName: 'Headwear',
    filter: 'Filtruj',
    filterAvailability: 'Filtruj dostępności',
    filterByNameOrCode: 'Filtruj po nazwie/kodzie',
    filterByPrice: 'Filtruj po cenie',
    hats: 'Kapelusze',
    noProductsInSearchCriteria: 'Brak produktów spełniających podane kryteria',
    addToList: 'Dodaj do listy',
    removeFromList: 'Usuń z listy',
    productUnavailable: 'Produkt niedostępny',
    selectedProducts: 'Wybrane produkty',
    noSelectedProducts: 'Nie wybrano jeszcze żadnych produktów',
    addSelectedProducts: 'Dodaj wybrane',
    orderInfo: 'Wysyłaj zapytania o ofertę lub realizuj zamówienia <span class="text-primary font-weight-bold">w 5 prostych krokach</span>:',
    orderWithAdditionInfo: '<i class="material-icons text-danger">info</i> W wypadku zamówień ze zdobieniami Twoje zapytanie ofertowe zostanie przekazane do naszego działu handlowego. Przygotujemy ofertę, którą będziesz mógł zatwierdzić w tym panelu w zakładce <span class="font-weight-bold">"Zapytania ofertowe"</span>. Zapytania do zatwierdzenia będą mieć status <span class="font-weight-bold">"Do akceptacji"</span>.',
    orderWithNoAdditionInfo: '<i class="material-icons text-danger">info</i> Jeśli chcesz zamówić czapki bez dodatkowych zdobień: kliknij przycisk <span class="font-weight-bold">"Dodaj zamówienie"</span> - Twoje zamówienie od razu trafi do produkcji.',
    productBrowserInfo: 'Skorzystaj z naszej <span class="font-weight-bold">wyszukiwarki produktów</span>. Znajdziesz w niej zdjęcia produktów, cenę oraz stan magazynowy. Z poziomu wyszukiwarki możesz też zacząć tworzyć zapytanie ofertowe. Wystarczy kliknąć przy produkcie <span class="font-weight-bold">"Dodaj do oferty"</span> - zostaniesz przekierowany do formularza tworzenia oferty, a pierwszy produkt od razu pojawi się w zapytaniu.',
    requireAll: 'Wymagaj wszystkich',
    searchProducts: 'Szukaj produktu',
    setp: 'Krok',
    stepFiveContent: 'Kliknij przycisk <span class="font-weight-bold">"Wyślij zapytanie"</span> lub <span class="font-weight-bold">"Dodaj zamówienie"',
    stepFourContent: 'W zakładce <span class="font-weight-bold">"Dane ogólne"</span> wypełnij dane dostawy oraz kontaktowe',
    stepOneContent: 'Przejdź do zakładki <span class="font-weight-bold">"Zapytania ofertowe"</span>',
    stepThreeContent: 'W zakładce <span class="font-weight-bold">"Zapytanie"</span> wybierz produkty oraz zdobienia',
    stepTwoContent: 'Kliknij przycisk <span class="font-weight-bold">"Dodaj nowe zapytanie"</span>',
    wantToCheckOurProducts: 'Chcesz szybko sprawdzić nasze produkty i ceny?',
    welcomeToClientPanel: 'Witaj w panelu klienta HeadWear',
    winterHats: 'Czapki zimowe'
  }
};
